import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import Navbar from "../../Components/Navbar";
import { Colors } from "../../Constant/Color";
import Checkbox from "../../Components/checkbox";
import DatePickers from "../../Components/DatePicker";
import BasicSelect from "../../Components/Dropdown";
import { useEffect, useMemo, useRef, useState } from "react";
import CustomButton from "../../Components/Button";
import { Checkbox as CustomCheckBox, message } from "antd";
import {
  updateAllDayInvoices,
  updateAllEmployees,
  updateCustomers,
  updateDayCreditPayment,
  updateDayExpenses,
  updateDayRefund,
  updateProducts,
  updateShiftCreditPayment,
} from "../../Redux/LoginReduces";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Base_Uri } from "../../Constant/BaseUri";
import { RingLoader } from "react-spinners";
import {
  Document,
  Page,
  Text,
  View,
  PDFViewer,
  PDFDownloadLink,
  Font,
  pdf,
} from "@react-pdf/renderer";
//import MyFontRegular from "/fonts/Poppins-Medium.ttf";
//import MyFontBold from "/fonts/Poppins-Medium.ttf";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import React from "react";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ProductTableModal from "../../Components/productTableModal";

function Reports() {
  Font.register({
          family: 'MyFont',
          fonts: [
              { src: "/fonts/Poppins-Bold.ttf", fontWeight: 'bold' },
              { src: "/fonts/Poppins-Medium.ttf", fontWeight: 'normal' },
          ]
      });

  const dispatch = useDispatch();

  const userData = useSelector((state) => state.loginReducer.updatedState);

  const vat = useSelector((state) => state?.loginReducer?.vat);
  const customers = useSelector((state) => state.loginReducer.customers);
  const products = useSelector((state) => state.loginReducer.products);
  const deparments = useSelector(
    (state) => state.loginReducer.productDepartments
  );

  const expenses = useSelector((state) => state.loginReducer.dayExpenses);
  const employeeRefundData = useSelector(
    (state) => state.loginReducer.dayRefunds
  );
  const employeeCreditPayment = useSelector(
    (state) => state.loginReducer.dayCreditPayment
  );
  const dayAllInvoices = useSelector(
    (state) => state.loginReducer.allDayInvoices
  );
  const employeeShiftCreditPayment = useSelector(
    (state) => state?.loginReducer?.shiftCreditPayment
  );

  const [userExpenses, setUserExpenses] = useState(false);
  const [userRefunds, setUserRefunds] = useState(false);

  const [refundInvoices, setRefundInvoices] = React.useState([]);
  const [shiftInvoices, setShiftInvoices] = React.useState([]);

  const [creditPayment, setCreditPayment] = React.useState([]);
  const [isCategoryExist, setIsCategoryExist] = React.useState(true);
  const [isSubCategoryExist, setIsSubCategoryExist] = React.useState(true);

  const [loading, setLoading] = useState(false);
//console.log(employeeCreditPayment,"employeeCreditPayment")
  const [reportType, setReportType] = useState([
    "Daily Sales Report",
    "Sales Report by User",
    "Inventory Report",
    "Sales Report (Date Range)",
    "Net Sales Report (After Expenses)",
    "Sales Report By Department",
    "Product Sales Report for Selected Customer",
    "Product Sales & Profit Report for Selected Customer",
    "Customer-Specific Product Sales Report",
    "Top 1000 Best-Selling Products",
    "Product Sales Report (Selected Dates)",
    "Low Stock Level Report",
    "Department Summary Report",
    "Customer Balance Statement",
    "Customer Report by Department / Category / Subcategory"
  ]);
  const [reportTypeForSelecting, setReportTypeForSelecting] = useState([
    { id: "DayReport", value: "Daily Sales Report" },
    { id: "UserSaleReport", value: "Sales Report by User" },
    { id: "StockReport", value: "Inventory Report" },
    { id: "SaleReportBetweenDates", value: "Sales Report (Date Range)" },
    {
      id: "SaleReportBetweenDatesAfterExpense",
      value: "Net Sales Report (After Expenses)",
    },
    { id: "SaleReportByDepartment", value: "Sales Report By Department" },
    {
      id: "ProductSaleReportForSelectedCustomer",
      value: "Product Sales Report for Selected Customer",
    },
    {
      id: "ProductSaleReportForSelectedCustomerWithProfit",
      value: "Product Sales & Profit Report for Selected Customer",
    },
    {
      id: "CustomerSpecificProductSaleReport",
      value: "Customer-Specific Product Sales Report",
    },
    { id: "BestSellerTop100", value: "Top 1000 Best-Selling Products" },
    {
      id: "ProductSaleReportForSelectedDates",
      value: "Product Sales Report (Selected Dates)",
    },
    { id: "MinimumStockLevel", value: "Low Stock Level Report" },
    { id: "ByDepartmentReport", value: "Department Summary Report" },
    { id: "CustomerDueReport", value: "Customer Balance Statement" },
    { id: "CustomerReportwithDeparmentand", value: "Customer Report with Deparment / Category / Sub Category" },
  ]);

  useEffect(() => {
    if (userData.role != "admin") {
      let ReportsArray =
        userData.role_access?.find((e) => e.name === "Reports")?.subcategory ||
        [];

      //console.log(ReportsArray, "lkppt");

      let filteredReports = reportTypeForSelecting
        .filter((e) => ReportsArray.some((j) => e.id == j.name && j.selected))
        .map((e) => e.value);
      setReportType(filteredReports);

      //console.log(filteredReports, "lktp");
    }
  }, [userData]);
  const generateExcel = (data) => {
    // Calculate totals
    const totalQty = data.reduce((sum, e) => sum + Number(e.qty), 0);
    const totalSellPrice = data.reduce(
      (sum, e) => sum + Number(e.total_sell_price),
      0
    );
    const totalCostPrice = data.reduce(
      (sum, e) => sum + Number(e.total_cost_price),
      0
    );
    const totalProfit = data.reduce((sum, e) => sum + Number(e.profit), 0);

    // Append total row
    data.push({
      sku: "TOTAL",
      buying_date: "",
      supplier_details: "",
      model: "",
      IMEI: "",
      qty: totalQty,
      total_cost_price: totalCostPrice.toFixed(2),
      buyer_details: "",
      sell_date: "",
      total_sell_price: totalSellPrice.toFixed(2),
      profit: totalProfit.toFixed(2),
    });

    // Create a new workbook and worksheet
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    // Write the Excel file and create a Blob
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Save the file
    saveAs(dataBlob, "Report.xlsx");
  };

  const customerInputRef = useRef(null);
  const [pdfDownloadView, setPdfDownloadView] = useState({
    stockReport: false,
    dayReport: false,
    saleReport: false,
    minimumStockLevel: false,
    userSaleReport: false,
    saleReportBetweenDates: false,
    saleReportBetweenDatesAfterExpenses: false,
    productSaleReportForSelectedCustomer: false,
    ProductSaleReportForSelectedCustomerWithProfit: false,
    customerSpecificProductSaleReport: false,
    productSaleReportForSelectedDates: false,
    bestSellerTop100: false,
    saleReportByDepartment: false,
    ByDepartmentReport: false,
    CustomerDueReport: false,
    CustomerReportwithDeparmentand:false
  });

  const [selectDeparment, setSelectDeparment] = useState("");

  const [selectedSearch, setSelectedSearch] = useState("customers");
  const [text, setText] = useState("");
  const [selectedReportType, setSelectedReportType] = useState("select");
  const [searchProducts, setSearchProducts] = useState([]);
  const [searchCustomers, setSearchCustomers] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [allDeparmentReportsData, setAllDeparmentReportsData] = useState([]);
  const [searchDate, setSearchDate] = useState({
    selected: false,
  });

  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");

  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("select");

  const [allProducts, setAllProducts] = useState([]);
  const [minimumStockProduct, setMinimumStockProduct] = useState([]);

  const [employeeInvoices, setEmployeeInvoices] = useState([]);
  const [userAllInvoices, setUserAllInvoices] = useState([]);

  const [allInvoices, setAllInvoices] = useState([]);
  const [allUngroupedInvoice, setAllUngroupedInvoice] = useState([]);

  const [customerInvoices, setCustomerInvoices] = useState([]);
  const [allDepartment, setAllDempartment] = useState([]);

  const [customerProductsSale, setCustomerProductsSale] = useState([]);

  const [productSaleData, setProductSaleData] = useState([]);
  const [CustomerDueData, setCustomerDueData] = useState([]);

  const getProducts = async () => {
    try {
      // setLoading(true);
      let data = sessionStorage.getItem("userData");
      let token = JSON.parse(data);

      if (!token) {
        console.error("No token found");
        return;
      }

      let allProducts = [];
      let page = 1;
      const limit = 1000;
      let hasMore = true;

      while (hasMore) {
        const response = await axios.get(
          `${Base_Uri}getProducts?page=${page}&limit=${limit}&pag=1`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const chunk = response?.data?.data;

        if (!chunk || chunk.length === 0) {
          hasMore = false;
        } else {
          const formattedChunk = chunk.map((product, index) => ({
            ...product,
            id: allProducts.length + index + 1,
            productName: product?.product_name,
            status: product.status === "active" ? "Active" : product.status,
          }));

          allProducts = [...allProducts, ...formattedChunk];
          page++;
        }
      }

      dispatch(updateProducts(allProducts));
    } catch (error) {
      console.error("Error fetching products:", error);
      // setLoading(false);
    }
  };

  const getCustomers = async () => {
    let token = await sessionStorage.getItem("userData");
    token = JSON.parse(token);

    axios
      .get(`${Base_Uri}getCustomers`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let { data } = res;

        if (data.status) {
          let customers = data.data;

          dispatch(
            updateCustomers(customers && customers.length > 0 ? customers : [])
          );
        }
      })
      .catch((error) => {
        //console.log(error, "error");
      });
  };

  const getAllEmployees = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .get(`${Base_Uri}getAllEmployees`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        let data = res.data;

        if (data?.status) {
          let employee = data?.data;

          setEmployees(employee);
        } else {
          message.info(data?.message);
        }
      })
      .catch((error) => {
        message.info(error.message);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      customerInputRef?.current?.focus();
    }, 3000);
  }, [customerInputRef?.current]);

  useEffect(() => {
    // getProducts();
    getCustomers();
    getAllEmployees();
  }, []);

  const handleSearch = async (text) => {
    setText(text);

    if (!text) {
      setSearchCustomers([]);
      setSearchProducts([]);
      return;
    }

    if (selectedSearch == "customers") {
      setSearchProducts([]);

      setSearchCustomers(
        customers &&
          customers.length > 0 &&
          customers.filter((e, i) => {
            if (
              e?.customerName?.toLowerCase().includes(text.toLowerCase()) ||
              e?.businessName?.toLowerCase().includes(text.toLowerCase()) ||
              e?.email?.toLowerCase().includes(text.toLowerCase()) ||
              e?.accountNo == text
            ) {
              return e;
            }
          })
      );
    }

    if (selectedSearch == "products") {
      setSearchCustomers([]);

      try {
        const useExtendedSearch = text.length > 3; // Only use barcode/sku if length > 3
        //console.log(useExtendedSearch, "useExtendedSearch");
        let dataToken = await sessionStorage.getItem("userData");
        dataToken = JSON.parse(dataToken);
        let token = dataToken;
        const response = await fetch(
          `${Base_Uri}getProducts?search=${encodeURIComponent(
            text
          )}&useExtendedSearch=${useExtendedSearch}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();

        if (data.status) {
          setSearchProducts(data.data);
        } else {
          setSearchProducts([]);
        }
      } catch (error) {
        console.error("Error searching products:", error);
      }
    }
  };

  const handleSelectCustomer = (customer) => {
    setSelectedCustomer(customer);
    setText("");
    setSearchCustomers([]);
  };

  const handleSelectProduct = (product) => {
    setSelectedProduct(product);
    setText("");
    setSearchProducts([]);
  };

  const checkCustomerBalances = async (selectedCustomer) => {
    if (!selectedCustomer) return;

    try {
      const id = selectedCustomer.id;
      const res = await axios.get(`${Base_Uri}getCustomerLedger/${id}`);
      const data = res.data;

      if (!data?.status) {
        message.info(data.message);
        return 0;
      }

      const myData = data?.data;
      const customerData = data?.customerData;

      if (!myData || myData.length === 0) {
        message.info("No Data Found");
        return 0;
      }

      let previousBalance = 0;

      const ledger = myData.map((entry) => {
        const refund =
          entry.refund &&
          entry?.paymentMethod?.[0]?.toLowerCase() === "onaccount"
            ? entry.refund
            : 0;

        const creditNote =
          entry.deductCredit &&
          entry?.paymentMethod?.[0]?.toLowerCase() === "credit note"
            ? entry.deductCredit
            : 0;

        const additionalPaid =
          entry.transactionType === "Paid on invoice" ||
          entry.transactionType === "Paid on quotation"
            ? Number(entry?.deductCredit || 0)
            : 0;

        const currentRunningBalance =
            previousBalance +
                Number(entry.transactionType == "Opening Balance"?(entry?.openingquotationBalance+entry?.openinginvoiceBalance)||0:(entry?.paymentMethod?.includes("cheque")||entry?.paymentMethod=="cheque")?entry.toPay:entry.toPay || 0) -
                Number(refund) -
                Number(creditNote) -
                (((entry.transactionType == "Paid on invoice" ||
                  entry.transactionType == "Paid on quotation") &&
                  Number(entry?.deductCredit || 0)) ||
                  0) -
                  (entry.transactionType=="cheque clearing"?Number(entry.deductCredit):0)-
                Number(entry?.additionalDiscount || 0);

        previousBalance = currentRunningBalance;

        return {
          ...entry,
          runningBalance: Number(currentRunningBalance).toFixed(2),
          customerDetails: customerData,
        };
      });

      return ledger[ledger.length - 1]?.runningBalance || 0;
    } catch (error) {
      message.info(error?.message || "Error fetching customer balance");
      return 0;
    }
  };

  function parseDate(dateStr) {
    //console.log(dateStr);
    let [day, month, year] = dateStr && dateStr?.split("/").map(Number);
    //console.log(new Date(year, month, day));
    // Adjust month to zero-based index for JS Date
    return new Date(year, month, day);
  }

  const [expensesData, setExpensesData] = useState([]);
  useEffect(() => {
    const func = async () => {
      try {
        let data = sessionStorage.getItem("userData");
        data = JSON.parse(data);
        let token = data;
        //console.log(userData);
        let allExp = await fetchPaginatedData(
          `${Base_Uri}getDateWiseExpense`,
          {
            startDate: startDate && parseDate(startDate),
            endDate: endDate && parseDate(endDate),
            // id: userData?.employeeId,
          },
          token
        );
        //console.log(allExp, "allExp");
        setExpensesData(allExp.data);
      } catch (error) {
        //console.log(error);
      }
      // axios
      //   .post(
      //     `${Base_Uri}getDateWiseExpense`,
      //     {
      //       startDate: startDate && parseDate(startDate),
      //       endDate: endDate && parseDate(endDate),
      //       // id: userData?.employeeId,
      //     },
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //         Authorization: `Bearer ${token}`,
      //       },
      //     }
      //   )
      //   .then((data) => {
      //     setExpensesData(data.data.data);
      //   })
      //   .catch((err) => {
      //     //console.log(err);
      //   });
    };
    if (startDate && endDate) {
      func();
    }
  }, [startDate, endDate]);
  const exportStockReportToExcel = (allProducts) => {
    const data = allProducts.map((item, index) => {
      const qty = Number(item?.qty || 0);
      const cost = (Number(item.cost_price || 0) * qty).toFixed(2);
      const trade = (Number(item.trade_price || 0) * qty).toFixed(2);
      const warehouse = (Number(item.warehouse_price || 0) * qty).toFixed(2);
      const retail = (Number(item.retail_price || 0) * qty).toFixed(2);
      const diamond = (Number(item.diamond || 0) * qty).toFixed(2);
      const average = (
        ((Number(item.trade_price) +
          Number(item.retail_price) +
          Number(item.warehouse_price) +
          Number(item.diamond)) /
          4) *
        qty
      ).toFixed(2);

      return {
        SNo: index + 1,
        Product: item.product_name,
        "Cost (£)": cost,
        "Trade (£)": trade,
        "Warehouse (£)": warehouse,
        "Retail (£)": retail,
        "Diamond (£)": diamond,
        "Average (£)": average,
        Quantity: qty,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Inventory Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(fileData, "Stock_Report.xlsx");
  };

  const StockReportHeader = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              {vat?.companyName}
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "normal",
                marginTop: "20px",
              }}
            >
              Inventory Report
            </Text>
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          <View style={{ flex: 0.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              S.no
            </Text>
          </View>

          <View style={{ flex: 4 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Product
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Cost
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Sell (A)
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Sell (B)
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Sell (C)
            </Text>
          </View>
          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Sell (D)
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Avg Sell
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Qty
            </Text>
          </View>
        </View>
      </View>
    );
  };
  const chunkArray = (array, size) =>
    Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
      array.slice(i * size, i * size + size)
    );

  const getTotals = (products) => {
    const totalByType = (key) =>
      products.reduce(
        (pre, curr) => pre + Number(curr.qty || 0) * Number(curr[key] || 0),
        0
      );

    const averagePriceTotal = products.reduce((pre, curr) => {
      const avg =
        (Number(curr.trade_price || 0) +
          Number(curr.retail_price || 0) +
          Number(curr.warehouse_price || 0) +
          Number(curr.diamond || 0)) /
        4;
      return pre + avg * (Number(curr.qty) || 0);
    }, 0);

    const totalQty = products.reduce(
      (pre, curr) => pre + (Number(curr.qty) || 0),
      0
    );

    return {
      cost_price: totalByType("cost_price").toFixed(2),
      trade_price: totalByType("trade_price").toFixed(2),
      warehouse_price: totalByType("warehouse_price").toFixed(2),
      retail_price: totalByType("retail_price").toFixed(2),
      average_price: averagePriceTotal.toFixed(2),
      qty: totalQty,
    };
  };
  const StockReportDocument = () => {
    const productChunks = useMemo(
      () => chunkArray(allProducts, 28),
      [allProducts]
    );
    const totals = useMemo(() => getTotals(allProducts), [allProducts]);

    return (
      <Document size="A4">
        {productChunks.map((chunk, chunkIndex) => (
          <Page key={chunkIndex} style={{ padding: "0px 10px" }}>
            <StockReportHeader />
            <View>
              {chunk.map((item, index) => {
                const qty = Number(item?.qty || 0);
                const cost = (Number(item.cost_price || 0) * qty).toFixed(2);
                const trade = (Number(item.trade_price || 0) * qty).toFixed(2);
                const warehouse = (
                  Number(item.warehouse_price || 0) * qty
                ).toFixed(2);
                const retail = (Number(item.retail_price || 0) * qty).toFixed(
                  2
                );
                const diamond = (Number(item.diamond || 0) * qty).toFixed(2);
                const average = (
                  ((Number(item.trade_price) +
                    Number(item.retail_price) +
                    Number(item.warehouse_price) +
                    Number(item.diamond)) /
                    4) *
                  qty
                ).toFixed(2);

                return (
                  <View
                    key={index}
                    style={{
                      flexDirection: "row",
                      borderBottomWidth: 1,
                      borderColor: "#000",
                      padding: "3px 10px",
                    }}
                  >
                    <View style={{ flex: 0.5 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        {index + 1 + chunkIndex * 28}
                      </Text>
                    </View>

                    <View style={{ flex: 4 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        {item.product_name}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        £{cost}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        £{trade}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        £{warehouse}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        £{retail}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        £{diamond}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        £{average}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        {qty}
                      </Text>
                    </View>
                  </View>
                );
              })}
            </View>

            {chunkIndex === productChunks.length - 1 && (
              <View
                style={{
                  flexDirection: "row",
                  borderColor: "#000",
                  padding: "5px 10px",
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderBottomWidth: 1,
                }}
              >
                <View style={{ flex: 4.5 }}>
                  <Text
                    style={{
                      fontFamily: "MyFont",
                      fontSize: 9,
                      fontWeight: "bold",
                    }}
                  >
                    Total
                  </Text>
                </View>

                {[
                  "cost_price",
                  "trade_price",
                  "warehouse_price",
                  "retail_price",
                ].map((key, i) => (
                  <View key={i} style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontFamily: "MyFont",
                        fontSize: 8,
                        fontWeight: "bold",
                      }}
                    >
                      £{totals[key]}
                    </Text>
                  </View>
                ))}

                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontFamily: "MyFont",
                      fontSize: 8,
                      fontWeight: "bold",
                    }}
                  >
                    £{totals.average_price}
                  </Text>
                </View>

                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontFamily: "MyFont",
                      fontSize: 8,
                      fontWeight: "bold",
                    }}
                  >
                    {totals.qty}
                  </Text>
                </View>
              </View>
            )}
          </Page>
        ))}
      </Document>
    );
  };

  const MinimumStockReportHeader = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              Minumum Stock Level
            </Text>
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          <View style={{ flex: 3.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              DESCRIPTION
            </Text>
          </View>

          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              DEPT
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              CATEGORY
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              COLOR
            </Text>
          </View>

          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              BARCODE
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              MAKE
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              MODEL
            </Text>
          </View>

          <View style={{ flex: 0.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Qty
            </Text>
          </View>

          <View style={{ flex: 0.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              ML
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const MinimumStockReportDocument = () => (
    <Document size="A4">
      {/* <Header /> */}

      <Page style={{ padding: "0px 10px" }}>
        <MinimumStockReportHeader />

        <View>
          {minimumStockProduct && minimumStockProduct?.length > 0
            ? minimumStockProduct?.map((item, index) => {
                return (
                  <View
                    key={index}
                    style={{
                      flexDirection: "row",
                      borderBottomWidth: 1,
                      borderColor: "#000",
                      padding: "3px 10px",
                    }}
                  >
                    <View style={{ flex: 3.5 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        {item.product_name}
                      </Text>
                    </View>

                    <View style={{ flex: 1.5 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        {item?.department}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        {item?.category}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        {item?.product_color}
                      </Text>
                    </View>

                    <View style={{ flex: 1.5 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        {item?.barcode}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        {item?.make}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                        {item?.model}
                      </Text>
                    </View>

                    <View style={{ flex: 0.5 }}>
                      <Text
                        style={{
                          fontFamily: "MyFont",
                          fontSize: 8,
                          color: Colors.red,
                        }}
                      >
                        {item?.qty || 0}
                      </Text>
                    </View>

                    <View style={{ flex: 0.5 }}>
                      <Text
                        style={{
                          fontFamily: "MyFont",
                          fontSize: 8,
                          color: Colors.red,
                        }}
                      >
                        {item?.reminder_qty || 0}
                      </Text>
                    </View>
                  </View>
                );
              })
            : ""}
        </View>
      </Page>
    </Document>
  );

  const UserSaleReportHeader = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              {vat?.companyName}
            </Text>
            <Text
              style={{
                color: "black",
                fontSize: "12px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              User report for {selectedEmployee}
            </Text>
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const UserSaleReportDocument = () => (
    <Document size="A4">
      {/* <Header /> */}

      <Page style={{ padding: "30px 10px" }} orientation="landscape">
        <UserSaleReportHeader />

        <View>
          <Text
            style={{
              fontSize: 12,
              fontWeight: "bold",
              color: "black",
              fontFamily: "MyFont",
              width: "100%",
              marginTop: "10px",
            }}
          >
            Invoice Details:
          </Text>

          {Object.entries(employeeInvoices).map(([key, value]) => {
            return (
              <View>
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    fontFamily: "MyFont",
                    color: "red",
                  }}
                >
                  {key}
                </Text>

                <View
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    borderBottomWidth: 1,
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Date
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Invoice Amount
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Paid
                    </Text>
                  </View>

                  <View style={{ flex: 2 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      MOP
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Cash
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      On Account
                    </Text>
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Card
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Online
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Cheque
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Invoice Type
                    </Text>
                  </View>
                </View>

                {value &&
                  value.length > 0 &&
                  value?.map((e, i) => {
                    return (
                      <View
                        style={{
                          width: "100%",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          borderBottomWidth: 1,
                        }}
                      >
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "bold",
                              fontFamily: "MyFont",
                            }}
                          >
                            {new Date(
                              e?.saleDate
                                ? e?.saleDate
                                : e?.saleReturnDate
                                ? e?.saleReturnDate
                                : e?.exchangeDate
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "2-digit",
                            })}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            {e?.saleReturnDate && "-"} £
                            {Number(e?.subtotal).toFixed(2)}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            £
                            {Number(e?.cash || 0) +
                              Number(e?.online || 0) +
                              Number(e?.card || 0)}
                          </Text>
                        </View>

                        <View style={{ flex: 2 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            {e?.paymentMethod &&
                            Array?.isArray(e?.paymentMethod)
                              ? e?.paymentMethod?.map((e) => e).join(",")
                              : e?.paymentMethod}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            {e?.paymentMethod &&
                            !Array?.isArray(e?.paymentMethod) &&
                            e?.paymentMethod?.toLowerCase() == "refund cash"
                              ? `£${-Number(e?.subtotal).toFixed(2)}`
                              : e?.paymentMethod &&
                                Array?.isArray(e?.paymentMethod) &&
                                e?.paymentMethod?.some(
                                  (j) => j?.toLowerCase() == "refund cash"
                                )
                              ? `£${Number(e?.subtotal).toFixed(2)}`
                              : `£${e?.cash || 0}`}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            {e?.paymentMethod &&
                            !Array?.isArray(e?.paymentMethod) &&
                            e?.paymentMethod?.toLowerCase() == "credit note"
                              ? `£${-Number(e?.subtotal).toFixed(2)}`
                              : e?.paymentMethod &&
                                Array?.isArray(e?.paymentMethod) &&
                                e?.paymentMethod?.some(
                                  (j) => j?.toLowerCase() == "credit note"
                                )
                              ? `£${Number(e?.subtotal).toFixed(2)}`
                              : `£${e?.credit || 0}`}
                          </Text>
                        </View>
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            {e?.paymentMethod &&
                            !Array?.isArray(e?.paymentMethod) &&
                            e?.paymentMethod?.toLowerCase() == "refund card"
                              ? `£${-Number(e?.subtotal).toFixed(2)}`
                              : e?.paymentMethod &&
                                Array?.isArray(e?.paymentMethod) &&
                                e?.paymentMethod?.some(
                                  (j) => j?.toLowerCase() == "refund card"
                                )
                              ? `£${Number(e?.subtotal).toFixed(2)}`
                              : `£${e?.card || 0}`}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            £{e?.online || 0}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            £{e?.cheque || 0}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            {e?.exchangeDate ? "Exchange" : e?.status}
                          </Text>
                        </View>
                      </View>
                    );
                  })}

                <View
                  style={{
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "space-between",
                    borderBottomWidth: 1,
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "normal",
                        fontFamily: "MyFont",
                      }}
                    >
                      Total
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            if (curr?.saleReturnDate) {
                              return (pre || 0) - Number(curr?.subtotal);
                            } else {
                              return (pre || 0) + Number(curr?.subtotal);
                            }
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            return (
                              (pre || 0) +
                              Number(
                                Number(curr?.cash || 0) +
                                  Number(curr?.online || 0) +
                                  Number(curr?.card || 0)
                              )
                            );
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 2 }}></View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            if (
                              curr?.paymentMethod &&
                              !Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "refund cash"
                            ) {
                              return (pre || 0) - Number(curr?.subtotal);
                            } else if (
                              curr?.paymentMethod &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (j) => j?.toLowerCase() == "refund cash"
                              )
                            ) {
                              return (pre || 0) + Number(curr?.subtotal);
                            } else {
                              return (pre || 0) + Number(curr?.cash || 0);
                            }
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            if (
                              curr?.paymentMethod &&
                              !Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "credit note"
                            ) {
                              return (pre || 0) - Number(curr?.subtotal);
                            } else if (
                              curr?.paymentMethod &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (j) => j?.toLowerCase() == "credit note"
                              )
                            ) {
                              return (pre || 0) + Number(curr?.subtotal);
                            } else {
                              return (pre || 0) + Number(curr?.credit || 0);
                            }
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            if (
                              curr?.paymentMethod &&
                              !Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "refund card"
                            ) {
                              return (pre || 0) - Number(curr?.subtotal);
                            } else if (
                              curr?.paymentMethod &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (j) => j?.toLowerCase() == "refund card"
                              )
                            ) {
                              return (pre || 0) + Number(curr?.subtotal);
                            } else {
                              return (pre || 0) + Number(curr?.card || 0);
                            }
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            return (pre || 0) + Number(curr?.online || 0);
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            return (pre || 0) + Number(curr?.cheque || 0);
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}></View>
                </View>
              </View>
            );
          })}
        </View>

        <View>
          <Text
            style={{
              fontSize: 12,
              fontWeight: "bold",
              color: "green",
              fontFamily: "MyFont",
              width: "100%",
              marginTop: "10px",
            }}
          >
            Refund Details:
          </Text>

          {Object.keys(refundInvoices).length > 0 &&
            Object.entries(refundInvoices).map(([key, value]) => {
              return (
                <View>
                  <Text
                    style={{
                      fontSize: 10,
                      fontWeight: "bold",
                      fontFamily: "MyFont",
                      color: "red",
                    }}
                  >
                    {key}
                  </Text>

                  <View
                    style={{
                      width: "100%",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      borderBottomWidth: 1,
                    }}
                  >
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Date
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Refund Amount
                      </Text>
                    </View>

                    <View style={{ flex: 2 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Payment Method
                      </Text>
                    </View>

                    <View style={{ flex: 2 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Transaction Type
                      </Text>
                    </View>

                    <View style={{ flex: 5 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Reason
                      </Text>
                    </View>
                  </View>

                  {value &&
                    value.length > 0 &&
                    value?.map((e, i) => {
                      return (
                        <View
                          style={{
                            width: "100%",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            borderBottomWidth: 1,
                          }}
                        >
                          <View style={{ flex: 1 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "bold",
                                fontFamily: "MyFont",
                              }}
                            >
                              {new Date(e?.date).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "2-digit",
                              })}
                            </Text>
                          </View>

                          <View style={{ flex: 1 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              £{Number(e?.refund).toFixed(2)}
                            </Text>
                          </View>

                          <View style={{ flex: 2 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              {e?.paymentMethod[0]}
                            </Text>
                          </View>

                          <View style={{ flex: 2 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              {e?.transactionType}
                            </Text>
                          </View>

                          <View style={{ flex: 5 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              {e?.reason}
                            </Text>
                          </View>
                        </View>
                      );
                    })}

                  <View
                    style={{
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "space-between",
                      borderBottomWidth: 1,
                    }}
                  >
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "normal",
                          fontFamily: "MyFont",
                        }}
                      >
                        Total
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        £
                        {Number(
                          value &&
                            value?.length > 0 &&
                            value?.reduce((pre, curr) => {
                              return (pre || 0) + Number(curr?.refund);
                            }, 0)
                        ).toFixed(2)}
                      </Text>
                    </View>

                    <View style={{ flex: 9 }}></View>
                  </View>
                </View>
              );
            })}
        </View>

        <View>
          <Text
            style={{
              fontSize: 12,
              fontWeight: "bold",
              color: "green",
              fontFamily: "MyFont",
              width: "100%",
              marginTop: "10px",
            }}
          >
            Credit Payment By Customer:
          </Text>

          {Object.keys(creditPayment).length > 0 &&
            Object.entries(creditPayment).map(([key, value]) => {
              return (
                <View>
                  <Text
                    style={{
                      fontSize: 10,
                      fontWeight: "bold",
                      fontFamily: "MyFont",
                      color: "red",
                    }}
                  >
                    {key}
                  </Text>

                  <View
                    style={{
                      width: "100%",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      borderBottomWidth: 1,
                    }}
                  >
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Date
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Total Amount
                      </Text>
                    </View>

                    <View style={{ flex: 2 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Payment Method
                      </Text>
                    </View>

                    <View style={{ flex: 2 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Transaction Type
                      </Text>
                    </View>

                    <View style={{ flex: 5 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Reason
                      </Text>
                    </View>
                  </View>

                  {value &&
                    value.length > 0 &&
                    value?.map((e, i) => {
                      return (
                        <View
                          style={{
                            width: "100%",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            borderBottomWidth: 1,
                          }}
                        >
                          <View style={{ flex: 1 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "bold",
                                fontFamily: "MyFont",
                              }}
                            >
                              {new Date(e?.date).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "2-digit",
                              })}
                            </Text>
                          </View>

                          <View style={{ flex: 1 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              £{Number(e?.deductCredit).toFixed(2)}
                            </Text>
                          </View>

                          <View style={{ flex: 2 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              {e?.paymentMethod[0]}
                            </Text>
                          </View>

                          <View style={{ flex: 2 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              {e?.transactionType}
                            </Text>
                          </View>

                          <View style={{ flex: 5 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              {e?.reason}
                            </Text>
                          </View>
                        </View>
                      );
                    })}

                  <View
                    style={{
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "space-between",
                      borderBottomWidth: 1,
                    }}
                  >
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "normal",
                          fontFamily: "MyFont",
                        }}
                      >
                        Total
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        £
                        {Number(
                          value &&
                            value?.length > 0 &&
                            value?.reduce((pre, curr) => {
                              return (pre || 0) + Number(curr?.deductCredit);
                            }, 0)
                        ).toFixed(2)}
                      </Text>
                    </View>

                    <View style={{ flex: 9 }}></View>
                  </View>
                </View>
              );
            })}
        </View>

        <View style={{ marginTop: "20px" }}>
          <Text
            style={{
              fontSize: 12,
              fontWeight: "bold",
              color: "green",
              fontFamily: "MyFont",
              width: "100%",
            }}
          >
            Expense Details:
          </Text>

          <View
            style={{
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              borderBottomWidth: 1,
            }}
          >
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 8,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                Date
              </Text>
            </View>

            <View style={{ flex: 9 }}>
              <Text
                style={{
                  fontSize: 8,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                description
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 8,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                Amount
              </Text>
            </View>
          </View>

          {userExpenses &&
            userExpenses.length > 0 &&
            userExpenses.map((e, i) => {
              return (
                <View
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    borderBottomWidth: 1,
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      {new Date(
                        e?.date ? e?.date : e?.created_at
                      ).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "2-digit",
                      })}
                    </Text>
                  </View>

                  <View style={{ flex: 9 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "normal",
                        fontFamily: "MyFont",
                      }}
                    >
                      {e?.description}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "normal",
                        fontFamily: "MyFont",
                      }}
                    >
                      £{e?.amount || 0}
                    </Text>
                  </View>
                </View>
              );
            })}

          <View
            style={{
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              borderBottomWidth: 1,
            }}
          >
            <View style={{ flex: 10 }}>
              <Text
                style={{
                  fontSize: 8,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                Total
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 8,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  userExpenses &&
                    userExpenses?.length > 0 &&
                    userExpenses?.reduce((pre, curr) => {
                      return (pre || 0) + Number(curr?.amount || 0);
                    }, 0)
                ).toFixed(2)}
              </Text>
            </View>
          </View>
        </View>

        <View style={{ marginTop: "20px" }}>
          <Text
            style={{
              fontSize: 10,
              fontWeight: "bold",
              fontFamily: "MyFont",
              borderBottomWidth: 1,
              width: "100%",
              color:"green"
            }}
          >
            Payment Summary:
          </Text>

          <View style={{ marginTop: "10px" }}>
            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Cash:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        return (pre || 0) + (curr?.cash || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Cash Returns:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          !Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.toLowerCase() == "refund cash"
                        ) {
                          return (pre || 0) - (curr?.subtotal || 0);
                        } else if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (j) => j?.toLowerCase() == "refund cash"
                          )
                        ) {
                          return (pre || 0) + (curr?.subtotal || 0);
                        } else {
                          return pre || 0;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Cash Refunds:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £(
                {Number(
                  userRefunds && userRefunds?.length > 0
                    ? userRefunds?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e) => e.toLowerCase() == "cash"
                          )
                        ) {
                          return (pre || 0) + (curr?.refund || 0);
                        } else {
                          return pre;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}
                ){" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Credit Payments:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  employeeShiftCreditPayment &&
                    employeeShiftCreditPayment?.length > 0
                    ? employeeShiftCreditPayment?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e) => e.toLowerCase() == "cash"
                          )
                        ) {
                          return (pre || 0) + (curr?.deductCredit || 0);
                        } else {
                          return pre;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Cash Expenses:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £(
                {Number(
                  userExpenses && userExpenses?.length > 0
                    ? userExpenses?.reduce((pre, curr) => {
                        return (pre || 0) + (Number(curr?.amount) || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}
                ){" "}
              </Text>
            </Text>

            <Text
              style={{
                color: "red",
                fontFamily: "MyFont",
                fontWeight: "bold",
                fontSize: 10,
                borderBottomWidth: 1,
                borderBottomColor: "black",
              }}
            >
              Total Remaining Cash: £
              {Number(
                Number(
                  shiftInvoices &&
                    shiftInvoices?.length > 0 &&
                    shiftInvoices?.reduce((pre, curr) => {
                      if (
                        curr?.saleReturnDate &&
                        curr?.paymentMethod?.toLowerCase() == "refund cash"
                      ) {
                        return (pre || 0) - curr?.subtotal;
                      } else if (
                        curr?.exchangeDate &&
                        Array?.isArray(curr?.paymentMethod) &&
                        curr?.paymentMethod?.some(
                          (e, i) => e?.toLowerCase() == "refund cash"
                        )
                      ) {
                        return (pre || 0) + curr?.subtotal;
                      } else {
                        return (pre || 0) + (curr?.cash || 0);
                      }
                    }, 0)
                ) +
                  Number(
                    employeeShiftCreditPayment &&
                      employeeShiftCreditPayment?.length > 0 &&
                      employeeShiftCreditPayment?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "cash"
                          )
                        ) {
                          return (pre || 0) + curr?.deductCredit;
                        } else {
                          return pre;
                        }
                      }, 0)
                  ) -
                  Number(
                    userRefunds &&
                      userRefunds?.length > 0 &&
                      userRefunds?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "cash"
                          )
                        ) {
                          return (pre || 0) + curr?.refund;
                        } else {
                          return pre;
                        }
                      }, 0)
                  ) -
                  Number(
                    userExpenses &&
                      userExpenses?.length > 0 &&
                      userExpenses?.reduce((pre, curr) => {
                        return (pre || 0) + Number(curr?.amount);
                      }, 0)
                  )
              ).toFixed(2)}
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              On Account:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        return (pre || 0) + (curr?.credit || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              On Account Returns:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          !Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.toLowerCase() == "credit note"
                        ) {
                          return (pre || 0) - (curr?.subtotal || 0);
                        } else if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (j) => j?.toLowerCase() == "credit note"
                          )
                        ) {
                          return (pre || 0) + (curr?.subtotal || 0);
                        } else {
                          return pre || 0;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              On Account Refunds :{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £(
                {Number(
                  userRefunds && userRefunds?.length > 0
                    ? userRefunds?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e) => e.toLowerCase() == "onaccount"
                          )
                        ) {
                          return (pre || 0) + (curr?.refund || 0);
                        } else {
                          return pre;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}
                ){" "}
              </Text>
            </Text>

            <Text
              style={{
                color: "red",
                fontFamily: "MyFont",
                fontWeight: "bold",
                fontSize: 10,
                borderBottomWidth: 1,
                borderBottomColor: "black",
              }}
            >
              Total On Accounts: £
              {Number(
                Number(
                  shiftInvoices &&
                    shiftInvoices?.length > 0 &&
                    shiftInvoices?.reduce((pre, curr) => {
                      if (
                        curr?.saleReturnDate &&
                        curr?.paymentMethod?.toLowerCase() == "credit note"
                      ) {
                        return (pre || 0) - curr?.subtotal;
                      } else if (
                        curr?.exchangeDate &&
                        Array?.isArray(curr?.paymentMethod) &&
                        curr?.paymentMethod?.some(
                          (e, i) => e?.toLowerCase() == "credit note"
                        )
                      ) {
                        return (pre || 0) + curr?.subtotal;
                      } else {
                        return (pre || 0) + (curr?.credit || 0);
                      }
                    }, 0)
                ) -
                  Number(
                    userRefunds &&
                      userRefunds?.length > 0 &&
                      userRefunds?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "onaccount"
                          )
                        ) {
                          return (pre || 0) + curr?.refund;
                        } else {
                          return pre;
                        }
                      }, 0)
                  )
              ).toFixed(2)}
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Card:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        return (pre || 0) + (curr?.card || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Card Returns:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          !Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.toLowerCase() == "refund card"
                        ) {
                          return (pre || 0) - (curr?.subtotal || 0);
                        } else if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (j) => j?.toLowerCase() == "refund card"
                          )
                        ) {
                          return (pre || 0) - (curr?.subtotal || 0);
                        } else {
                          return pre || 0;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Card Refunds :{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £(
                {Number(
                  userRefunds && userRefunds?.length > 0
                    ? userRefunds?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e) => e.toLowerCase() == "card"
                          )
                        ) {
                          return (pre || 0) + (curr?.refund || 0);
                        } else {
                          return pre;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}
                ){" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Credit Payments:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  employeeShiftCreditPayment &&
                    employeeShiftCreditPayment?.length > 0
                    ? employeeShiftCreditPayment?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e) => e.toLowerCase() == "card"
                          )
                        ) {
                          return (pre || 0) + (curr?.deductCredit || 0);
                        } else {
                          return pre;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{
                color: "red",
                fontFamily: "MyFont",
                fontWeight: "bold",
                fontSize: 10,
                borderBottomWidth: 1,
                borderBottomColor: "black",
              }}
            >
              Total Remaining Card: £
              {Number(
                Number(
                  shiftInvoices &&
                    shiftInvoices?.length > 0 &&
                    shiftInvoices?.reduce((pre, curr) => {
                      if (
                        curr?.saleReturnDate &&
                        curr?.paymentMethod?.toLowerCase() == "refund card"
                      ) {
                        return (pre || 0) - curr?.subtotal;
                      } else if (
                        curr?.exchangeDate &&
                        Array?.isArray(curr?.paymentMethod) &&
                        curr?.paymentMethod?.some(
                          (e, i) => e?.toLowerCase() == "refund card"
                        )
                      ) {
                        return (pre || 0) + curr?.subtotal;
                      } else {
                        return (pre || 0) + (curr?.card || 0);
                      }
                    }, 0)
                ) +
                  Number(
                    employeeShiftCreditPayment &&
                      employeeShiftCreditPayment?.length > 0 &&
                      employeeShiftCreditPayment?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "card"
                          )
                        ) {
                          return (pre || 0) + curr?.deductCredit;
                        } else {
                          return pre;
                        }
                      }, 0)
                  ) -
                  Number(
                    userRefunds &&
                      userRefunds?.length > 0 &&
                      userRefunds?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "card"
                          )
                        ) {
                          return (pre || 0) + curr?.refund;
                        } else {
                          return pre;
                        }
                      }, 0)
                  )
              ).toFixed(2)}
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Bank Transfer:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        return (pre || 0) + (curr?.online || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Credit Payments:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  Number(
                    employeeShiftCreditPayment &&
                      employeeShiftCreditPayment?.length > 0
                      ? employeeShiftCreditPayment?.reduce((pre, curr) => {
                          if (
                            curr?.paymentMethod &&
                            Array.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.some(
                              (e) => e.toLowerCase() == "bank transfer"
                            )
                          ) {
                            return (pre || 0) + (curr?.deductCredit || 0);
                          } else {
                            return pre;
                          }
                        }, 0)
                      : 0
                  )
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{
                color: "red",
                fontFamily: "MyFont",
                fontWeight: "bold",
                fontSize: 10,
                borderBottomWidth: 1,
                borderBottomColor: "black",
              }}
            >
              Total Bank Transfer: £
              {Number(
                Number(
                  shiftInvoices &&
                    shiftInvoices?.length > 0 &&
                    shiftInvoices?.reduce((pre, curr) => {
                      return (pre || 0) + (curr?.online || 0);
                    }, 0)
                ) +
                  Number(
                    employeeShiftCreditPayment &&
                      employeeShiftCreditPayment?.length > 0 &&
                      employeeShiftCreditPayment?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "bank transfer"
                          )
                        ) {
                          return (pre || 0) + curr?.deductCredit;
                        } else {
                          return pre;
                        }
                      }, 0)
                  )
              ).toFixed(2)}
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Cheques:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        return (pre || 0) + (curr?.cheque || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Credit Payments:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  Number(
                    employeeShiftCreditPayment &&
                      employeeShiftCreditPayment?.length > 0
                      ? employeeShiftCreditPayment?.reduce((pre, curr) => {
                          if (
                            curr?.paymentMethod &&
                            Array.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.some(
                              (e) => e.toLowerCase() == "cheque"
                            )
                          ) {
                            return (pre || 0) + (curr?.deductCredit || 0);
                          } else {
                            return pre;
                          }
                        }, 0)
                      : 0
                  )
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{
                color: "red",
                fontFamily: "MyFont",
                fontWeight: "bold",
                fontSize: 10,
              }}
            >
              Total Cheques: £
              {Number(
                Number(
                  shiftInvoices &&
                    shiftInvoices?.length > 0 &&
                    shiftInvoices?.reduce((pre, curr) => {
                      return (pre || 0) + (curr?.cheque || 0);
                    }, 0)
                ) +
                  Number(
                    employeeShiftCreditPayment &&
                      employeeShiftCreditPayment?.length > 0 &&
                      employeeShiftCreditPayment?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "cheque"
                          )
                        ) {
                          return (pre || 0) + curr?.deductCredit;
                        } else {
                          return pre;
                        }
                      }, 0)
                  )
              ).toFixed(2)}
            </Text>

            <View style={{ marginTop: "10px", borderTopWidth: 1 }}>
              <Text
                style={{ color: "black", fontFamily: "MyFont", fontSize: 10 }}
              >
                Total Sales: £
                {Number(
                  shiftInvoices &&
                    shiftInvoices.length > 0 &&
                    shiftInvoices.reduce((pre, curr) => {
                      if (curr?.saleDate) {
                        return (pre || 0) + Number(curr?.subtotal);
                      } else {
                        return pre;
                      }
                    }, 0)
                ).toFixed(2)}
              </Text>

              <Text
                style={{ color: "black", fontFamily: "MyFont", fontSize: 10 }}
              >
                Total Returns: £-
                {Number(
                  shiftInvoices &&
                    shiftInvoices.length > 0 &&
                    shiftInvoices.reduce((pre, curr) => {
                      if (curr?.saleReturnDate) {
                        return (pre || 0) + Number(curr?.subtotal);
                      } else {
                        return pre;
                      }
                    }, 0)
                ).toFixed(2)}
              </Text>

              <Text
                style={{ color: "black", fontFamily: "MyFont", fontSize: 10 }}
              >
                Total Exchange: £
                {Number(
                  shiftInvoices &&
                    shiftInvoices.length > 0 &&
                    shiftInvoices.reduce((pre, curr) => {
                      if (curr?.exchangeDate) {
                        return (pre || 0) + Number(curr?.subtotal);
                      } else {
                        return pre;
                      }
                    }, 0)
                ).toFixed(2)}
              </Text>

              <Text
                style={{
                  fontSize: 14,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                  color: "black",
                  borderTopWidth: 1,
                }}
              >
                Net Sales:{" "}
                <Text
                  style={{
                    fontSize: 16,
                    fontWeight: "normal",
                    fontFamily: "MyFont",
                    color: "red",
                  }}
                >
                  £
                  {Number(
                    shiftInvoices && shiftInvoices?.length > 0
                      ? shiftInvoices?.reduce((pre, curr) => {
                          if (
                            curr?.paymentMethod &&
                            !Array.isArray(curr?.paymentMethod) &&
                            (curr?.paymentMethod?.toLowerCase() ==
                              "refund cash" ||
                              curr?.paymentMethod?.toLowerCase() ==
                                "credit note" ||
                              curr?.paymentMethod?.toLowerCase() ==
                                "refund card")
                          ) {
                            return (pre || 0) - (curr?.subtotal || 0);
                          }

                          if (
                            curr?.paymentMethod &&
                            Array.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.some(
                              (e) =>
                                e?.toLowerCase() == "refund cash" ||
                                e?.toLowerCase() == "credit note" ||
                                e?.toLowerCase() == "refund card"
                            )
                          ) {
                            return (pre || 0) + (curr?.subtotal || 0);
                          } else {
                            return (pre || 0) + (curr?.subtotal || 0);
                          }
                        }, 0)
                      : 0
                  ).toFixed(2)}{" "}
                </Text>
              </Text>

              <Text
                style={{
                  fontSize: 14,
                  color: "black",
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                Gross Collection:{" "}
                <Text
                  style={{
                    color: "red",
                    fontFamily: "MyFont",
                    fontWeight: "bold",
                    fontSize: 16,
                  }}
                >
                  £
                  {Number(
                    Number(
                      shiftInvoices &&
                        shiftInvoices?.length > 0 &&
                        shiftInvoices?.reduce((pre, curr) => {
                          if (
                            curr?.saleReturnDate &&
                            curr?.paymentMethod?.toLowerCase() == "refund cash"
                          ) {
                            return (pre || 0) - curr?.subtotal;
                          } else if (
                            curr?.exchangeDate &&
                            Array?.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.some(
                              (e, i) => e?.toLowerCase() == "refund cash"
                            )
                          ) {
                            return (pre || 0) + curr?.subtotal;
                          } else {
                            return (pre || 0) + (curr?.cash || 0);
                          }
                        }, 0)
                    ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            if (
                              curr?.saleReturnDate &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "refund card"
                            ) {
                              return (pre || 0) - curr?.subtotal;
                            } else if (
                              curr?.exchangeDate &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (e, i) => e?.toLowerCase() == "refund card"
                              )
                            ) {
                              return (pre || 0) + curr?.subtotal;
                            } else {
                              return (pre || 0) + (curr?.card || 0);
                            }
                          }, 0)
                      ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            return (pre || 0) + (curr?.online || 0);
                          }, 0)
                      ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            if (
                              curr?.saleReturnDate &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "credit note"
                            ) {
                              return (pre || 0) - curr?.subtotal;
                            } else if (
                              curr?.exchangeDate &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (e, i) => e?.toLowerCase() == "credit note"
                              )
                            ) {
                              return (pre || 0) + curr?.subtotal;
                            } else {
                              return (pre || 0) + (curr?.credit || 0);
                            }
                          }, 0)
                      ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            return (pre || 0) + (curr?.cheque || 0);
                          }, 0)
                      )
                  ).toFixed(2)}
                </Text>
              </Text>

              <Text
                style={{
                  fontSize: 14,
                  color: "black",
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                  borderTopWidth: 1,
                  borderTopColor: "black",
                }}
              >
                Extra cash received on invoices:{" "}
                <Text
                  style={{
                    color: "red",
                    fontFamily: "MyFont",
                    fontWeight: "bold",
                    fontSize: 16,
                  }}
                >
                  £
                  {Number(
                    Number(
                      shiftInvoices &&
                        shiftInvoices?.length > 0 &&
                        shiftInvoices?.reduce((pre, curr) => {
                          if (
                            curr?.saleReturnDate &&
                            curr?.paymentMethod?.toLowerCase() == "refund cash"
                          ) {
                            return (pre || 0) - curr?.subtotal;
                          } else if (
                            curr?.exchangeDate &&
                            Array?.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.some(
                              (e, i) => e?.toLowerCase() == "refund cash"
                            )
                          ) {
                            return (pre || 0) + curr?.subtotal;
                          } else {
                            return (pre || 0) + (curr?.cash || 0);
                          }
                        }, 0)
                    ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            if (
                              curr?.saleReturnDate &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "refund card"
                            ) {
                              return (pre || 0) - curr?.subtotal;
                            } else if (
                              curr?.exchangeDate &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (e, i) => e?.toLowerCase() == "refund card"
                              )
                            ) {
                              return (pre || 0) + curr?.subtotal;
                            } else {
                              return (pre || 0) + (curr?.card || 0);
                            }
                          }, 0)
                      ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            return (pre || 0) + (curr?.online || 0);
                          }, 0)
                      ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            if (
                              curr?.saleReturnDate &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "credit note"
                            ) {
                              return (pre || 0) - curr?.subtotal;
                            } else if (
                              curr?.exchangeDate &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (e, i) => e?.toLowerCase() == "credit note"
                              )
                            ) {
                              return (pre || 0) + curr?.subtotal;
                            } else {
                              return (pre || 0) + (curr?.credit || 0);
                            }
                          }, 0)
                      ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            return (pre || 0) + (curr?.cheque || 0);
                          }, 0)
                      ) -
                      Number(
                        shiftInvoices &&
                          shiftInvoices.length > 0 &&
                          shiftInvoices.reduce((pre, curr) => {
                            if (curr?.saleReturnDate) {
                              return (pre || 0) - Number(curr?.subtotal);
                            } else {
                              return (pre || 0) + Number(curr?.subtotal);
                            }
                          }, 0)
                      )
                  ).toFixed(2)}
                </Text>
              </Text>

              <Text></Text>
            </View>
          </View>
        </View>
            <Text
        style={{ position: "absolute",
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 10,
    color: "black",}}
        render={({ pageNumber, totalPages }) =>
          `Page ${pageNumber} of ${totalPages}`
        }
        fixed
      />
      </Page>
    </Document>
  );

  const SaleReportBetweenDatesHeader = () => {
    //console.log(moment(parseDate(startDate)).format("DD/MM/YYYY"), "k");
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              {vat?.companyName} (Sales Report)
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "10px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              {vat?.companyName} (Sales Report)
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "10px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              From Date: {moment(parseDate(startDate)).format("DD/MM/YYYY")} to
              Date: {moment(parseDate(endDate)).format("DD/MM/YYYY")}
            </Text>
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Date
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Cash
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              on Account
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Online
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Card
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Cheque
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Total
            </Text>
          </View>
        </View>
      </View>
    );
  };
  const SaleReportBetweenDatesAfterExpensesHeader = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              {vat?.companyName} (Sales Report After Expenses)
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "10px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              {vat?.companyName} (Sales Report After Expenses)
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "10px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              From Date: {moment(parseDate(startDate)).format("DD/MM/YYYY")} to
              Date: {moment(parseDate(endDate)).format("DD/MM/YYYY")}
            </Text>
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Date
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Cash
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              on Account
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Online
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Card
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Cheque
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Total
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const SaleReportBetweenDatesDocument = () => (
    <Document size="A4">
      {/* <Header /> */}

      <Page style={{ padding: "0px 10px" }}>
        <SaleReportBetweenDatesHeader />

        <View>
          {Object.entries(allInvoices).map(([key, value]) => {
            return (
              <View style={{ marginTop: "10px" }}>
                <View
                  style={{
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "space-between",
                    borderBottomWidth: 1,
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "normal",
                        fontFamily: "MyFont",
                      }}
                    >
                      {new Date(key)?.toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            if (
                              curr?.paymentMethod &&
                              !Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "refund cash"
                            ) {
                              return (pre || 0) - Number(curr?.subtotal);
                            } else if (
                              curr?.paymentMethod &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (j) => j && j?.toLowerCase() == "refund cash"
                              )
                            ) {
                              return (pre || 0) + Number(curr?.subtotal);
                            } else {
                              return (pre || 0) + Number(curr?.cash || 0);
                            }
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            if (
                              curr?.paymentMethod &&
                              !Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "credit note"
                            ) {
                              return (pre || 0) - Number(curr?.subtotal);
                            } else if (
                              curr?.paymentMethod &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (j) => j && j?.toLowerCase() == "credit note"
                              )
                            ) {
                              return (pre || 0) + Number(curr?.subtotal);
                            } else {
                              return (pre || 0) + Number(curr?.credit || 0);
                            }
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            return (pre || 0) + Number(curr?.card || 0);
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            return (pre || 0) + Number(curr?.online || 0);
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            return (pre || 0) + Number(curr?.cheque || 0);
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            if (
                              curr?.paymentMethod &&
                              !Array.isArray(curr?.paymentMethod) &&
                              (curr.paymentMethod?.toLowerCase() ==
                                "refund cash" ||
                                curr.paymentMethod?.toLowerCase() ==
                                  "credit note")
                            ) {
                              return (pre || 0) - Number(curr?.subtotal);
                            } else {
                              return (pre || 0) + Number(curr?.subtotal);
                            }
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>
                </View>
              </View>
            );
          })}
        </View>

        <View
          style={{ padding: "5px 0px", width: "100%", flexDirection: "row" }}
        >
          <View style={{ flex: 1 }}>
            <Text
              style={{
                fontSize: 10,
                fontWeight: "bold",
                fontFamily: "MyFont",
                width: "100%",
              }}
            >
              Total
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              £
              {Number(
                allUngroupedInvoice && allUngroupedInvoice?.length > 0
                  ? allUngroupedInvoice?.reduce((pre, curr) => {
                      if (
                        curr?.paymentMethod &&
                        !Array.isArray(curr?.paymentMethod) &&
                        curr?.paymentMethod?.toLowerCase() == "refund cash"
                      ) {
                        return (pre || 0) - (curr?.subtotal || 0);
                      } else if (
                        curr?.paymentMethod &&
                        Array.isArray(curr?.paymentMethod) &&
                        curr?.paymentMethod?.some(
                          (j) => j && j?.toLowerCase() == "refund cash"
                        )
                      ) {
                        return (pre || 0) + (curr?.subtotal || 0);
                      } else {
                        return (pre || 0) + (curr?.cash || 0);
                      }
                    }, 0)
                  : 0
              ).toFixed(2)}{" "}
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              £
              {Number(
                allUngroupedInvoice && allUngroupedInvoice?.length > 0
                  ? allUngroupedInvoice?.reduce((pre, curr) => {
                      if (
                        curr?.paymentMethod &&
                        !Array.isArray(curr?.paymentMethod) &&
                        curr?.paymentMethod?.toLowerCase() == "credit note"
                      ) {
                        return (pre || 0) - (curr?.subtotal || 0);
                      } else if (
                        curr?.paymentMethod &&
                        Array.isArray(curr?.paymentMethod) &&
                        curr?.paymentMethod?.some(
                          (j) => j && j?.toLowerCase() == "credit note"
                        )
                      ) {
                        return (pre || 0) + (curr?.subtotal || 0);
                      } else {
                        return (pre || 0) + (curr?.credit || 0);
                      }
                    }, 0)
                  : 0
              ).toFixed(2)}{" "}
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              £
              {Number(
                allUngroupedInvoice && allUngroupedInvoice?.length > 0
                  ? allUngroupedInvoice?.reduce((pre, curr) => {
                      return (pre || 0) + (curr?.card || 0);
                    }, 0)
                  : 0
              ).toFixed(2)}{" "}
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              £
              {Number(
                allUngroupedInvoice && allUngroupedInvoice?.length > 0
                  ? allUngroupedInvoice?.reduce((pre, curr) => {
                      return (pre || 0) + (curr?.online || 0);
                    }, 0)
                  : 0
              ).toFixed(2)}{" "}
            </Text>
          </View>
          <View style={{ flex: 1 }}>
            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              £
              {Number(
                allUngroupedInvoice && allUngroupedInvoice?.length > 0
                  ? allUngroupedInvoice?.reduce((pre, curr) => {
                      return (pre || 0) + (curr?.cheque || 0);
                    }, 0)
                  : 0
              ).toFixed(2)}{" "}
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              £
              {Number(
                allUngroupedInvoice && allUngroupedInvoice?.length > 0
                  ? allUngroupedInvoice?.reduce((pre, curr) => {
                      if (
                        curr?.paymentMethod &&
                        !Array.isArray(curr?.paymentMethod) &&
                        (curr?.paymentMethod?.toLowerCase() == "refund cash" ||
                          curr?.paymentMethod?.toLowerCase() == "credit note")
                      ) {
                        return (pre || 0) - (curr?.subtotal || 0);
                      }

                      if (
                        curr?.paymentMethod &&
                        Array.isArray(curr?.paymentMethod) &&
                        curr?.paymentMethod?.some(
                          (e) =>
                            e?.toLowerCase() == "refund cash" ||
                            e?.toLowerCase() == "credit note"
                        )
                      ) {
                        return (pre || 0) + (curr?.subtotal || 0);
                      } else {
                        return (pre || 0) + (curr?.subtotal || 0);
                      }
                    }, 0)
                  : 0
              ).toFixed(2)}{" "}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
  const SaleReportBetweenDatesAfterExpensesDocument = () => {
    //console.log(expensesData, "jkl");
    return (
      <Document size="A4">
        {/* <Header /> */}

        <Page style={{ padding: "0px 10px" }}>
          <SaleReportBetweenDatesAfterExpensesHeader />

          <View>
            {Object.entries(allInvoices).map(([key, value]) => {
              return (
                <View style={{ marginTop: "10px" }}>
                  <View
                    style={{
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "space-between",
                      borderBottomWidth: 1,
                    }}
                  >
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "normal",
                          fontFamily: "MyFont",
                        }}
                      >
                        {new Date(key)?.toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        £
                        {Number(
                          value &&
                            value?.length > 0 &&
                            value?.reduce((pre, curr) => {
                              if (
                                curr?.paymentMethod &&
                                !Array?.isArray(curr?.paymentMethod) &&
                                curr?.paymentMethod?.toLowerCase() ==
                                  "refund cash"
                              ) {
                                return (pre || 0) - Number(curr?.subtotal);
                              } else if (
                                curr?.paymentMethod &&
                                Array?.isArray(curr?.paymentMethod) &&
                                curr?.paymentMethod?.some(
                                  (j) => j && j?.toLowerCase() == "refund cash"
                                )
                              ) {
                                return (pre || 0) + Number(curr?.subtotal);
                              } else {
                                return (pre || 0) + Number(curr?.cash || 0);
                              }
                            }, 0)
                        ).toFixed(2)}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        £
                        {Number(
                          value &&
                            value?.length > 0 &&
                            value?.reduce((pre, curr) => {
                              if (
                                curr?.paymentMethod &&
                                !Array?.isArray(curr?.paymentMethod) &&
                                curr?.paymentMethod?.toLowerCase() ==
                                  "credit note"
                              ) {
                                return (pre || 0) - Number(curr?.subtotal);
                              } else if (
                                curr?.paymentMethod &&
                                Array?.isArray(curr?.paymentMethod) &&
                                curr?.paymentMethod?.some(
                                  (j) => j && j?.toLowerCase() == "credit note"
                                )
                              ) {
                                return (pre || 0) + Number(curr?.subtotal);
                              } else {
                                return (pre || 0) + Number(curr?.credit || 0);
                              }
                            }, 0)
                        ).toFixed(2)}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        £
                        {Number(
                          value &&
                            value?.length > 0 &&
                            value?.reduce((pre, curr) => {
                              return (pre || 0) + Number(curr?.card || 0);
                            }, 0)
                        ).toFixed(2)}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        £
                        {Number(
                          value &&
                            value?.length > 0 &&
                            value?.reduce((pre, curr) => {
                              return (pre || 0) + Number(curr?.online || 0);
                            }, 0)
                        ).toFixed(2)}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        £
                        {Number(
                          value &&
                            value?.length > 0 &&
                            value?.reduce((pre, curr) => {
                              return (pre || 0) + Number(curr?.cheque || 0);
                            }, 0)
                        ).toFixed(2)}
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        £
                        {Number(
                          value &&
                            value?.length > 0 &&
                            value?.reduce((pre, curr) => {
                              if (
                                curr?.paymentMethod &&
                                !Array.isArray(curr?.paymentMethod) &&
                                (curr.paymentMethod?.toLowerCase() ==
                                  "refund cash" ||
                                  curr.paymentMethod?.toLowerCase() ==
                                    "credit note")
                              ) {
                                return (pre || 0) - Number(curr?.subtotal);
                              } else {
                                return (pre || 0) + Number(curr?.subtotal);
                              }
                            }, 0)
                        ).toFixed(2)}
                      </Text>
                    </View>
                  </View>
                </View>
              );
            })}
          </View>

          <View
            style={{ padding: "5px 0px", width: "100%", flexDirection: "row" }}
          >
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                  width: "100%",
                }}
              >
                Sub Total
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  allUngroupedInvoice && allUngroupedInvoice?.length > 0
                    ? allUngroupedInvoice?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          !Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.toLowerCase() == "refund cash"
                        ) {
                          return (pre || 0) - (curr?.subtotal || 0);
                        } else if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (j) => j && j?.toLowerCase() == "refund cash"
                          )
                        ) {
                          return (pre || 0) + (curr?.subtotal || 0);
                        } else {
                          return (pre || 0) + (curr?.cash || 0);
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  allUngroupedInvoice && allUngroupedInvoice?.length > 0
                    ? allUngroupedInvoice?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          !Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.toLowerCase() == "credit note"
                        ) {
                          return (pre || 0) - (curr?.subtotal || 0);
                        } else if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (j) => j && j?.toLowerCase() == "credit note"
                          )
                        ) {
                          return (pre || 0) + (curr?.subtotal || 0);
                        } else {
                          return (pre || 0) + (curr?.credit || 0);
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  allUngroupedInvoice && allUngroupedInvoice?.length > 0
                    ? allUngroupedInvoice?.reduce((pre, curr) => {
                        return (pre || 0) + (curr?.card || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  allUngroupedInvoice && allUngroupedInvoice?.length > 0
                    ? allUngroupedInvoice?.reduce((pre, curr) => {
                        return (pre || 0) + (curr?.online || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </View>
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  allUngroupedInvoice && allUngroupedInvoice?.length > 0
                    ? allUngroupedInvoice?.reduce((pre, curr) => {
                        return (pre || 0) + (curr?.cheque || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  allUngroupedInvoice && allUngroupedInvoice?.length > 0
                    ? allUngroupedInvoice?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          !Array.isArray(curr?.paymentMethod) &&
                          (curr?.paymentMethod?.toLowerCase() ==
                            "refund cash" ||
                            curr?.paymentMethod?.toLowerCase() == "credit note")
                        ) {
                          return (pre || 0) - (curr?.subtotal || 0);
                        }

                        if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e) =>
                              e?.toLowerCase() == "refund cash" ||
                              e?.toLowerCase() == "credit note"
                          )
                        ) {
                          return (pre || 0) + (curr?.subtotal || 0);
                        } else {
                          return (pre || 0) + (curr?.subtotal || 0);
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </View>
          </View>

          {/* {expenses.length!=0&&<Text style={{
                fontSize: 20,
                fontWeight: "bold",
                fontFamily: "MyFont",
                width: "100%",
              }} >Expenses</Text>} */}
          {expensesData.length == 0 && (
            <Text
              style={{
                fontSize: 20,
                fontWeight: "bold",
                fontFamily: "MyFont",
                width: "100%",
              }}
            >
              No Expenses
            </Text>
          )}

          {expensesData.length != 0 && (
            <View
              style={{
                flexDirection: "row",
                borderBottomWidth: 1,
                borderColor: "#000",
                paddingBottom: 5,
                paddingTop: 5,
                border: "1px solid black",
                backgroundColor: "gray",
                alignItems: "center",
                padding: 10,
                marginTop: "20px",
              }}
            >
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,
                    fontWeight: "bold",
                  }}
                >
                  Date
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,
                    fontWeight: "bold",
                  }}
                >
                  Employee Name
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,
                    fontWeight: "bold",
                  }}
                >
                  Description
                </Text>
              </View>
              <View style={{ flex: 1 }}></View>
              <View style={{ flex: 1 }}></View>
              <View style={{ flex: 1 }}></View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 8,
                    fontWeight: "bold",
                  }}
                >
                  Amount
                </Text>
              </View>
            </View>
          )}
          {expensesData?.map((e) => {
            return (
              <View
                style={{
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  borderBottomWidth: 1,
                }}
              >
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      fontWeight: "normal",
                      fontFamily: "MyFont",
                    }}
                  >
                    {new Date(e.date)?.toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}
                  </Text>
                </View>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      fontWeight: "normal",
                      fontFamily: "MyFont",
                    }}
                  >
                    {e?.employeeName}
                  </Text>
                </View>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      fontWeight: "normal",
                      fontFamily: "MyFont",
                    }}
                  >
                    {e.description}
                  </Text>
                </View>
                <View style={{ flex: 1 }}></View>
                <View style={{ flex: 1 }}></View>
                <View style={{ flex: 1 }}></View>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 8,
                      fontWeight: "normal",
                      fontFamily: "MyFont",
                    }}
                  >
                    {e.amount}
                  </Text>
                </View>
              </View>
            );
          })}
          {
            <View
              style={{
                padding: "5px 0px",
                width: "100%",
                flexDirection: "row",
              }}
            >
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    fontFamily: "MyFont",
                    width: "100%",
                  }}
                >
                  Total
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    fontFamily: "MyFont",
                  }}
                >
                  £
                  {Number(
                    allUngroupedInvoice && allUngroupedInvoice?.length > 0
                      ? allUngroupedInvoice?.reduce((pre, curr) => {
                          if (
                            curr?.paymentMethod &&
                            !Array.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.toLowerCase() == "refund cash"
                          ) {
                            return (pre || 0) - (curr?.subtotal || 0);
                          } else if (
                            curr?.paymentMethod &&
                            Array.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.some(
                              (j) => j && j?.toLowerCase() == "refund cash"
                            )
                          ) {
                            return (pre || 0) + (curr?.subtotal || 0);
                          } else {
                            return (pre || 0) + (curr?.cash || 0);
                          }
                        }, 0)
                      : 0
                  )?.toFixed(2)}{" "}
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    fontFamily: "MyFont",
                  }}
                >
                  £
                  {Number(
                    allUngroupedInvoice && allUngroupedInvoice?.length > 0
                      ? allUngroupedInvoice?.reduce((pre, curr) => {
                          if (
                            curr?.paymentMethod &&
                            !Array.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.toLowerCase() == "credit note"
                          ) {
                            return (pre || 0) - (curr?.subtotal || 0);
                          } else if (
                            curr?.paymentMethod &&
                            Array.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.some(
                              (j) => j && j?.toLowerCase() == "credit note"
                            )
                          ) {
                            return (pre || 0) + (curr?.subtotal || 0);
                          } else {
                            return (pre || 0) + (curr?.credit || 0);
                          }
                        }, 0)
                      : 0
                  ).toFixed(2)}{" "}
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    fontFamily: "MyFont",
                  }}
                >
                  £
                  {Number(
                    allUngroupedInvoice && allUngroupedInvoice?.length > 0
                      ? allUngroupedInvoice?.reduce((pre, curr) => {
                          return (pre || 0) + (curr?.card || 0);
                        }, 0)
                      : 0
                  ).toFixed(2)}{" "}
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    fontFamily: "MyFont",
                  }}
                >
                  £
                  {Number(
                    allUngroupedInvoice && allUngroupedInvoice?.length > 0
                      ? allUngroupedInvoice?.reduce((pre, curr) => {
                          return (pre || 0) + (curr?.online || 0);
                        }, 0)
                      : 0
                  ).toFixed(2)}{" "}
                </Text>
              </View>
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    fontFamily: "MyFont",
                  }}
                >
                  £
                  {Number(
                    allUngroupedInvoice && allUngroupedInvoice?.length > 0
                      ? allUngroupedInvoice?.reduce((pre, curr) => {
                          return (pre || 0) + (curr?.cheque || 0);
                        }, 0)
                      : 0
                  ).toFixed(2)}{" "}
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    fontFamily: "MyFont",
                  }}
                >
                  £
                  {Number(
                    allUngroupedInvoice && allUngroupedInvoice?.length > 0
                      ? allUngroupedInvoice?.reduce((pre, curr) => {
                          if (
                            curr?.paymentMethod &&
                            !Array.isArray(curr?.paymentMethod) &&
                            (curr?.paymentMethod?.toLowerCase() ==
                              "refund cash" ||
                              curr?.paymentMethod?.toLowerCase() ==
                                "credit note")
                          ) {
                            return (pre || 0) - (curr?.subtotal || 0);
                          }

                          if (
                            curr?.paymentMethod &&
                            Array.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.some(
                              (e) =>
                                e?.toLowerCase() == "refund cash" ||
                                e?.toLowerCase() == "credit note"
                            )
                          ) {
                            return (pre || 0) + (curr?.subtotal || 0);
                          } else {
                            return (pre || 0) + (curr?.subtotal || 0);
                          }
                        }, 0) -
                          expensesData.reduce((totalExp, expOne) => {
                            return totalExp + Number(expOne.amount);
                          }, 0)
                      : 0
                  ).toFixed(2)}{" "}
                </Text>
              </View>
            </View>
          }
        </Page>
      </Document>
    );
  };

  const ProductSaleReportForSelectedCustomerHeader = () => {
    let selectedDateParts = endDate?.split("/");
    let dateFromParts = startDate?.split("/");

    // Create Date objects from the parsed components
    let selectedDateTime = new Date();

    let dateFromTime = new Date();
    if (startDate && endDate && searchDate?.selected) {
      selectedDateTime = new Date(
        parseInt(selectedDateParts[2]), // Year
        parseInt(selectedDateParts[1]), // Month (zero-based)
        parseInt(selectedDateParts[0]), // Day
        23, // Hours
        59, // Minutes
        59 // Seconds
      );
      dateFromTime = new Date(
        parseInt(dateFromParts[2]), // Year
        parseInt(dateFromParts[1]), // Month (zero-based)
        parseInt(dateFromParts[0]), // Day
        0, // Hours
        0, // Minutes
        0 // Seconds
      );
    }
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              {vat?.companyName}
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "10px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Product sale report by customer: Customer:{" "}
              {selectedCustomer?.businessName}
            </Text>

            {startDate && endDate && searchDate?.selected && (
              <Text
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontFamily: "MyFont",
                  fontWeight: "normal",
                }}
              >
                From Date:{" "}
                {new Date(dateFromTime).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}{" "}
                to Date:{" "}
                {new Date(selectedDateTime).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
              </Text>
            )}
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Account no: {selectedCustomer?.accountNo}
            </Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Trans ID
            </Text>
          </View>

          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Date
            </Text>
          </View>

          <View style={{ flex: 4 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Description
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Qty
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Unit Price
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Total
            </Text>
          </View>
        </View>
      </View>
    );
  };
  const ProductSaleReportForSelectedCustomerWithProfitHeader = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              {vat?.companyName}
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "10px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Product sale report by customer with profit: Customer:{" "}
              {selectedCustomer?.businessName}
            </Text>

            {startDate && endDate && searchDate?.selected && (
              <Text
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontFamily: "MyFont",
                  fontWeight: "normal",
                }}
              >
                From Date: {moment(parseDate(startDate)).format("DD/MM/YYYY")}{" "}
                to Date: {moment(parseDate(endDate)).format("DD/MM/YYYY")}
              </Text>
            )}
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Account no: {selectedCustomer?.accountNo}
            </Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          <View style={{ flex: 3 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Trans ID
            </Text>
          </View>

          {/* <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Date
            </Text>
          </View> */}

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Qty
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Profit
            </Text>
          </View>
          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Profit %
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Total
            </Text>
          </View>
        </View>
      </View>
    );
  };
  // const ProductSaleReportForSelectedCustomerWithProfitHeader = () => {
  //   //  let selectedDateParts = endDate?.split("/");
  //   // let dateFromParts = startDate?.split("/");

  //   // // Create Date objects from the parsed components
  //   // let selectedDateTime = new Date(
  //   //   parseInt(selectedDateParts[2]), // Year
  //   //   parseInt(selectedDateParts[1]), // Month (zero-based)
  //   //   parseInt(selectedDateParts[0]), // Day
  //   //   23, // Hours
  //   //   59, // Minutes
  //   //   59 // Seconds
  //   // );

  //   // let dateFromTime = new Date(
  //   //   parseInt(dateFromParts[2]), // Year
  //   //   parseInt(dateFromParts[1]), // Month (zero-based)
  //   //   parseInt(dateFromParts[0]), // Day
  //   //   0, // Hours
  //   //   0, // Minutes
  //   //   0 // Seconds
  //   // );
  //   return (
  //     <View fixed>
  //       <View
  //         style={{
  //           display: "flex",
  //           flexDirection: "row",
  //           justifyContent: "space-between",
  //           padding: 10,
  //           alignItems: "flex-start",
  //         }}
  //       >
  //         <View>
  //           <Text
  //             style={{
  //               color: "black",
  //               fontSize: "14px",
  //               fontFamily: "MyFont",
  //               fontWeight: "bold",
  //             }}
  //           >
  //             {vat?.companyName}
  //           </Text>

  //           <Text
  //             style={{
  //               color: "black",
  //               fontSize: "10px",
  //               fontFamily: "MyFont",
  //               fontWeight: "normal",
  //             }}
  //           >
  //             Product sale report by customer with profit: Customer:{" "}
  //             {selectedCustomer?.businessName}
  //           </Text>

  //           {startDate && endDate && searchDate?.selected && (
  //             <Text
  //               style={{
  //                 color: "black",
  //                 fontSize: "10px",
  //                 fontFamily: "MyFont",
  //                 fontWeight: "normal",
  //               }}
  //             >
  //                             From Date: {moment(parseDate(startDate)).format("DD/MM/YYYY")} to Date: {moment(parseDate(endDate)).format("DD/MM/YYYY")}

  //             </Text>
  //           )}
  //         </View>

  //         <View>
  //           <Text
  //             style={{
  //               color: "black",
  //               fontSize: "8px",
  //               fontFamily: "MyFont",
  //               fontWeight: "normal",
  //             }}
  //           >
  //             Print Date:{" "}
  //             {new Date().toLocaleDateString("en-GB", {
  //               day: "2-digit",
  //               month: "2-digit",
  //               year: "numeric",
  //             })}
  //             <Text style={{ marginLeft: "5px" }}>
  //               {" "}
  //               {new Date().toLocaleTimeString()}
  //             </Text>
  //           </Text>

  //           <Text
  //             style={{
  //               color: "black",
  //               fontSize: "8px",
  //               fontFamily: "MyFont",
  //               fontWeight: "normal",
  //             }}
  //           >
  //             Account no: {selectedCustomer?.accountNo}
  //           </Text>
  //         </View>
  //       </View>

  //       <View
  //         style={{
  //           flexDirection: "row",
  //           borderBottomWidth: 1,
  //           borderColor: "#000",
  //           paddingBottom: 5,
  //           paddingTop: 5,
  //           border: "1px solid black",
  //           backgroundColor: "gray",
  //           alignItems: "center",
  //           padding: 10,
  //           marginTop: "20px",
  //         }}
  //       >
  //         <View style={{ flex: 1.5 }}>
  //           <Text
  //             style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
  //           >
  //             Trans ID
  //           </Text>
  //         </View>

  //         {/* <View style={{ flex: 1.5 }}>
  //           <Text
  //             style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
  //           >
  //             Date
  //           </Text>
  //         </View> */}

  //         <View style={{ flex: 4 }}>
  //           <Text
  //             style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
  //           >
  //             Description
  //           </Text>
  //         </View>

  //         <View style={{ flex: 1 }}>
  //           <Text
  //             style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
  //           >
  //             Qty
  //           </Text>
  //         </View>

  //         <View style={{ flex: 1 }}>
  //           <Text
  //             style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
  //           >
  //             Profit
  //           </Text>
  //         </View>
  //         <View style={{ flex: 1 }}>
  //           <Text
  //             style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
  //           >
  //             Profit %
  //           </Text>
  //         </View>

  //         <View style={{ flex: 1 }}>
  //           <Text
  //             style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
  //           >
  //             Total
  //           </Text>
  //         </View>
  //       </View>
  //     </View>
  //   );
  // };
  const ProductCustomerDueReportCustomerHeader = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              {vat?.companyName}
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "10px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              Customer Balance Statement
            </Text>
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Customer Name
            </Text>
          </View>

          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Invoice Balance
            </Text>
          </View>

          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Quotation Balance
            </Text>
          </View>

          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Account Balance
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const ProductSaleReportSelectedCustomerDocument = () => {
    let allProducts =
      customerInvoices &&
      customerInvoices?.length > 0 &&
      customerInvoices
        ?.flatMap((e) => {
          // //console.log(e?.saleReturnDate,"saleReturnDate")
          let status = e?.saleReturnDate ? "Return" : "Sale";

          if (e.productDetails && e.productDetails.length > 0) {
            // Iterate through each productDetail and set productStatus
            e.productDetails.forEach((product) => {
              product.productStatus = status;
            });

            // Return productDetails array with productStatus set
            return e.productDetails;
          } else {
            // Return an empty array if productDetails is empty or null
            return [];
          }
        })
        .filter(Boolean);

    let returnProduct =
      customerInvoices &&
      customerInvoices?.length > 0 &&
      customerInvoices
        ?.flatMap((e) => {
          let status = "Return";

          if (e.returnProductDetails && e.returnProductDetails.length > 0) {
            // Iterate through each productDetail and set productStatus
            e.returnProductDetails.forEach((product) => {
              product.productStatus = status;
            });

            // Return returnProductDetails array with productStatus set
            return e.returnProductDetails;
          } else {
            // Return an empty array if returnProductDetails is empty or null
            return [];
          }
        })
        .filter(Boolean);

    allProducts = allProducts && allProducts?.length > 0 ? allProducts : [];
    returnProduct =
      returnProduct && returnProduct?.length > 0 ? returnProduct : [];

    let products = [...allProducts, ...returnProduct];
    // //console.log(customerInvoices,"customerInvoices")
    return (
      <Document size="A4">
        {/* <Header /> */}

        <Page style={{ padding: "0px 10px" }}>
          <ProductSaleReportForSelectedCustomerHeader />

          <View>
            {customerInvoices &&
              customerInvoices?.length > 0 &&
              customerInvoices?.map((e, i) => {
                return (
                  <View style={{ width: "100%" }}>
                    {e?.productDetails &&
                      e?.productDetails?.length > 0 &&
                      e?.productDetails?.map((j, k) => {
                        e.customerDetails =
                          e.customerDetails && e.customerDetails[0];
                        return (
                          <View
                            style={{
                              width: "100%",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <View style={{ flex: 1.5 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleDate
                                  ? `Invoice no ${e?.invoiceNumber}`
                                  : e?.saleReturnDate
                                  ? `return no ${e?.invoiceNumber}`
                                  : e?.invoiceNumber}
                              </Text>
                            </View>

                            <View style={{ flex: 1.5 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                )?.toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "2-digit",
                                })}{" "}
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                ).toLocaleTimeString()}
                              </Text>
                            </View>

                            <View style={{ flex: 4 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {j?.productName}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleReturnDate && "-"}{" "}
                                {j?.DamageQty ? j?.DamageQty : j?.saleQty}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleReturnDate && "-"} £
                                {j?.discountPrice
                                  ? Number(j?.discountPrice).toFixed(2)
                                  : e?.customerDetails?.priceLevel?.[0]?.id == 1
                                  ? Number(j?.trade_price).toFixed(2)
                                  : e?.customerDetails?.priceLevel?.[0]?.id == 2
                                  ? Number(j?.warehouse_price).toFixed(2)
                                  : Number(j?.retail_price).toFixed(2)}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleReturnDate && "-"}£
                                {Number(
                                  (j?.discountPrice
                                    ? Number(j?.discountPrice).toFixed(2)
                                    : e?.customerDetails?.priceLevel[0]?.id == 1
                                    ? Number(j?.trade_price).toFixed(2)
                                    : e?.customerDetails?.priceLevel[0]?.id == 2
                                    ? Number(j?.warehouse_price).toFixed(2)
                                    : Number(j?.retail_price).toFixed(2)) *
                                    (j?.DamageQty ? j?.DamageQty : j?.saleQty)
                                ).toFixed(2)}
                              </Text>
                            </View>
                          </View>
                        );
                      })}

                    {e?.returnProductDetails &&
                      e?.returnProductDetails?.length > 0 &&
                      e?.returnProductDetails?.map((j) => {
                        return (
                          <View
                            style={{
                              width: "100%",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <View style={{ flex: 1.5 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleDate
                                  ? `Invoice no ${e?.invoiceNumber}`
                                  : e?.saleReturnDate
                                  ? `return no ${e?.invoiceNumber}`
                                  : e?.invoiceNumber}
                              </Text>
                            </View>

                            <View style={{ flex: 1.5 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                )?.toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "2-digit",
                                })}{" "}
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                ).toLocaleTimeString()}
                              </Text>
                            </View>

                            <View style={{ flex: 4 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {j?.productName}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                -{j?.DamageQty ? j?.DamageQty : j?.saleQty}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                - £
                                {j?.discountPrice
                                  ? Number(j?.discountPrice).toFixed(2)
                                  : e?.customerDetails?.priceLevel[0]?.id == 1
                                  ? Number(j?.trade_price).toFixed(2)
                                  : e?.customerDetails?.priceLevel[0]?.id == 2
                                  ? Number(j?.warehouse_price).toFixed(2)
                                  : Number(j?.retail_price).toFixed(2)}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                - £
                                {Number(
                                  (j?.discountPrice
                                    ? Number(j?.discountPrice).toFixed(2)
                                    : e?.customerDetails?.priceLevel[0]?.id == 1
                                    ? Number(j?.trade_price).toFixed(2)
                                    : e?.customerDetails?.priceLevel[0]?.id == 2
                                    ? Number(j?.warehouse_price).toFixed(2)
                                    : Number(j?.retail_price).toFixed(2)) *
                                    (j?.DamageQty ? j?.DamageQty : j?.saleQty)
                                ).toFixed(2)}
                              </Text>
                            </View>
                          </View>
                        );
                      })}
                  </View>
                );
              })}
          </View>

          <View
            style={{
              padding: "5px 0px",
              width: "100%",
              flexDirection: "row",
              borderTopWidth: 1,
            }}
          >
            <View style={{ flex: 7 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                  width: "100%",
                }}
              >
                Total
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                {products &&
                  products?.length > 0 &&
                  products?.reduce((pre, curr) => {
                    if (curr?.productStatus?.toLowerCase() == "return") {
                      return (
                        (pre || 0) -
                        (curr?.DamageQty
                          ? Number(curr?.DamageQty)
                          : Number(curr?.saleQty))
                      );
                    } else {
                      return (
                        (pre || 0) +
                        (curr?.DamageQty
                          ? Number(curr?.DamageQty)
                          : Number(curr?.saleQty))
                      );
                    }
                  }, 0)}
              </Text>
            </View>

            <View style={{ flex: 1 }}></View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  customerInvoices &&
                    customerInvoices?.length > 0 &&
                    customerInvoices
                      ?.reduce((pre, curr) => {
                        if (curr?.saleReturnDate) {
                          return (
                            (pre || 0) -
                            (Number(curr?.total || 0) -
                              Number(curr?.discount || 0))
                          );
                        } else {
                          return (
                            (pre || 0) +
                            (Number(curr?.total || 0) -
                              Number(curr?.discount || 0))
                          );
                        }
                      }, 0)
                      .toFixed(2)
                ).toFixed(2)}
              </Text>
            </View>
          </View>
        </Page>
      </Document>
    );
  };
  const ProductSaleReportSelectedCustomerWithProfitDocument = () => {
    let allProducts =
      customerInvoices &&
      customerInvoices?.length > 0 &&
      customerInvoices
        ?.flatMap((e) => {
          let status = e?.saleReturnDate ? "Return" : "Sale";

          if (e.productDetails && e.productDetails.length > 0) {
            // Iterate through each productDetail and set productStatus
            e.productDetails.forEach((product) => {
              product.productStatus = status;
            });
            const qty = Number(e.productDetails.length);

            // Return productDetails array with productStatus set
            return {
              ...e.productDetails[0],
              customerDetails: e?.customerDetails[0],
              SDAmount: e?.SDAmount,
            };
          } else {
            // Return an empty array if productDetails is empty or null
            return [];
          }
        })
        .filter(Boolean);

    let returnProduct =
      customerInvoices &&
      customerInvoices?.length > 0 &&
      customerInvoices
        ?.flatMap((e) => {
          let status = "Return";

          if (e.returnProductDetails && e.returnProductDetails.length > 0) {
            // Iterate through each productDetail and set productStatus
            e.returnProductDetails.forEach((product) => {
              product.productStatus = status;
            });
            const qty = Number(e.returnProductDetails.length);
            // Return returnProductDetails array with productStatus set
            return {
              ...e.returnProductDetails[0],
              customerDetails: e?.customerDetails[0],
              SDAmount: e?.SDAmount,
            };
          } else {
            // Return an empty array if returnProductDetails is empty or null
            return [];
          }
        })
        .filter(Boolean);

    allProducts = allProducts && allProducts?.length > 0 ? allProducts : [];
    returnProduct =
      returnProduct && returnProduct?.length > 0 ? returnProduct : [];

    let products = [...allProducts, ...returnProduct];

    return (
      <Document size="A4">
        {/* <Header /> */}

        <Page style={{ padding: "0px 10px" }}>
          <ProductSaleReportForSelectedCustomerWithProfitHeader />

          <View>
            {customerInvoices &&
              customerInvoices?.length > 0 &&
              customerInvoices?.map((e, i) => {
                console.log(e, "pjk");
                return (
                  <View
                    style={{
                      width: "100%",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <View style={{ flex: 3 }}>
                      <Text
                        style={{
                          color: "black",
                          fontSize: "8px",
                          fontFamily: "MyFont",
                          fontWeight: "normal",
                        }}
                      >
                        {e?.saleDate
                          ? `Invoice no ${e?.invoiceNumber}`
                          : e?.saleReturnDate
                          ? `return no ${e?.invoiceNumber}`
                          : e?.invoiceNumber}
                      </Text>
                    </View>

                    {/* <View style={{ flex: 1.5 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                )?.toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "2-digit",
                                })}{" "}
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                ).toLocaleTimeString()}
                              </Text>
                            </View> */}

                    {/* <View style={{ flex: 4 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {j?.productName}
                              </Text>
                            </View> */}

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          color: "black",
                          fontSize: "8px",
                          fontFamily: "MyFont",
                          fontWeight: "normal",
                        }}
                      >
                        {e?.saleReturnDate && "-"} {e?.totalQty}
                      </Text>
                    </View>
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          color: "black",
                          fontSize: "8px",
                          fontFamily: "MyFont",
                          fontWeight: "normal",
                        }}
                      >
                        {e?.type?.toLowerCase() === "return" && "-"}
                        {/* {Math.abs(Math.abs(Number(e?.subtotal))-Math.abs(Number(e?.costPrice))-Math.abs(Number(e?.discount))).toFixed(2)} */}
                        {Math.abs(
                          Number(
                            Math.abs(e?.subtotal || 0) -
                              (e?.vatAmount || 0) -
                              ((e?.productDetails || []).reduce(
                                (j, i) => j + (i?.cost_price * i?.saleQty || 0),
                                0
                              ) -
                                // + (e?.type!="exchange"?(e?.returnProductDetails || []).reduce((e, i) => e + (i?.cost_price*i?.saleQty || 0), 0):0)
                                (e?.returnProductDetails || []).reduce(
                                  (e, i) =>
                                    e + (i?.cost_price * i?.saleQty || 0),
                                  0
                                ))
                          )
                        ).toFixed(2)}
                      </Text>
                    </View>
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          color: "black",
                          fontSize: "8px",
                          fontFamily: "MyFont",
                          fontWeight: "normal",
                        }}
                      >
                        {/* {e?.saleReturnDate && "-"}{" "}
                                {j?.DamageQty ? j?.DamageQty : j?.saleQty} */}
                        {e?.type?.toLowerCase() === "return" && "-"}
                        {(
                          (Math.abs(
                            Number(
                              Math.abs(e?.subtotal || 0) -
                                (e?.vatAmount || 0) -
                                ((e?.productDetails || []).reduce(
                                  (j, i) =>
                                    j + (i?.cost_price * i?.saleQty || 0),
                                  0
                                ) -
                                  // + (e?.type!="exchange"?(e?.returnProductDetails || []).reduce((e, i) => e + (i?.cost_price*i?.saleQty || 0), 0):0)
                                  (e?.returnProductDetails || []).reduce(
                                    (e, i) =>
                                      e + (i?.cost_price * i?.saleQty || 0),
                                    0
                                  ))
                            )
                          ) /
                            Math.abs(Number(e?.subtotal))) *
                          100
                        ).toFixed(2)}
                        %
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          color: "black",
                          fontSize: "8px",
                          fontFamily: "MyFont",
                          fontWeight: "normal",
                        }}
                      >
                        {e?.saleReturnDate && "-"}£
                        {Math.abs(Number(e?.subtotal)).toFixed(2)}
                      </Text>
                    </View>
                  </View>
                );
              })}
          </View>

          <View
            style={{
              padding: "5px 0px",
              width: "100%",
              flexDirection: "row",
              borderTopWidth: 1,
            }}
          >
            <View style={{ flex: 3 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                  width: "100%",
                }}
              >
                Total
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                {customerInvoices &&
                  customerInvoices?.length > 0 &&
                  customerInvoices?.reduce((pre, curr) => {
                    if (curr?.type?.toLowerCase() == "return") {
                      return (pre || 0) - curr?.totalQty;
                    } else {
                      return (pre || 0) + curr?.totalQty;
                    }
                  }, 0)}
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                {customerInvoices && customerInvoices.length > 0
                  ? customerInvoices
                      .reduce((total, curr) => {
                        const qty = curr?.totalQty;
                        //console.log(qty, "qtyT");
                        // Determine unit price based on priority
                        let unitPrice = 0;

                        unitPrice = Number(curr.subtotal);
                        const cost = Number(curr?.costPrice ?? 0);
                        const profitOrLoss = Math.abs(
                          Number(
                            Math.abs(curr?.subtotal || 0) -
                              (curr?.vatAmount || 0) -
                              ((curr?.productDetails || []).reduce(
                                (j, i) => j + (i?.cost_price * i?.saleQty || 0),
                                0
                              ) -
                                // + (curr?.type!="exchange"?(curr?.returnProductDetails || []).reduce((e, i) => e + (i?.cost_price*i?.saleQty || 0), 0):0)
                                (curr?.returnProductDetails || []).reduce(
                                  (e, i) =>
                                    e + (i?.cost_price * i?.saleQty || 0),
                                  0
                                ))
                          )
                        );

                        if (curr?.type?.toLowerCase() === "return") {
                          return total - profitOrLoss;
                        } else {
                          return total + profitOrLoss;
                        }
                      }, 0)
                      .toFixed(2)
                  : "0.00"}
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                {(
                  customerInvoices &&
                  customerInvoices.length > 0 &&
                  (customerInvoices.reduce((total, curr) => {
                    const profitOrLoss = Math.abs(
                      Number(
                        Math.abs(curr?.subtotal || 0) -
                          (curr?.vatAmount || 0) -
                          ((curr?.productDetails || []).reduce(
                            (j, i) => j + (i?.cost_price * i?.saleQty || 0),
                            0
                          ) -
                            // + (curr?.type!="exchange"?(curr?.returnProductDetails || []).reduce((e, i) => e + (i?.cost_price*i?.saleQty || 0), 0):0)
                            (curr?.returnProductDetails || []).reduce(
                              (e, i) => e + (i?.cost_price * i?.saleQty || 0),
                              0
                            ))
                      )
                    );

                    return curr?.type?.toLowerCase() === "return"
                      ? total - profitOrLoss
                      : total + profitOrLoss;
                  }, 0) /
                    Number(
                      customerInvoices &&
                        customerInvoices?.length > 0 &&
                        customerInvoices?.reduce((pre, curr) => {
                          if (curr?.saleReturnDate) {
                            return (
                              (pre || 0) - Math.abs(Number(curr?.subtotal || 0))
                            );
                          } else {
                            return (
                              (pre || 0) + Math.abs(Number(curr?.subtotal || 0))
                            );
                          }
                        }, 0)
                    )) *
                    100
                ).toFixed(2)}
                %
              </Text>
            </View>
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  customerInvoices &&
                    customerInvoices?.length > 0 &&
                    customerInvoices?.reduce((pre, curr) => {
                      if (curr?.saleReturnDate) {
                        return (
                          (pre || 0) - Math.abs(Number(curr?.subtotal || 0))
                        );
                      } else {
                        return (
                          (pre || 0) + Math.abs(Number(curr?.subtotal || 0))
                        );
                      }
                    }, 0)
                ).toFixed(2)}
              </Text>
            </View>
          </View>
        </Page>
      </Document>
    );
  };
  //   const ProductSaleReportSelectedCustomerWithProfitDocument = () => {
  //     let allProducts =
  //       customerInvoices &&
  //       customerInvoices?.length > 0 &&
  //       customerInvoices
  //         ?.flatMap((e) => {
  //           let status = e?.saleReturnDate ? "Return" : "Sale";

  //           if (e.productDetails && e.productDetails.length > 0) {
  //             // Iterate through each productDetail and set productStatus
  //             e.productDetails.forEach((product) => {
  //               product.productStatus = status;
  //             });
  //  const qty = Number(e.productDetails.length);

  //             // Return productDetails array with productStatus set
  //             return {...e.productDetails[0],customerDetails:e?.customerDetails[0],SDAmount:e?.SDAmount};
  //           } else {
  //             // Return an empty array if productDetails is empty or null
  //             return [];
  //           }
  //         })
  //         .filter(Boolean);

  //     let returnProduct =
  //       customerInvoices &&
  //       customerInvoices?.length > 0 &&
  //       customerInvoices
  //         ?.flatMap((e) => {
  //           let status = "Return";

  //           if (e.returnProductDetails && e.returnProductDetails.length > 0) {
  //             // Iterate through each productDetail and set productStatus
  //             e.returnProductDetails.forEach((product) => {
  //               product.productStatus = status;
  //             });
  //  const qty = Number(e.returnProductDetails.length);
  //             // Return returnProductDetails array with productStatus set
  //             return {...e.returnProductDetails[0],customerDetails:e?.customerDetails[0],SDAmount:e?.SDAmount};
  //           } else {
  //             // Return an empty array if returnProductDetails is empty or null
  //             return [];
  //           }
  //         })
  //         .filter(Boolean);

  //     allProducts = allProducts && allProducts?.length > 0 ? allProducts : [];
  //     returnProduct =
  //       returnProduct && returnProduct?.length > 0 ? returnProduct : [];

  //     let products = [...allProducts, ...returnProduct];

  //     return (
  //       <Document size="A4">
  //         {/* <Header /> */}

  //         <Page style={{ padding: "0px 10px" }}>
  //           <ProductSaleReportForSelectedCustomerWithProfitHeader />

  //           <View>
  //             {customerInvoices &&
  //               customerInvoices?.length > 0 &&
  //               customerInvoices?.map((e, i) => {
  //                 //console.log(e,"pjk")
  //                 return (
  //                   <View style={{ width: "100%" }}>
  //                     {e?.productDetails &&
  //                       e?.productDetails?.length > 0 &&
  //                       e?.productDetails?.map((j) => {
  //                           e.customerDetails =e.customerDetails&& e.customerDetails[0]
  //                         const profitFind = (Number(
  //                                   (j?.discountPrice
  //                                     ? Number(j?.discountPrice).toFixed(2)
  //                                     : e?.customerDetails?.priceLevel[0]?.id == 1
  //                                     ? Number(j?.trade_price).toFixed(2)
  //                                     : e?.customerDetails?.priceLevel[0]?.id == 2
  //                                     ? Number(j?.warehouse_price).toFixed(2)
  //                                      : e?.customerDetails?.priceLevel[0]?.id == 4
  //                                     ? Number(j?.diamond).toFixed(2)
  //                                     : Number(j?.retail_price).toFixed(2)) *
  //                                     (j?.DamageQty ? j?.DamageQty : j?.saleQty)
  //                                 )-Number(j?.cost_price*
  //                                     (j?.DamageQty ? j?.DamageQty : j?.saleQty))-e?.SDAmount).toFixed(2)
  //                         return (
  //                           <View
  //                             style={{
  //                               width: "100%",
  //                               flexDirection: "row",
  //                               alignItems: "center",
  //                               justifyContent: "space-between",
  //                             }}
  //                           >
  //                             <View style={{ flex: 3 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //                                 {e?.saleDate
  //                                   ? `Invoice no ${e?.invoiceNumber}`
  //                                   : e?.saleReturnDate
  //                                   ? `return no ${e?.invoiceNumber}`
  //                                   : e?.invoiceNumber}
  //                               </Text>
  //                             </View>

  //                             {/* <View style={{ flex: 1.5 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //                                 {new Date(
  //                                   e?.saleDate
  //                                     ? e?.saleDate
  //                                     : e?.saleReturnDate
  //                                     ? e?.saleReturnDate
  //                                     : e?.exchangeDate
  //                                 )?.toLocaleDateString("en-GB", {
  //                                   day: "2-digit",
  //                                   month: "2-digit",
  //                                   year: "2-digit",
  //                                 })}{" "}
  //                                 {new Date(
  //                                   e?.saleDate
  //                                     ? e?.saleDate
  //                                     : e?.saleReturnDate
  //                                     ? e?.saleReturnDate
  //                                     : e?.exchangeDate
  //                                 ).toLocaleTimeString()}
  //                               </Text>
  //                             </View> */}

  //                             {/* <View style={{ flex: 4 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //                                 {j?.productName}
  //                               </Text>
  //                             </View> */}

  //                             <View style={{ flex: 1 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //                                 {e?.saleReturnDate && "-"}{" "}
  //                                 {j?.DamageQty ? j?.DamageQty : j?.saleQty}
  //                               </Text>
  //                             </View>
  //                             <View style={{ flex: 1 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //  {j?.productStatus?.toLowerCase() === "return" && "-"}
  //                                {profitFind}
  //                               </Text>
  //                             </View>
  //                             <View style={{ flex: 1 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //                                 {/* {e?.saleReturnDate && "-"}{" "}
  //                                 {j?.DamageQty ? j?.DamageQty : j?.saleQty} */}
  //  {j?.productStatus?.toLowerCase() === "return" && "-"}
  //                                 {
  //                                   profitFind  &&( ((profitFind )
  // / Number(
  //                                   (j?.discountPrice
  //                                     ? Number(j?.discountPrice).toFixed(2)
  //                                     : e?.customerDetails?.priceLevel[0]?.id == 1
  //                                     ? Number(j?.trade_price).toFixed(2)
  //                                     : e?.customerDetails?.priceLevel[0]?.id == 2
  //                                     ? Number(j?.warehouse_price).toFixed(2)
  //                                      : e?.customerDetails?.priceLevel[0]?.id == 4
  //                                     ? Number(j?.diamond).toFixed(2)
  //                                     : Number(j?.retail_price).toFixed(2)) *
  //                                     (j?.DamageQty ? j?.DamageQty : j?.saleQty)
  //                                 )) * 100).toFixed(2)

  //                                 }
  //                                 %
  //                               </Text>
  //                             </View>

  //                             <View style={{ flex: 1 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //                                 {e?.saleReturnDate && "-"}£
  //                                 {Number(
  //                                   (j?.discountPrice
  //                                     ? Number(j?.discountPrice).toFixed(2)
  //                                     : e?.customerDetails?.priceLevel[0]?.id == 1
  //                                     ? Number(j?.trade_price).toFixed(2)
  //                                     : e?.customerDetails?.priceLevel[0]?.id == 2
  //                                     ? Number(j?.warehouse_price).toFixed(2)
  //                                      : e?.customerDetails?.priceLevel[0]?.id == 4
  //                                     ? Number(j?.diamond).toFixed(2)
  //                                     : Number(j?.retail_price).toFixed(2)) *
  //                                     (j?.DamageQty ? j?.DamageQty : j?.saleQty)-e?.SDAmount
  //                                 ).toFixed(2)}
  //                               </Text>
  //                             </View>
  //                           </View>
  //                         );
  //                       })}

  //                     {e?.returnProductDetails &&
  //                       e?.returnProductDetails?.length > 0 &&
  //                       e?.returnProductDetails?.map((j) => {
  //                         const profitFind = (Number(
  //                                   (j?.discountPrice
  //                                     ? Number(j?.discountPrice).toFixed(2)
  //                                     : e?.customerDetails?.priceLevel[0]?.id == 1
  //                                     ? Number(j?.trade_price).toFixed(2)
  //                                     : e?.customerDetails?.priceLevel[0]?.id == 2
  //                                     ? Number(j?.warehouse_price).toFixed(2)
  //                                      : e?.customerDetails?.priceLevel[0]?.id == 4
  //                                     ? Number(j?.diamond).toFixed(2)
  //                                     : Number(j?.retail_price).toFixed(2)) *
  //                                     (j?.DamageQty ? j?.DamageQty : j?.saleQty)
  //                                 )-Number(j?.cost_price*
  //                                     (j?.DamageQty ? j?.DamageQty : j?.saleQty))).toFixed(2)
  //                         return (
  //                           <View
  //                             style={{
  //                               width: "100%",
  //                               flexDirection: "row",
  //                               alignItems: "center",
  //                               justifyContent: "space-between",
  //                             }}
  //                           >
  //                             <View style={{ flex: 3 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //                                 {e?.saleDate
  //                                   ? `Invoice no ${e?.invoiceNumber}`
  //                                   : e?.saleReturnDate
  //                                   ? `return no ${e?.invoiceNumber}`
  //                                   : e?.invoiceNumber}
  //                               </Text>
  //                             </View>

  //                             {/* <View style={{ flex: 1.5 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //                                 {new Date(
  //                                   e?.saleDate
  //                                     ? e?.saleDate
  //                                     : e?.saleReturnDate
  //                                     ? e?.saleReturnDate
  //                                     : e?.exchangeDate
  //                                 )?.toLocaleDateString("en-GB", {
  //                                   day: "2-digit",
  //                                   month: "2-digit",
  //                                   year: "2-digit",
  //                                 })}{" "}
  //                                 {new Date(
  //                                   e?.saleDate
  //                                     ? e?.saleDate
  //                                     : e?.saleReturnDate
  //                                     ? e?.saleReturnDate
  //                                     : e?.exchangeDate
  //                                 ).toLocaleTimeString()}
  //                               </Text>
  //                             </View> */}

  //                             {/* <View style={{ flex: 4 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //                                 {j?.productName}
  //                               </Text>
  //                             </View> */}

  //                             <View style={{ flex: 1 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //                                 -{j?.DamageQty ? j?.DamageQty : j?.saleQty}
  //                               </Text>
  //                             </View>

  //                             {/* <View style={{ flex: 1 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //                                 - £
  //                                 {j?.discountPrice
  //                                   ? Number(j?.discountPrice).toFixed(2)
  //                                   : e?.customerDetails?.priceLevel[0]?.id == 1
  //                                   ? Number(j?.trade_price).toFixed(2)
  //                                   : e?.customerDetails?.priceLevel[0]?.id == 2
  //                                   ? Number(j?.warehouse_price).toFixed(2)
  //                                   : Number(j?.retail_price).toFixed(2)}
  //                               </Text>
  //                             </View> */}
  // <View style={{ flex: 1 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //  {j?.productStatus?.toLowerCase() === "return" && "-"}
  //                                {profitFind}
  //                               </Text>
  //                             </View>
  //                             <View style={{ flex: 1 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //                                 {/* {e?.saleReturnDate && "-"}{" "}
  //                                 {j?.DamageQty ? j?.DamageQty : j?.saleQty} */}

  //  {j?.productStatus?.toLowerCase() === "return" && "-"}
  //                                 {
  //                                   profitFind  &&( ((profitFind )
  // / Number(
  //                                   (j?.discountPrice
  //                                     ? Number(j?.discountPrice).toFixed(2)
  //                                     : e?.customerDetails?.priceLevel[0]?.id == 1
  //                                     ? Number(j?.trade_price).toFixed(2)
  //                                     : e?.customerDetails?.priceLevel[0]?.id == 2
  //                                     ? Number(j?.warehouse_price).toFixed(2)
  //                                      : e?.customerDetails?.priceLevel[0]?.id == 4
  //                                     ? Number(j?.diamond).toFixed(2)
  //                                     : Number(j?.retail_price).toFixed(2)) *
  //                                     (j?.DamageQty ? j?.DamageQty : j?.saleQty)
  //                                 )) * 100).toFixed(2)

  //                                 }
  //                                 %
  //                               </Text>
  //                             </View>
  //                             <View style={{ flex: 1 }}>
  //                               <Text
  //                                 style={{
  //                                   color: "black",
  //                                   fontSize: "8px",
  //                                   fontFamily: "MyFont",
  //                                   fontWeight: "normal",
  //                                 }}
  //                               >
  //                                 - £
  //                                 {Number(
  //                                   (j?.discountPrice
  //                                     ? Number(j?.discountPrice).toFixed(2)
  //                                     : e?.customerDetails?.priceLevel[0]?.id == 1
  //                                     ? Number(j?.trade_price).toFixed(2)
  //                                     : e?.customerDetails?.priceLevel[0]?.id == 2
  //                                     ? Number(j?.warehouse_price).toFixed(2)
  //                                      : e?.customerDetails?.priceLevel[0]?.id == 4
  //                                     ? Number(j?.diamond).toFixed(2)
  //                                     : Number(j?.retail_price).toFixed(2)) *
  //                                     (j?.DamageQty ? j?.DamageQty : j?.saleQty)
  //                                 ).toFixed(2)}
  //                               </Text>
  //                             </View>
  //                           </View>
  //                         );
  //                       })}
  //                   </View>
  //                 );
  //               })}
  //           </View>

  //           <View
  //             style={{
  //               padding: "5px 0px",
  //               width: "100%",
  //               flexDirection: "row",
  //               borderTopWidth: 1,
  //             }}
  //           >
  //             <View style={{ flex: 5.5 }}>
  //               <Text
  //                 style={{
  //                   fontSize: 10,
  //                   fontWeight: "bold",
  //                   fontFamily: "MyFont",
  //                   width: "100%",
  //                 }}
  //               >
  //                 Total
  //               </Text>
  //             </View>

  //             <View style={{ flex: 1 }}>
  //               <Text
  //                 style={{
  //                   fontSize: 10,
  //                   fontWeight: "bold",
  //                   fontFamily: "MyFont",
  //                 }}
  //               >
  //                 {products &&
  //                   products?.length > 0 &&
  //                   products?.reduce((pre, curr) => {
  //                     if (curr?.productStatus?.toLowerCase() == "return") {
  //                       return (
  //                         (pre || 0) -
  //                         (curr?.DamageQty
  //                           ? Number(curr?.DamageQty)
  //                           : Number(curr?.saleQty))
  //                       );
  //                     } else {
  //                       return (
  //                         (pre || 0) +
  //                         (curr?.DamageQty
  //                           ? Number(curr?.DamageQty)
  //                           : Number(curr?.saleQty))
  //                       );
  //                     }
  //                   }, 0)}
  //               </Text>
  //             </View>

  //            <View style={{ flex: 1 }}>
  //   <Text
  //     style={{
  //       fontSize: 10,
  //       fontWeight: "bold",
  //       fontFamily: "MyFont",
  //     }}
  //   >
  //     {products && products.length > 0
  //       ? products
  //           .reduce((total, curr) => {

  //             const qty = curr?.DamageQty ?? curr?.saleQty ?? 0;
  //             //console.log(qty,"qtyT")
  //             // Determine unit price based on priority
  //             let unitPrice = 0;

  //             if (curr?.discountPrice) {
  //               unitPrice = Number(curr.discountPrice);
  //             } else {
  //               const priceLevelId = curr?.customerDetails?.priceLevel?.[0]?.id;
  // //console.log(priceLevelId,"priceLevelId")
  // //console.log(curr,"curr")
  //               unitPrice = (priceLevelId === 1
  //                 ? Number(curr?.trade_price)
  //                 : priceLevelId === 2
  //                 ? Number(curr?.warehouse_price)
  //                 : priceLevelId === 4
  //                 ? Number(curr?.diamond)
  //                 : Number(curr?.retail_price));
  //             }
  //             //console.log(unitPrice,"unitPrice")
  //             const cost = Number(curr?.cost_price ?? 0);
  //             const profitOrLoss = (unitPrice - cost) * qty;

  //             if (curr?.productStatus?.toLowerCase() === "return") {
  //               return total - (profitOrLoss-curr?.SDAmount);
  //             } else {
  //               return total + (profitOrLoss-curr?.SDAmount);
  //             }
  //           }, 0)
  //           .toFixed(2)
  //       : "0.00"}
  //   </Text>
  // </View>

  //             <View style={{ flex: 1 }}>
  //               <Text
  //     style={{
  //       fontSize: 10,
  //       fontWeight: "bold",
  //       fontFamily: "MyFont",
  //     }}
  //   >
  //     {(products && products.length > 0 &&
  //       products.reduce((total, curr) => {
  //         const qty = curr?.DamageQty ?? curr?.saleQty ?? 0;

  //         // Determine sale price
  //         // //console.log(curr,"curr")
  //         let unitPrice = 0;
  //         if (curr?.discountPrice) {
  //           unitPrice = Number(curr.discountPrice);
  //         } else {
  //           const priceLevelId = curr?.customerDetails?.priceLevel?.[0]?.id;
  //           unitPrice =
  //             priceLevelId === 1
  //               ? Number(curr?.trade_price)
  //               : priceLevelId === 2
  //               ? Number(curr?.warehouse_price)
  //               : priceLevelId === 4
  //               ? Number(curr?.diamond)
  //               : Number(curr?.retail_price);
  //         }

  //         const cost = Number(curr?.cost_price ?? 0);
  //         const profitOrLoss = (unitPrice - cost) * qty;

  //         return curr?.productStatus?.toLowerCase() === "return"
  //           ? total - profitOrLoss
  //           : total + profitOrLoss;
  //       }, 0)/Number(
  //                   customerInvoices &&
  //                     customerInvoices?.length > 0 &&
  //                     customerInvoices?.reduce((pre, curr) => {
  //                       if (curr?.saleReturnDate) {
  //                         return (
  //                           (pre || 0) -
  //                           (Number(curr?.total || 0) -
  //                             Number(curr?.discount || 0))
  //                         );
  //                       } else {
  //                         return (
  //                           (pre || 0) +
  //                           (Number(curr?.total || 0) -
  //                             Number(curr?.discount || 0))
  //                         );
  //                       }
  //                     }, 0)
  //                 )*100).toFixed(2)}%
  //   </Text>
  //             </View>
  //             <View style={{ flex: 1 }}>
  //               <Text
  //                 style={{
  //                   fontSize: 10,
  //                   fontWeight: "bold",
  //                   fontFamily: "MyFont",
  //                 }}
  //               >
  //                 £
  //                 {Number(
  //                   customerInvoices &&
  //                     customerInvoices?.length > 0 &&
  //                     customerInvoices?.reduce((pre, curr) => {
  //                       if (curr?.saleReturnDate) {
  //                         return (
  //                           (pre || 0) -
  //                           (Number(curr?.total || 0) -
  //                             Number(curr?.discount || 0))
  //                         );
  //                       } else {
  //                         return (
  //                           (pre || 0) +
  //                           (Number(curr?.total || 0) -
  //                             Number(curr?.discount || 0))
  //                         );
  //                       }
  //                     }, 0)
  //                 ).toFixed(2)}
  //               </Text>
  //             </View>
  //           </View>
  //         </Page>
  //       </Document>
  //     );
  //   };
  const ProductCustomerDueReportDocument = () => {
    return (
      <Document size="A4">
        {/* <Header /> */}

        <Page style={{ padding: "0px 10px" }}>
          <ProductCustomerDueReportCustomerHeader />

          <View>
            {CustomerDueData.filter((e)=>Number(e.totalToPay)!=0).sort((a, b) =>
  a.businessName.localeCompare(b.businessName)
).map((data) => {
              return (
                <View
                  style={{
                    flexDirection: "row",
                    borderBottomWidth: 1,
                    borderColor: "#000",
                    paddingBottom: 5,
                    paddingTop: 5,
                    // border: "1px solid black",
                    // backgroundColor: "gray",
                    alignItems: "center",
                    padding: 10,
                    // marginTop: "20px",
                  }}
                >
                  <View style={{ flex: 1.5 }}>
                    <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                      {data?.businessName}
                    </Text>
                  </View>

                  <View style={{ flex: 1.5 }}>
                    <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                      {Number(data?.creditBalance).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1.5 }}>
                    <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                      {Number(data?.totalToPay - data?.creditBalance).toFixed(
                        2
                      )}
                    </Text>
                  </View>

                  <View style={{ flex: 1.5 }}>
                    <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                      {Number(data?.totalToPay).toFixed(2)}
                    </Text>
                  </View>
                </View>
              );
            })}
          </View>

          <View
            style={{
              padding: "5px 0px",
              width: "100%",
              flexDirection: "row",
              borderTopWidth: 1,
            }}
          >
            <View style={{ flex: 1.5 }}>
              <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>Total</Text>
            </View>

            <View style={{ flex: 1.5 }}>
              <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                {CustomerDueData.reduce(
                  (e, i) => e + i?.creditBalance,
                  0
                ).toFixed(2)}
              </Text>
            </View>

            <View style={{ flex: 1.5 }}>
              <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                {/* {Number(data?.totalToPay).toFixed(2)} */}

                {CustomerDueData.reduce(
                  (e, i) => e + Number(i?.totalToPay) - i?.creditBalance,
                  0
                ).toFixed(2)}
              </Text>
            </View>

            <View style={{ flex: 1.5 }}>
              <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                {CustomerDueData.reduce(
                  (e, i) => e + Number(i?.totalToPay),
                  0
                ).toFixed(2)}
              </Text>
            </View>
          </View>
        </Page>
      </Document>
    );
  };

  const CustomerSpecificProductSaleReportHeader = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              {vat?.companyName}
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "10px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Product sale report by customer:{" "}
              <Text style={{ marginLeft: "10px", fontSize: "8px" }}>
                {" "}
                Customer: {selectedCustomer?.customerName}{" "}
              </Text>{" "}
            </Text>

            {startDate && endDate && searchDate?.selected && (
              <Text
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontFamily: "MyFont",
                  fontWeight: "normal",
                }}
              >
                From Date: {startDate} to Date: {endDate}
              </Text>
            )}
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
                marginTop: "10px",
              }}
            >
              Account no: {selectedCustomer?.accountNo}
            </Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Trans ID
            </Text>
          </View>

          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Date
            </Text>
          </View>

          <View style={{ flex: 4 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Description
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Qty
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Unit Price
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Total
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const CustomerSpecificProductSaleReportDocument = () => {
    let allProducts =
      customerProductsSale &&
      customerProductsSale?.length > 0 &&
      customerProductsSale
        ?.flatMap((e) => {
          let status = e?.saleReturnDate ? "Return" : "Sale";

          if (e.productDetails && e.productDetails.length > 0) {
            // Iterate through each productDetail and set productStatus
            e.productDetails.forEach((product) => {
              product.productStatus = status;
              product.customerDetails = e?.customerDetails;
            });

            // Return productDetails array with productStatus set
            return e.productDetails;
          } else {
            // Return an empty array if productDetails is empty or null
            return [];
          }
        })
        .filter(Boolean);

    let returnProduct =
      customerProductsSale &&
      customerProductsSale?.length > 0 &&
      customerProductsSale
        ?.flatMap((e) => {
          let status = "Return";

          if (e.returnProductDetails && e.returnProductDetails.length > 0) {
            // Iterate through each productDetail and set productStatus
            e.returnProductDetails.forEach((product) => {
              product.productStatus = status;
              product.customerDetails = e?.customerDetails;
            });

            // Return returnProductDetails array with productStatus set
            return e.returnProductDetails;
          } else {
            // Return an empty array if returnProductDetails is empty or null
            return [];
          }
        })
        .filter(Boolean);

    allProducts = allProducts && allProducts?.length > 0 ? allProducts : [];
    returnProduct =
      returnProduct && returnProduct?.length > 0 ? returnProduct : [];

    let products = [...allProducts, ...returnProduct];

    return (
      <Document size="A4">
        <Page style={{ padding: "0px 10px" }}>
          <CustomerSpecificProductSaleReportHeader />

          <View>
            {customerProductsSale &&
              customerProductsSale?.length > 0 &&
              customerProductsSale?.map((e, i) => {
                e.customerDetails = e.customerDetails && e.customerDetails[0];
                console.log(e, "e");
                return (
                  <View style={{ width: "100%" }}>
                    {e?.productDetails &&
                      e?.productDetails?.length > 0 &&
                      e?.productDetails?.map((j) => {
                        j.customerDetails =
                          j.customerDetails && j.customerDetails[0];
                        return (
                          <View
                            style={{
                              width: "100%",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <View style={{ flex: 1.5 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleDate
                                  ? `Invoice no ${e?.invoiceNumber}`
                                  : e?.saleReturnDate
                                  ? `return no ${e?.invoiceNumber}`
                                  : e?.invoiceNumber}
                              </Text>
                            </View>

                            <View style={{ flex: 1.5 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                )?.toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "2-digit",
                                })}{" "}
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                ).toLocaleTimeString()}
                              </Text>
                            </View>

                            <View style={{ flex: 4 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {j?.productName}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleReturnDate && "-"}{" "}
                                {j?.DamageQty ? j?.DamageQty : j?.saleQty}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleReturnDate && "-"} £
                                {j?.discountPrice
                                  ? Number(j?.discountPrice).toFixed(2)
                                  : e?.customerDetails?.priceLevel[0]?.id == 1
                                  ? Number(j?.trade_price).toFixed(2)
                                  : e?.customerDetails?.priceLevel[0]?.id == 2
                                  ? Number(j?.warehouse_price).toFixed(2)
                                  : Number(j?.retail_price).toFixed(2)}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleReturnDate && "-"}£
                                {Number(
                                  (j?.discountPrice
                                    ? Number(j?.discountPrice).toFixed(2)
                                    : e?.customerDetails?.priceLevel[0]?.id == 1
                                    ? Number(j?.trade_price).toFixed(2)
                                    : e?.customerDetails?.priceLevel[0]?.id == 2
                                    ? Number(j?.warehouse_price).toFixed(2)
                                    : Number(j?.retail_price).toFixed(2)) *
                                    (j?.DamageQty ? j?.DamageQty : j?.saleQty)
                                ).toFixed(2)}
                              </Text>
                            </View>
                          </View>
                        );
                      })}

                    {e?.returnProductDetails &&
                      e?.returnProductDetails?.length > 0 &&
                      e?.returnProductDetails?.map((j) => {
                        j.customerDetails =
                          j.customerDetails && j.customerDetails[0];
                        return (
                          <View
                            style={{
                              width: "100%",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <View style={{ flex: 1.5 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleDate
                                  ? `Invoice no ${e?.invoiceNumber}`
                                  : e?.saleReturnDate
                                  ? `return no ${e?.invoiceNumber}`
                                  : e?.invoiceNumber}
                              </Text>
                            </View>

                            <View style={{ flex: 1.5 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                )?.toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "2-digit",
                                })}{" "}
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                ).toLocaleTimeString()}
                              </Text>
                            </View>

                            <View style={{ flex: 4 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {j?.productName}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                -{j?.DamageQty ? j?.DamageQty : j?.saleQty}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                -£
                                {j?.discountPrice
                                  ? Number(j?.discountPrice).toFixed(2)
                                  : e?.customerDetails?.priceLevel[0]?.id == 1
                                  ? Number(j?.trade_price).toFixed(2)
                                  : e?.customerDetails?.priceLevel[0]?.id == 2
                                  ? Number(j?.warehouse_price).toFixed(2)
                                  : Number(j?.retail_price).toFixed(2)}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                -£
                                {Number(
                                  (j?.discountPrice
                                    ? Number(j?.discountPrice).toFixed(2)
                                    : e?.customerDetails?.priceLevel[0]?.id == 1
                                    ? Number(j?.trade_price).toFixed(2)
                                    : e?.customerDetails?.priceLevel[0]?.id == 2
                                    ? Number(j?.warehouse_price).toFixed(2)
                                    : Number(j?.retail_price).toFixed(2)) *
                                    (j?.DamageQty ? j?.DamageQty : j?.saleQty)
                                ).toFixed(2)}
                              </Text>
                            </View>
                          </View>
                        );
                      })}
                  </View>
                );
              })}
          </View>

          <View
            style={{
              padding: "5px 0px",
              width: "100%",
              flexDirection: "row",
              borderTopWidth: 1,
            }}
          >
            <View style={{ flex: 7 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                  width: "100%",
                }}
              >
                Total
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                {products &&
                  products?.length > 0 &&
                  products?.reduce((pre, curr) => {
                    if (curr?.productStatus?.toLowerCase() == "return") {
                      return (
                        (pre || 0) -
                        (curr?.DamageQty
                          ? Number(curr?.DamageQty)
                          : Number(curr?.saleQty))
                      );
                    } else {
                      return (
                        (pre || 0) +
                        (curr?.DamageQty
                          ? Number(curr?.DamageQty)
                          : Number(curr?.saleQty))
                      );
                    }
                  }, 0)}
              </Text>
            </View>

            <View style={{ flex: 1 }}></View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                £
                {products &&
                  products?.length > 0 &&
                  products?.reduce((pre, curr) => {
                    if (curr?.productStatus?.toLowerCase() == "return") {
                      return (
                        (pre || 0) -
                        (curr?.discountPrice
                          ? curr?.discountPrice
                          : curr?.customerDetails?.priceLevel[0]?.id == 1
                          ? curr?.trade_price
                          : curr?.customerDetails?.priceLevel[0]?.id == 2
                          ? curr?.discountPrice
                          : curr?.retail_price) *
                          (curr?.DamageQty
                            ? Number(curr?.DamageQty)
                            : Number(curr?.saleQty))
                      );
                    } else {
                      return (
                        (pre || 0) +
                        (curr?.discountPrice
                          ? curr?.discountPrice
                          : curr?.customerDetails?.priceLevel[0]?.id == 1
                          ? curr?.trade_price
                          : curr?.customerDetails?.priceLevel[0]?.id == 2
                          ? curr?.discountPrice
                          : curr?.retail_price) *
                          (curr?.DamageQty
                            ? Number(curr?.DamageQty)
                            : Number(curr?.saleQty))
                      );
                    }
                  }, 0)}
              </Text>
            </View>
          </View>
        </Page>
      </Document>
    );
  };

  const ProductSaleReportForSelectedDatesHeader = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              {vat?.companyName}
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "10px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
             Product Sales Report (Selected Dates):{" "}
              {/* <Text style={{ marginLeft: "10px", fontSize: "8px" }}>
                {" "}
                Customer: All{" "}
              </Text>{" "} */}
            </Text>

            {startDate && endDate && searchDate?.selected && (
              <Text
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontFamily: "MyFont",
                  fontWeight: "normal",
                }}
              >
                From Date: {startDate} to Date: {endDate}
              </Text>
            )}

            {
              <Text
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontFamily: "MyFont",
                  fontWeight: "normal",
                }}
              >
                Product:
                <Text style={{ marginLeft: "10px", fontSize: "8px" }}>
                  {" "}
                  {selectedProduct?.productName}{" "}
                </Text>{" "}
              </Text>
            }
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Trans ID
            </Text>
          </View>

          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Date
            </Text>
          </View>

          <View style={{ flex: 4 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Description
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Qty
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Unit Price
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Total
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const ProductSaleReportForSelectedDatesDocument = () => {
    let allProducts =
      productSaleData &&
      productSaleData?.length > 0 &&
      productSaleData
        ?.flatMap((e) => {
          let status = e?.saleReturnDate ? "Return" : "Sale";

          if (e.productDetails && e.productDetails.length > 0) {
            // Iterate through each productDetail and set productStatus
            e.productDetails.forEach((product) => {
              product.productStatus = status;
              product.customerDetails =
                e?.customerDetails && e?.customerDetails?.length > 0
                  ? e?.customerDetails[0]
                  : e?.customerDetails;
            });

            // Return productDetails array with productStatus set
            return e.productDetails;
          } else {
            // Return an empty array if productDetails is empty or null
            return [];
          }
        })
        .filter(Boolean);

    let returnProduct =
      productSaleData &&
      productSaleData?.length > 0 &&
      productSaleData
        ?.flatMap((e) => {
          let status = "Return";

          if (e.returnProductDetails && e.returnProductDetails.length > 0) {
            // Iterate through each productDetail and set productStatus
            e.returnProductDetails.forEach((product) => {
              product.productStatus = status;
              product.customerDetails =
                e?.customerDetails && e?.customerDetails?.length > 0
                  ? e?.customerDetails[0]
                  : e?.customerDetails;
            });

            return e.returnProductDetails;
          } else {
            return [];
          }
        })
        .filter(Boolean);

    allProducts = allProducts && allProducts?.length > 0 ? allProducts : [];
    returnProduct =
      returnProduct && returnProduct?.length > 0 ? returnProduct : [];

    let products = [...allProducts, ...returnProduct];

    return (
      <Document size="A4">
        <Page style={{ padding: "0px 10px" }}>
          <ProductSaleReportForSelectedDatesHeader />

          <View>
            {productSaleData &&
              productSaleData?.length > 0 &&
              productSaleData?.map((e, i) => {
                e.customerDetails =
                  e?.customerDetails && e?.customerDetails?.length > 0
                    ? e?.customerDetails[0]
                    : e?.customerDetails;

                return (
                  <View style={{ width: "100%" }}>
                    {e?.productDetails &&
                      e?.productDetails?.length > 0 &&
                      e?.productDetails?.map((j) => {
                        return (
                          <View
                            style={{
                              width: "100%",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <View style={{ flex: 1.5 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleDate
                                  ? `Invoice no ${e?.invoiceNumber}`
                                  : e?.saleReturnDate
                                  ? `return no ${e?.invoiceNumber}`
                                  : e?.invoiceNumber}
                              </Text>
                            </View>

                            <View style={{ flex: 1.5 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                )?.toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "2-digit",
                                })}{" "}
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                ).toLocaleTimeString()}
                              </Text>
                            </View>

                            <View style={{ flex: 4 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {j?.productName}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleReturnDate && "-"}{" "}
                                {j?.DamageQty ? j?.DamageQty : j?.saleQty}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleReturnDate && "-"} £
                                {j?.discountPrice
                                  ? Number(j?.discountPrice).toFixed(2)
                                  : e?.customerDetails?.priceLevel?.[0]?.id == 1
                                  ? Number(j?.trade_price).toFixed(2)
                                  : e?.customerDetails?.priceLevel?.[0]?.id == 2
                                  ? Number(j?.warehouse_price).toFixed(2)
                                  : Number(j?.retail_price).toFixed(2)}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleReturnDate && "-"}£
                                {Number(
                                  (j?.discountPrice
                                    ? Number(j?.discountPrice).toFixed(2)
                                    : e?.customerDetails?.priceLevel?.[0]?.id ==
                                      1
                                    ? Number(j?.trade_price).toFixed(2)
                                    : e?.customerDetails?.priceLevel?.[0]?.id ==
                                      2
                                    ? Number(j?.warehouse_price).toFixed(2)
                                    : Number(j?.retail_price).toFixed(2)) *
                                    (j?.DamageQty ? j?.DamageQty : j?.saleQty)
                                ).toFixed(2)}
                              </Text>
                            </View>
                          </View>
                        );
                      })}

                    {e?.returnProductDetails &&
                      e?.returnProductDetails?.length > 0 &&
                      e?.returnProductDetails?.map((j) => {
                        return (
                          <View
                            style={{
                              width: "100%",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <View style={{ flex: 1.5 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {e?.saleDate
                                  ? `Invoice no ${e?.invoiceNumber}`
                                  : e?.saleReturnDate
                                  ? `return no ${e?.invoiceNumber}`
                                  : e?.invoiceNumber}
                              </Text>
                            </View>

                            <View style={{ flex: 1.5 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                )?.toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "2-digit",
                                })}{" "}
                                {new Date(
                                  e?.saleDate
                                    ? e?.saleDate
                                    : e?.saleReturnDate
                                    ? e?.saleReturnDate
                                    : e?.exchangeDate
                                ).toLocaleTimeString()}
                              </Text>
                            </View>

                            <View style={{ flex: 4 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                {j?.productName}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                -{j?.DamageQty ? j?.DamageQty : j?.saleQty}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                -£
                                {j?.discountPrice
                                  ? Number(j?.discountPrice).toFixed(2)
                                  : e?.customerDetails?.priceLevel?.[0]?.id == 1
                                  ? Number(j?.trade_price).toFixed(2)
                                  : e?.customerDetails?.priceLevel?.[0]?.id == 2
                                  ? Number(j?.warehouse_price).toFixed(2)
                                  : Number(j?.retail_price).toFixed(2)}
                              </Text>
                            </View>

                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  color: "black",
                                  fontSize: "8px",
                                  fontFamily: "MyFont",
                                  fontWeight: "normal",
                                }}
                              >
                                -£
                                {Number(
                                  (j?.discountPrice
                                    ? Number(j?.discountPrice).toFixed(2)
                                    : e?.customerDetails?.priceLevel?.[0]?.id ==
                                      1
                                    ? Number(j?.trade_price).toFixed(2)
                                    : e?.customerDetails?.priceLevel?.[0]?.id ==
                                      2
                                    ? Number(j?.warehouse_price).toFixed(2)
                                    : Number(j?.retail_price).toFixed(2)) *
                                    (j?.DamageQty ? j?.DamageQty : j?.saleQty)
                                ).toFixed(2)}
                              </Text>
                            </View>
                          </View>
                        );
                      })}
                  </View>
                );
              })}
          </View>

          <View
            style={{
              padding: "5px 0px",
              width: "100%",
              flexDirection: "row",
              borderTopWidth: 1,
            }}
          >
            <View style={{ flex: 7 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                  width: "100%",
                }}
              >
                Total
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                {products &&
                  products?.length > 0 &&
                  products?.reduce((pre, curr) => {
                    if (curr?.productStatus?.toLowerCase() == "return") {
                      return (
                        (pre || 0) -
                        (curr?.DamageQty
                          ? Number(curr?.DamageQty)
                          : Number(curr?.saleQty))
                      );
                    } else {
                      return (
                        (pre || 0) +
                        (curr?.DamageQty
                          ? Number(curr?.DamageQty)
                          : Number(curr?.saleQty))
                      );
                    }
                  }, 0)}
              </Text>
            </View>

            <View style={{ flex: 1 }}></View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                £
                {products &&
                  products?.length > 0 &&
                  products?.reduce((pre, curr) => {
                    if (curr?.productStatus?.toLowerCase() == "return") {
                      return (
                        (pre || 0) -
                        (curr?.discountPrice
                          ? curr?.discountPrice
                          : curr?.customerDetails?.priceLevel?.[0]?.id == 1
                          ? curr?.trade_price
                          : curr?.customerDetails?.priceLevel?.[0]?.id == 2
                          ? curr?.discountPrice
                          : curr?.retail_price) *
                          (curr?.DamageQty
                            ? Number(curr?.DamageQty)
                            : Number(curr?.saleQty))
                      );
                    } else {
                      return (
                        (pre || 0) +
                        (curr?.discountPrice
                          ? curr?.discountPrice
                          : curr?.customerDetails?.priceLevel?.[0]?.id == 1
                          ? curr?.trade_price
                          : curr?.customerDetails?.priceLevel?.[0]?.id == 2
                          ? curr?.discountPrice
                          : curr?.retail_price) *
                          (curr?.DamageQty
                            ? Number(curr?.DamageQty)
                            : Number(curr?.saleQty))
                      );
                    }
                  }, 0)}
              </Text>
            </View>
          </View>
        </Page>
      </Document>
    );
  };

  const BestSellerProductHeader = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              {vat?.companyName}
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "10px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Top 1000 Best-Selling Products
            </Text>
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          <View style={{ flex: 4 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Description
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Barcode
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Qty
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Unit Price
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Value
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const BestSellerProductDocument = () => {
    return (
      <Document size="A4">
        <Page style={{ padding: "0px 10px" }}>
          <BestSellerProductHeader />

          <View>
            {productSaleData &&
              productSaleData?.length > 0 &&
              productSaleData?.map((e, i) => {
                return (
                  <View style={{ width: "100%" }}>
                    <View
                      style={{
                        width: "100%",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <View style={{ flex: 4 }}>
                        <Text
                          style={{
                            color: "black",
                            fontSize: "8px",
                            fontFamily: "MyFont",
                            fontWeight: "normal",
                          }}
                        >
                          {e?.productName}
                        </Text>
                      </View>

                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            color: "black",
                            fontSize: "8px",
                            fontFamily: "MyFont",
                            fontWeight: "normal",
                          }}
                        >
                          {e?.barcode}
                        </Text>
                      </View>

                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            color: "black",
                            fontSize: "8px",
                            fontFamily: "MyFont",
                            fontWeight: "normal",
                          }}
                        >
                          {e?.qty}
                        </Text>
                      </View>

                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            color: "black",
                            fontSize: "8px",
                            fontFamily: "MyFont",
                            fontWeight: "normal",
                          }}
                        >
                          £{Number(e?.totalAmount / e?.qty).toFixed(2)}
                        </Text>
                      </View>

                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            color: "black",
                            fontSize: "8px",
                            fontFamily: "MyFont",
                            fontWeight: "normal",
                          }}
                        >
                          £{Number(e?.totalAmount).toFixed(2)}
                        </Text>
                      </View>
                    </View>
                  </View>
                );
              })}
          </View>
        </Page>
      </Document>
    );
  };

  const DepartmentSaleReportHeader = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              {vat?.companyName}
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "10px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Sales Report By Department
            </Text>
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          <View style={{ flex: 4 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Description
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Qty
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Amount
            </Text>
          </View>
        </View>
      </View>
    );
  };
  const CustomerReportDeparmentAndprofitHeader = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              {vat?.companyName}
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "10px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Customer Report by Department / Category / Subcategory:{" "}
              <Text style={{ marginLeft: "10px", fontSize: "8px" }}>
                {" "}
                Customer: {selectedCustomer?.customerName}{" "}
              </Text>{" "}
            </Text>
             {startDate && endDate && searchDate?.selected && (
              <Text
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontFamily: "MyFont",
                  fontWeight: "normal",
                }}
              >
                From Date: {startDate} to Date: {endDate}
              </Text>
            )}
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
                marginTop: "10px",
              }}
            >
              Account no: {selectedCustomer?.accountNo}
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const DepartmentSaleReportDocument = () => {
    return (
      <Document size="A4">
        <Page style={{ padding: "0px 10px" }}>
          <DepartmentSaleReportHeader />

          <View>
            {productSaleData &&
              productSaleData?.length > 0 &&
              productSaleData?.map((e, i) => {
                return (
                  <View style={{ width: "100%" }}>
                    <View
                      style={{
                        width: "100%",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <View style={{ flex: 4 }}>
                        <Text
                          style={{
                            color: "black",
                            fontSize: "8px",
                            fontFamily: "MyFont",
                            fontWeight: "normal",
                          }}
                        >
                          {e?.department}
                        </Text>
                      </View>

                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            color: "black",
                            fontSize: "8px",
                            fontFamily: "MyFont",
                            fontWeight: "normal",
                          }}
                        >
                          {e?.qty}
                        </Text>
                      </View>

                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            color: "black",
                            fontSize: "8px",
                            fontFamily: "MyFont",
                            fontWeight: "normal",
                          }}
                        >
                          £{Number(Math.round(e?.totalAmount)).toFixed(2)}
                        </Text>
                      </View>
                    </View>
                  </View>
                );
              })}
          </View>

          <View
            style={{
              width: "100%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              borderTopWidth: 1,
            }}
          >
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                Total:-
              </Text>
            </View>

            <View style={{ flex: 3 }}>
              <Text
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                Total Count:- {productSaleData?.length}
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                {productSaleData &&
                  productSaleData?.length > 0 &&
                  productSaleData?.reduce((pre, curr) => {
                    return (pre || 0) + curr?.qty;
                  }, 0)}
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: "10px",
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  Math.round(
                    productSaleData &&
                      productSaleData?.length > 0 &&
                      productSaleData?.reduce((pre, curr) => {
                        return (pre || 0) + curr?.totalAmount;
                      }, 0)
                  )
                ).toFixed(2)}
              </Text>
            </View>
          </View>
        </Page>
      </Document>
    );
  };
 const CustomerReportWithProfitAndDepartment = () => {
  /* =======================
     1. BUILD FULL TREE (SALES + MASTER DATA)
     ======================= */

  const departmentMap = {};

  // 1️⃣ Initialize from departments API (MASTER)
  deparments?.forEach(dep => {
    departmentMap[dep.departmentName] = {
      department: dep.departmentName,
      qty: 0,
      totalAmount: 0,
      categories: dep.categories?.map(cat => ({
        category: cat.categoryName,
        qty: 0,
        totalAmount: 0,
        subcategory: cat.subcategories?.map(sub => ({
          subcategory: sub.subcategoryName,
          qty: 0,
          totalAmount: 0
        })) || []
      })) || []
    };
  });

  // 2️⃣ Merge sales data into master tree
  productSaleData?.forEach(depSale => {
    const dep = departmentMap[depSale.department];
    if (!dep) return;

    dep.qty += depSale.qty || 0;
    dep.totalAmount += depSale.totalAmount || 0;

    depSale.categories?.forEach(catSale => {
      const cat = dep.categories.find(
        c => c.category === catSale.category
      );
      if (!cat) return;

      cat.qty += catSale.qty || 0;
      cat.totalAmount += catSale.totalAmount || 0;

      catSale.subcategory?.forEach(subSale => {
        const sub = cat.subcategory.find(
          s => s.subcategory === subSale.subcategory
        );
        if (!sub) return;

        sub.qty += subSale.qty || 0;
        sub.totalAmount += subSale.totalAmount || 0;
      });
    });
  });

  const productSaleDataAdded = Object.values(departmentMap);

  /* =======================
     2. SHARED STYLES
     ======================= */

  const rowBase = {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 3
  };

  const cellLeft = { flex: 4 };
  const cell = { flex: 1, textAlign: "right" };

  /* =======================
     3. PDF RENDER
     ======================= */

  return (
    <Document size="A4">
      <Page style={{ padding: "10px" }}>
<CustomerReportDeparmentAndprofitHeader/>
        {/* ===== COLUMN HEADER ===== */}
        <View
          style={{
            ...rowBase,
            borderBottomWidth: 1,
            marginBottom: 4
          }}
        >
          <Text style={{ ...cellLeft, fontSize: 14, fontWeight: "bold" }}>
            Department {isCategoryExist?" / Category":""} {isSubCategoryExist?" / Sub Category":""}
          </Text>
          <Text style={{ ...cell, fontSize: 14, fontWeight: "bold" }}>
            Qty
          </Text>
          <Text style={{ ...cell, fontSize: 14, fontWeight: "bold" }}>
            Amount
          </Text>
        </View>

        {/* ===== DATA TREE ===== */}
        {productSaleDataAdded.map((dep, i) => (
          <View key={i}>

            {/* ===== DEPARTMENT ===== */}
            <View
              style={{
                ...rowBase,
                backgroundColor: "#F1F1F1",
                borderBottomWidth: 0.5
              }}
            >
              <Text style={{ ...cellLeft, fontSize: 8, fontWeight: "bold" }}>
                {dep.department}
              </Text>
              <Text style={{ ...cell, fontSize: 8, fontWeight: "bold" }}>
                {dep.qty}
              </Text>
              <Text style={{ ...cell, fontSize: 8, fontWeight: "bold" }}>
                £{Number(dep.totalAmount).toFixed(2)}
              </Text>
            </View>

            {/* ===== CATEGORIES ===== */}
            {isCategoryExist&&(dep.categories.map((cat, ci) => (
              <View key={ci}>
                <View
                  style={{
                    ...rowBase,
                    paddingLeft: 10,
                    borderBottomWidth: 0.3
                  }}
                >
                  <Text style={{ ...cellLeft, fontSize: 7 }}>
                    {cat.category}
                  </Text>
                  <Text style={{ ...cell, fontSize: 7 }}>
                    {cat.qty}
                  </Text>
                  <Text style={{ ...cell, fontSize: 7 }}>
                    £{Number(cat.totalAmount).toFixed(2)}
                  </Text>
                </View>

                {/* ===== SUB CATEGORIES ===== */}
                {isSubCategoryExist&&(cat.subcategory.map((sub, si) => (
                  <View
                    key={si}
                    style={{
                      ...rowBase,
                      paddingLeft: 20
                    }}
                  >
                    <Text
                      style={{
                        ...cellLeft,
                        fontSize: 6.5,
                        color: "#555"
                      }}
                    >
                      {sub.subcategory}
                    </Text>
                    <Text style={{ ...cell, fontSize: 6.5, color: "#555" }}>
                      {sub.qty}
                    </Text>
                    <Text style={{ ...cell, fontSize: 6.5, color: "#555" }}>
                      £{Number(sub.totalAmount).toFixed(2)}
                    </Text>
                  </View>
                )))}
              </View>
            )))}
          </View>
        ))}

        {/* ===== TOTAL FOOTER ===== */}
        <View
          style={{
            ...rowBase,
            borderTopWidth: 1,
            marginTop: 6,
            paddingTop: 4
          }}
        >
          <Text style={{ ...cellLeft, fontSize: 9, fontWeight: "bold" }}>
            Grand Total
          </Text>

          <Text style={{ ...cell, fontSize: 9, fontWeight: "bold" }}>
            {productSaleDataAdded.reduce((s, d) => s + d.qty, 0)}
          </Text>

          <Text style={{ ...cell, fontSize: 9, fontWeight: "bold" }}>
            £
            {Number(
              productSaleDataAdded.reduce(
                (s, d) => s + d.totalAmount,
                0
              )
            ).toFixed(2)}
          </Text>
        </View>
      </Page>
    </Document>
  );
};



  const DayReportHeader = () => {
    let selectedDateParts = endDate?.split("/");
    let dateFromParts = startDate?.split("/");

    // Create Date objects from the parsed components
    let selectedDateTime = new Date(
      parseInt(selectedDateParts[2]), // Year
      parseInt(selectedDateParts[1]), // Month (zero-based)
      parseInt(selectedDateParts[0]), // Day
      23, // Hours
      59, // Minutes
      59 // Seconds
    );

    let dateFromTime = new Date(
      parseInt(dateFromParts[2]), // Year
      parseInt(dateFromParts[1]), // Month (zero-based)
      parseInt(dateFromParts[0]), // Day
      0, // Hours
      0, // Minutes
      0 // Seconds
    );

    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            <Text
              style={{
                color: "black",
                fontSize: "14px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
            >
              {vat?.companyName}
            </Text>
            <Text
              style={{
                color: "black",
                fontSize: "12px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Daily Sales Report
            </Text>
          </View>

          <View>
            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
              }}
            >
              Print Date:{" "}
              {new Date().toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
              <Text style={{ marginLeft: "5px" }}>
                {" "}
                {new Date().toLocaleTimeString()}
              </Text>
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
                marginTop: "10px",
              }}
            >
              Start Date:{" "}
              {new Date(dateFromTime).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </Text>

            <Text
              style={{
                color: "black",
                fontSize: "8px",
                fontFamily: "MyFont",
                fontWeight: "normal",
                marginTop: "10px",
              }}
            >
              End Date:{" "}
              {new Date(selectedDateTime).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const DayReportDocument = () => (
    <Document size="A4">
      {/* <Header /> */}

      <Page style={{ padding: "30px 10px" }} orientation="landscape">
        <DayReportHeader />

        <View>
          <Text
            style={{
              fontSize: 12,
              fontWeight: "bold",
              color: "black",
              fontFamily: "MyFont",
              width: "100%",
              marginTop: "10px",
            }}
          >
            Invoice Details:
          </Text>

          {Object.entries(employeeInvoices).map(([key, value],ind) => {
            return (
              <View>
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    fontFamily: "MyFont",
                    color: "red",
                  }}
                >
                  {key}
                </Text>

                <View
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    borderBottomWidth: 1,
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Date
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Invoice Amount
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Paid
                    </Text>
                  </View>

                  <View style={{ flex: 2 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      MOP
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Cash
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      On Account
                    </Text>
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Card
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Online
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Cheque
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      Invoice Type
                    </Text>
                  </View>
                </View>

                {value &&
                  value.length > 0 &&
                  value?.map((e, i) => {
                    return (
                      <View
                        style={{
                          width: "100%",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          borderBottomWidth: 1,
                        }}
                      >
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "bold",
                              fontFamily: "MyFont",
                            }}
                          >
                            {new Date(
                              e?.saleDate
                                ? e?.saleDate
                                : e?.saleReturnDate
                                ? e?.saleReturnDate
                                : e?.exchangeDate
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "2-digit",
                            })}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            {e?.saleReturnDate && "-"} £
                            {Number(e?.subtotal).toFixed(2)}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            £
                            {Number(e?.cash || 0) +
                              Number(e?.online || 0) +
                              Number(e?.card || 0)}
                          </Text>
                        </View>

                        <View style={{ flex: 2 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            {e?.paymentMethod &&
                            Array?.isArray(e?.paymentMethod)
                              ? e?.paymentMethod?.map((e) => e).join(",")
                              : e?.paymentMethod}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            {e?.paymentMethod &&
                            !Array?.isArray(e?.paymentMethod) &&
                            e?.paymentMethod?.toLowerCase() == "refund cash"
                              ? `£${-Number(e?.subtotal).toFixed(2)}`
                              : e?.paymentMethod &&
                                Array?.isArray(e?.paymentMethod) &&
                                e?.paymentMethod?.some(
                                  (j) => j?.toLowerCase() == "refund cash"
                                )
                              ? `£${Number(e?.subtotal).toFixed(2)}`
                              : `£${e?.cash || 0}`}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            {e?.paymentMethod &&
                            !Array?.isArray(e?.paymentMethod) &&
                            e?.paymentMethod?.toLowerCase() == "credit note"
                              ? `£${-Number(e?.subtotal).toFixed(2)}`
                              : e?.paymentMethod &&
                                Array?.isArray(e?.paymentMethod) &&
                                e?.paymentMethod?.some(
                                  (j) => j?.toLowerCase() == "credit note"
                                )
                              ? `£${Number(e?.subtotal).toFixed(2)}`
                              : `£${e?.credit || 0}`}
                          </Text>
                        </View>
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            {e?.paymentMethod &&
                            !Array?.isArray(e?.paymentMethod) &&
                            e?.paymentMethod?.toLowerCase() == "refund card"
                              ? `£${-Number(e?.subtotal).toFixed(2)}`
                              : e?.paymentMethod &&
                                Array?.isArray(e?.paymentMethod) &&
                                e?.paymentMethod?.some(
                                  (j) => j?.toLowerCase() == "refund card"
                                )
                              ? `£${Number(e?.subtotal).toFixed(2)}`
                              : `£${e?.card || 0}`}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            £{e?.online || 0}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            £{e?.cheque || 0}
                          </Text>
                        </View>

                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 8,
                              fontWeight: "normal",
                              fontFamily: "MyFont",
                            }}
                          >
                            {e?.exchangeDate ? "Exchange" : e?.status}
                          </Text>
                        </View>
                      </View>
                    );
                  })}

                <View
                  style={{
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "space-between",
                    borderBottomWidth: 1,
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "normal",
                        fontFamily: "MyFont",
                      }}
                    >
                      Total
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            if (curr?.saleReturnDate) {
                              return (pre || 0) - Number(curr?.subtotal);
                            } else {
                              return (pre || 0) + Number(curr?.subtotal);
                            }
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            return (
                              (pre || 0) +
                              Number(
                                Number(curr?.cash || 0) +
                                  Number(curr?.online || 0) +
                                  Number(curr?.card || 0)
                              )
                            );
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 2 }}></View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            if (
                              curr?.paymentMethod &&
                              !Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "refund cash"
                            ) {
                              return (pre || 0) - Number(curr?.subtotal);
                            } else if (
                              curr?.paymentMethod &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (j) => j?.toLowerCase() == "refund cash"
                              )
                            ) {
                              return (pre || 0) + Number(curr?.subtotal);
                            } else {
                              return (pre || 0) + Number(curr?.cash || 0);
                            }
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            if (
                              curr?.paymentMethod &&
                              !Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "credit note"
                            ) {
                              return (pre || 0) - Number(curr?.subtotal);
                            } else if (
                              curr?.paymentMethod &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (j) => j?.toLowerCase() == "credit note"
                              )
                            ) {
                              return (pre || 0) + Number(curr?.subtotal);
                            } else {
                              return (pre || 0) + Number(curr?.credit || 0);
                            }
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            if (
                              curr?.paymentMethod &&
                              !Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "refund card"
                            ) {
                              return (pre || 0) - Number(curr?.subtotal);
                            } else if (
                              curr?.paymentMethod &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (j) => j?.toLowerCase() == "refund card"
                              )
                            ) {
                              return (pre || 0) + Number(curr?.subtotal);
                            } else {
                              return (pre || 0) + Number(curr?.card || 0);
                            }
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            return (pre || 0) + Number(curr?.online || 0);
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      £
                      {Number(
                        value &&
                          value?.length > 0 &&
                          value?.reduce((pre, curr) => {
                            return (pre || 0) + Number(curr?.cheque || 0);
                          }, 0)
                      ).toFixed(2)}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}></View>
                </View>
              </View>
            );
          })}
        </View>

        <View break>
          <Text
            style={{
              fontSize: 12,
              fontWeight: "bold",
              color: "green",
              fontFamily: "MyFont",
              width: "100%",
              marginTop: "10px",
            }}
          >
            Refund Details:
          </Text>

          {Object.keys(refundInvoices).length > 0 &&
            Object.entries(refundInvoices).map(([key, value],ind) => {
              return (
                <View>
                  <Text
                    style={{
                      fontSize: 10,
                      fontWeight: "bold",
                      fontFamily: "MyFont",
                      color: "red",
                    }}
                  >
                    {key}
                  </Text>

                  <View
                    style={{
                      width: "100%",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      borderBottomWidth: 1,
                    }}
                  >
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Date
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Refund Amount
                      </Text>
                    </View>

                    <View style={{ flex: 2 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Payment Method
                      </Text>
                    </View>

                    <View style={{ flex: 2 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Transaction Type
                      </Text>
                    </View>

                    <View style={{ flex: 5 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Reason
                      </Text>
                    </View>
                  </View>

                  {value &&
                    value.length > 0 &&
                    value?.map((e, i) => {
                      return (
                        <View
                          style={{
                            width: "100%",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            borderBottomWidth: 1,
                          }}
                        >
                          <View style={{ flex: 1 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "bold",
                                fontFamily: "MyFont",
                              }}
                            >
                              {new Date(e?.date).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "2-digit",
                              })}
                            </Text>
                          </View>

                          <View style={{ flex: 1 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              £{Number(e?.refund).toFixed(2)}
                            </Text>
                          </View>

                          <View style={{ flex: 2 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              {e?.paymentMethod[0]}
                            </Text>
                          </View>

                          <View style={{ flex: 2 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              {e?.transactionType}
                            </Text>
                          </View>

                          <View style={{ flex: 5 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              {e?.reason}
                            </Text>
                          </View>
                        </View>
                      );
                    })}

                  <View
                    style={{
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "space-between",
                      borderBottomWidth: 1,
                    }}
                  >
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "normal",
                          fontFamily: "MyFont",
                        }}
                      >
                        Total
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        £
                        {Number(
                          value &&
                            value?.length > 0 &&
                            value?.reduce((pre, curr) => {
                              return (pre || 0) + Number(curr?.refund);
                            }, 0)
                        ).toFixed(2)}
                      </Text>
                    </View>

                    <View style={{ flex: 9 }}></View>
                  </View>
                </View>
              );
            })}
        </View>

        <View>
          <Text
            style={{
              fontSize: 12,
              fontWeight: "bold",
              color: "green",
              fontFamily: "MyFont",
              width: "100%",
              marginTop: "10px",
            }}
          >
            Credit Payment By Customer:
          </Text>

          {Object.keys(creditPayment).length > 0 &&
            Object.entries(creditPayment).map(([key, value],ind) => {
              return (
                <View>
                  <Text
                    style={{
                      fontSize: 10,
                      fontWeight: "bold",
                      fontFamily: "MyFont",
                      color: "red",
                    }}
                  >
                    {key}
                  </Text>

                  <View
                    style={{
                      width: "100%",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      borderBottomWidth: 1,
                    }}
                  >
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Date
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Total Amount
                      </Text>
                    </View>

                    <View style={{ flex: 2 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Payment Method
                      </Text>
                    </View>

                    <View style={{ flex: 2 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Transaction Type
                      </Text>
                    </View>

                    <View style={{ flex: 5 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        Reason
                      </Text>
                    </View>
                  </View>

                  {value &&
                    value.length > 0 &&
                    value?.map((e, i) => {
                      return (
                        <View
                          style={{
                            width: "100%",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            borderBottomWidth: 1,
                          }}
                        >
                          <View style={{ flex: 1 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "bold",
                                fontFamily: "MyFont",
                              }}
                            >
                              {new Date(e?.date).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "2-digit",
                              })}
                            </Text>
                          </View>

                          <View style={{ flex: 1 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              £{Number(e?.deductCredit).toFixed(2)}
                            </Text>
                          </View>

                          <View style={{ flex: 2 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              {e?.paymentMethod[0]}
                            </Text>
                          </View>

                          <View style={{ flex: 2 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              {e?.transactionType}
                            </Text>
                          </View>

                          <View style={{ flex: 5 }}>
                            <Text
                              style={{
                                fontSize: 8,
                                fontWeight: "normal",
                                fontFamily: "MyFont",
                              }}
                            >
                              {e?.reason}
                            </Text>
                          </View>
                        </View>
                      );
                    })}

                  <View
                    style={{
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "space-between",
                      borderBottomWidth: 1,
                    }}
                  >
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "normal",
                          fontFamily: "MyFont",
                        }}
                      >
                        Total
                      </Text>
                    </View>

                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          fontWeight: "bold",
                          fontFamily: "MyFont",
                        }}
                      >
                        £
                        {Number(
                          value &&
                            value?.length > 0 &&
                            value?.reduce((pre, curr) => {
                              return (pre || 0) + Number(curr?.deductCredit);
                            }, 0)
                        ).toFixed(2)}
                      </Text>
                    </View>

                    <View style={{ flex: 9 }}></View>
                  </View>
                </View>
              );
            })}
        </View>

        <View style={{ marginTop: "20px" }}>
          <Text
            style={{
              fontSize: 12,
              fontWeight: "bold",
              color: "green",
              fontFamily: "MyFont",
              width: "100%",
            }}
          >
            Expense Details:
          </Text>

          <View
            style={{
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              borderBottomWidth: 1,
            }}
          >
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 8,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                Date
              </Text>
            </View>

            <View style={{ flex: 9 }}>
              <Text
                style={{
                  fontSize: 8,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                description
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 8,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                Amount
              </Text>
            </View>
          </View>

          {expenses &&
            expenses.length > 0 &&
            expenses.map((e, i) => {
              return (
                <View
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    borderBottomWidth: 1,
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "bold",
                        fontFamily: "MyFont",
                      }}
                    >
                      {new Date(
                        e?.date ? e?.date : e?.created_at
                      ).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "2-digit",
                      })}
                    </Text>
                  </View>

                  <View style={{ flex: 9 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "normal",
                        fontFamily: "MyFont",
                      }}
                    >
                      {e?.description}
                    </Text>
                  </View>

                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 8,
                        fontWeight: "normal",
                        fontFamily: "MyFont",
                      }}
                    >
                      £{e?.amount || 0}
                    </Text>
                  </View>
                </View>
              );
            })}

          <View
            style={{
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              borderBottomWidth: 1,
            }}
          >
            <View style={{ flex: 10 }}>
              <Text
                style={{
                  fontSize: 8,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                Total
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 8,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  expenses &&
                    expenses?.length > 0 &&
                    expenses?.reduce((pre, curr) => {
                      return (pre || 0) + Number(curr?.amount || 0);
                    }, 0)
                ).toFixed(2)}
              </Text>
            </View>
          </View>
        </View>

        <View style={{ marginTop: "20px" }} break>
          <Text
            style={{
              fontSize: 10,
              fontWeight: "bold",
              fontFamily: "MyFont",
              borderBottomWidth: 1,
              width: "100%",
              color:"green"
            }}
          >
            Payment Summary:
          </Text>

          <View style={{ marginTop: "10px" }}>
            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Cash:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        return (pre || 0) + (curr?.cash || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Cash Returns:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          !Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.toLowerCase() == "refund cash"
                        ) {
                          return (pre || 0) - (curr?.subtotal || 0);
                        } else if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (j) => j?.toLowerCase() == "refund cash"
                          )
                        ) {
                          return (pre || 0) + (curr?.subtotal || 0);
                        } else {
                          return pre || 0;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Cash Refunds:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £(
                {Number(
                  employeeRefundData && employeeRefundData?.length > 0
                    ? employeeRefundData?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e) => e.toLowerCase() == "cash"
                          )
                        ) {
                          return (pre || 0) + (curr?.refund || 0);
                        } else {
                          return pre;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}
                ){" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Credit Payments:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  employeeCreditPayment && employeeCreditPayment?.length > 0
                    ? employeeCreditPayment?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e) => e.toLowerCase() == "cash"
                          )
                        ) {
                          //console.log(curr, "curr");
                          return (pre || 0) + (curr?.deductCredit || 0);
                        } else {
                          return pre;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            {/* <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Credit Summary:{" "}
            </Text>
            {employeeCreditPayment && employeeCreditPayment?.length > 0
              ? employeeCreditPayment?.map((e) => {
                  return (
                    <View style={{flexDirection:"column"}}>
                      <Text
                        style={{
                          fontSize: 10,
                          fontWeight: "normal",
                          fontFamily: "MyFont",
                          
                        }}
                      >
                        {e?.customerData?.business_name}{" "}
                      </Text>
                      <Text
                        style={{
                          fontSize: 10,
                          fontWeight: "normal",
                          fontFamily: "MyFont",
                        }}
                      >
                        £{e?.deductCredit}
                      </Text>
                    </View>
                  );
                })
              : 0} */}

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Cash Expenses:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £(
                {Number(
                  expenses && expenses?.length > 0
                    ? expenses?.reduce((pre, curr) => {
                        return (pre || 0) + (Number(curr?.amount) || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}
                ){" "}
              </Text>
            </Text>

            <Text
              style={{
                color: "red",
                fontFamily: "MyFont",
                fontWeight: "bold",
                fontSize: 10,
                borderBottomWidth: 1,
                borderBottomColor: "black",
              }}
            >
              Total Remaining Cash: £
              {Number(
                Number(
                  shiftInvoices &&
                    shiftInvoices?.length > 0 &&
                    shiftInvoices?.reduce((pre, curr) => {
                      if (
                        curr?.saleReturnDate &&
                        curr?.paymentMethod?.toLowerCase() == "refund cash"
                      ) {
                        return (pre || 0) - curr?.subtotal;
                      } else if (
                        curr?.exchangeDate &&
                        Array?.isArray(curr?.paymentMethod) &&
                        curr?.paymentMethod?.some(
                          (e, i) => e?.toLowerCase() == "refund cash"
                        )
                      ) {
                        return (pre || 0) + curr?.subtotal;
                      } else {
                        return (pre || 0) + (curr?.cash || 0);
                      }
                    }, 0)
                ) +
                  Number(
                    employeeCreditPayment &&
                      employeeCreditPayment?.length > 0 &&
                      employeeCreditPayment?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "cash"
                          )
                        ) {
                          return (pre || 0) + curr?.deductCredit;
                        } else {
                          return pre;
                        }
                      }, 0)
                  ) -
                  Number(
                    employeeRefundData &&
                      employeeRefundData?.length > 0 &&
                      employeeRefundData?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "cash"
                          )
                        ) {
                          return (pre || 0) + curr?.refund;
                        } else {
                          return pre;
                        }
                      }, 0)
                  ) -
                  Number(
                    expenses &&
                      expenses?.length > 0 &&
                      expenses?.reduce((pre, curr) => {
                        return (pre || 0) + Number(curr?.amount);
                      }, 0)
                  )
              ).toFixed(2)}
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              On Account:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        return (pre || 0) + (curr?.credit || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              On Account Returns:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          !Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.toLowerCase() == "credit note"
                        ) {
                          return (pre || 0) - (curr?.subtotal || 0);
                        } else if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (j) => j?.toLowerCase() == "credit note"
                          )
                        ) {
                          return (pre || 0) + (curr?.subtotal || 0);
                        } else {
                          return pre || 0;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              On Account Refunds :{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £(
                {Number(
                  employeeRefundData && employeeRefundData?.length > 0
                    ? employeeRefundData?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e) => e.toLowerCase() == "onaccount"
                          )
                        ) {
                          return (pre || 0) + (curr?.refund || 0);
                        } else {
                          return pre;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}
                ){" "}
              </Text>
            </Text>

            <Text
              style={{
                color: "red",
                fontFamily: "MyFont",
                fontWeight: "bold",
                fontSize: 10,
                borderBottomWidth: 1,
                borderBottomColor: "black",
              }}
            >
              Total On Accounts: £
              {Number(
                Number(
                  shiftInvoices &&
                    shiftInvoices?.length > 0 &&
                    shiftInvoices?.reduce((pre, curr) => {
                      if (
                        curr?.saleReturnDate &&
                        curr?.paymentMethod?.toLowerCase() == "credit note"
                      ) {
                        return (pre || 0) - curr?.subtotal;
                      } else if (
                        curr?.exchangeDate &&
                        Array?.isArray(curr?.paymentMethod) &&
                        curr?.paymentMethod?.some(
                          (e, i) => e?.toLowerCase() == "credit note"
                        )
                      ) {
                        return (pre || 0) + curr?.subtotal;
                      } else {
                        return (pre || 0) + (curr?.credit || 0);
                      }
                    }, 0)
                ) -
                  Number(
                    employeeRefundData &&
                      employeeRefundData?.length > 0 &&
                      employeeRefundData?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "onaccount"
                          )
                        ) {
                          return (pre || 0) + curr?.refund;
                        } else {
                          return pre;
                        }
                      }, 0)
                  )
              ).toFixed(2)}
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Card:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        return (pre || 0) + (curr?.card || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Card Returns:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          !Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.toLowerCase() == "refund card"
                        ) {
                          return (pre || 0) - (curr?.subtotal || 0);
                        } else if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (j) => j?.toLowerCase() == "refund card"
                          )
                        ) {
                          return (pre || 0) - (curr?.subtotal || 0);
                        } else {
                          return pre || 0;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Card Refunds :{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £(
                {Number(
                  employeeRefundData && employeeRefundData?.length > 0
                    ? employeeRefundData?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e) => e.toLowerCase() == "card"
                          )
                        ) {
                          return (pre || 0) + (curr?.refund || 0);
                        } else {
                          return pre;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}
                ){" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Credit Payments:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  employeeCreditPayment && employeeCreditPayment?.length > 0
                    ? employeeCreditPayment?.reduce((pre, curr) => {
                        if (
                          curr?.paymentMethod &&
                          Array.isArray(curr?.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e) => e.toLowerCase() == "card"
                          )
                        ) {
                          return (pre || 0) + (curr?.deductCredit || 0);
                        } else {
                          return pre;
                        }
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{
                color: "red",
                fontFamily: "MyFont",
                fontWeight: "bold",
                fontSize: 10,
                borderBottomWidth: 1,
                borderBottomColor: "black",
              }}
            >
              Total Remaining Card: £
              {Number(
                Number(
                  shiftInvoices &&
                    shiftInvoices?.length > 0 &&
                    shiftInvoices?.reduce((pre, curr) => {
                      if (
                        curr?.saleReturnDate &&
                        curr?.paymentMethod?.toLowerCase() == "refund card"
                      ) {
                        return (pre || 0) - curr?.subtotal;
                      } else if (
                        curr?.exchangeDate &&
                        Array?.isArray(curr?.paymentMethod) &&
                        curr?.paymentMethod?.some(
                          (e, i) => e?.toLowerCase() == "refund card"
                        )
                      ) {
                        return (pre || 0) + curr?.subtotal;
                      } else {
                        return (pre || 0) + (curr?.card || 0);
                      }
                    }, 0)
                ) +
                  Number(
                    employeeCreditPayment &&
                      employeeCreditPayment?.length > 0 &&
                      employeeCreditPayment?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "card"
                          )
                        ) {
                          return (pre || 0) + curr?.deductCredit;
                        } else {
                          return pre;
                        }
                      }, 0)
                  ) -
                  Number(
                    employeeRefundData &&
                      employeeRefundData?.length > 0 &&
                      employeeRefundData?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "card"
                          )
                        ) {
                          return (pre || 0) + curr?.refund;
                        } else {
                          return pre;
                        }
                      }, 0)
                  )
              ).toFixed(2)}
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Bank Transfer:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        return (pre || 0) + (curr?.online || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Credit Payments:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  Number(
                    employeeCreditPayment && employeeCreditPayment?.length > 0
                      ? employeeCreditPayment?.reduce((pre, curr) => {
                          if (
                            curr?.paymentMethod &&
                            Array.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.some(
                              (e) => e.toLowerCase() == "bank transfer"
                            )
                          ) {
                            return (pre || 0) + (curr?.deductCredit || 0);
                          } else {
                            return pre;
                          }
                        }, 0)
                      : 0
                  )
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{
                color: "red",
                fontFamily: "MyFont",
                fontWeight: "bold",
                fontSize: 10,
                borderBottomWidth: 1,
                borderBottomColor: "black",
              }}
            >
              Total Bank Transfer: £
              {Number(
                Number(
                  shiftInvoices &&
                    shiftInvoices?.length > 0 &&
                    shiftInvoices?.reduce((pre, curr) => {
                      return (pre || 0) + (curr?.online || 0);
                    }, 0)
                ) +
                  Number(
                    employeeCreditPayment &&
                      employeeCreditPayment?.length > 0 &&
                      employeeCreditPayment?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "bank transfer"
                          )
                        ) {
                          return (pre || 0) + curr?.deductCredit;
                        } else {
                          return pre;
                        }
                      }, 0)
                  )
              ).toFixed(2)}
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Cheques:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  shiftInvoices && shiftInvoices?.length > 0
                    ? shiftInvoices?.reduce((pre, curr) => {
                        return (pre || 0) + (curr?.cheque || 0);
                      }, 0)
                    : 0
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{ fontSize: 10, fontWeight: "bold", fontFamily: "MyFont" }}
            >
              Credit Payments:{" "}
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  fontFamily: "MyFont",
                }}
              >
                £
                {Number(
                  Number(
                    employeeCreditPayment && employeeCreditPayment?.length > 0
                      ? employeeCreditPayment?.reduce((pre, curr) => {
                          if (
                            curr?.paymentMethod &&
                            Array.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.some(
                              (e) => e.toLowerCase() == "cheque"
                            )
                          ) {
                            return (pre || 0) + (curr?.deductCredit || 0);
                          } else {
                            return pre;
                          }
                        }, 0)
                      : 0
                  )
                ).toFixed(2)}{" "}
              </Text>
            </Text>

            <Text
              style={{
                color: "red",
                fontFamily: "MyFont",
                fontWeight: "bold",
                fontSize: 10,
              }}
            >
              Total Cheques: £
              {Number(
                Number(
                  shiftInvoices &&
                    shiftInvoices?.length > 0 &&
                    shiftInvoices?.reduce((pre, curr) => {
                      return (pre || 0) + (curr?.cheque || 0);
                    }, 0)
                ) +
                  Number(
                    employeeCreditPayment &&
                      employeeCreditPayment?.length > 0 &&
                      employeeCreditPayment?.reduce((pre, curr) => {
                        if (
                          Array.isArray(curr.paymentMethod) &&
                          curr?.paymentMethod?.some(
                            (e, i) => e?.toLowerCase() == "cheque"
                          )
                        ) {
                          return (pre || 0) + curr?.deductCredit;
                        } else {
                          return pre;
                        }
                      }, 0)
                  )
              ).toFixed(2)}
            </Text>

            <View style={{ marginTop: "10px", borderTopWidth: 1 }}>
              <Text
                style={{ color: "black", fontFamily: "MyFont", fontSize: 10 }}
              >
                Total Sales: £
                {Number(
                  shiftInvoices &&
                    shiftInvoices.length > 0 &&
                    shiftInvoices.reduce((pre, curr) => {
                      if (curr?.saleDate) {
                        return (pre || 0) + Number(curr?.subtotal);
                      } else {
                        return pre;
                      }
                    }, 0)
                ).toFixed(2)}
              </Text>

              <Text
                style={{ color: "black", fontFamily: "MyFont", fontSize: 10 }}
              >
                Total Returns: £-
                {Number(
                  shiftInvoices &&
                    shiftInvoices.length > 0 &&
                    shiftInvoices.reduce((pre, curr) => {
                      if (curr?.saleReturnDate) {
                        return (pre || 0) + Number(curr?.subtotal);
                      } else {
                        return pre;
                      }
                    }, 0)
                ).toFixed(2)}
              </Text>

              <Text
                style={{ color: "black", fontFamily: "MyFont", fontSize: 10 }}
              >
                Total Exchange: £
                {Number(
                  shiftInvoices &&
                    shiftInvoices.length > 0 &&
                    shiftInvoices.reduce((pre, curr) => {
                      if (curr?.exchangeDate) {
                        return (pre || 0) + Number(curr?.subtotal);
                      } else {
                        return pre;
                      }
                    }, 0)
                ).toFixed(2)}
              </Text>

              <Text
                style={{
                  fontSize: 14,
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                  color: "black",
                  borderTopWidth: 1,
                }}
              >
                Net Sales:{" "}
                <Text
                  style={{
                    fontSize: 16,
                    fontWeight: "normal",
                    fontFamily: "MyFont",
                    color: "red",
                  }}
                >
                  £
                  {Number(
                    shiftInvoices && shiftInvoices?.length > 0
                      ? shiftInvoices?.reduce((pre, curr) => {
                          if (
                            curr?.paymentMethod &&
                            !Array.isArray(curr?.paymentMethod) &&
                            (curr?.paymentMethod?.toLowerCase() ==
                              "refund cash" ||
                              curr?.paymentMethod?.toLowerCase() ==
                                "credit note" ||
                              curr?.paymentMethod?.toLowerCase() ==
                                "refund card")
                          ) {
                            return (pre || 0) - (curr?.subtotal || 0);
                          }

                          if (
                            curr?.paymentMethod &&
                            Array.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.some(
                              (e) =>
                                e?.toLowerCase() == "refund cash" ||
                                e?.toLowerCase() == "credit note" ||
                                e?.toLowerCase() == "refund card"
                            )
                          ) {
                            return (pre || 0) + (curr?.subtotal || 0);
                          } else {
                            return (pre || 0) + (curr?.subtotal || 0);
                          }
                        }, 0)
                      : 0
                  ).toFixed(2)}{" "}
                </Text>
              </Text>

              <Text
                style={{
                  fontSize: 14,
                  color: "black",
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                }}
              >
                Gross Collection:{" "}
                <Text
                  style={{
                    color: "red",
                    fontFamily: "MyFont",
                    fontWeight: "bold",
                    fontSize: 16,
                  }}
                >
                  £
                  {Number(
                    Number(
                      shiftInvoices &&
                        shiftInvoices?.length > 0 &&
                        shiftInvoices?.reduce((pre, curr) => {
                          if (
                            curr?.saleReturnDate &&
                            curr?.paymentMethod?.toLowerCase() == "refund cash"
                          ) {
                            return (pre || 0) - curr?.subtotal;
                          } else if (
                            curr?.exchangeDate &&
                            Array?.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.some(
                              (e, i) => e?.toLowerCase() == "refund cash"
                            )
                          ) {
                            return (pre || 0) + curr?.subtotal;
                          } else {
                            return (pre || 0) + (curr?.cash || 0);
                          }
                        }, 0)
                    ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            if (
                              curr?.saleReturnDate &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "refund card"
                            ) {
                              return (pre || 0) - curr?.subtotal;
                            } else if (
                              curr?.exchangeDate &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (e, i) => e?.toLowerCase() == "refund card"
                              )
                            ) {
                              return (pre || 0) + curr?.subtotal;
                            } else {
                              return (pre || 0) + (curr?.card || 0);
                            }
                          }, 0)
                      ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            return (pre || 0) + (curr?.online || 0);
                          }, 0)
                      ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            if (
                              curr?.saleReturnDate &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "credit note"
                            ) {
                              return (pre || 0) - curr?.subtotal;
                            } else if (
                              curr?.exchangeDate &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (e, i) => e?.toLowerCase() == "credit note"
                              )
                            ) {
                              return (pre || 0) + curr?.subtotal;
                            } else {
                              return (pre || 0) + (curr?.credit || 0);
                            }
                          }, 0)
                      ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            return (pre || 0) + (curr?.cheque || 0);
                          }, 0)
                      )
                  ).toFixed(2)}
                </Text>
              </Text>

              <Text
                style={{
                  fontSize: 14,
                  color: "black",
                  fontWeight: "bold",
                  fontFamily: "MyFont",
                  borderTopWidth: 1,
                  borderTopColor: "black",
                }}
              >
                Extra cash received on invoices:{" "}
                <Text
                  style={{
                    color: "red",
                    fontFamily: "MyFont",
                    fontWeight: "bold",
                    fontSize: 16,
                  }}
                >
                  £
                  {Number(
                    Number(
                      shiftInvoices &&
                        shiftInvoices?.length > 0 &&
                        shiftInvoices?.reduce((pre, curr) => {
                          if (
                            curr?.saleReturnDate &&
                            curr?.paymentMethod?.toLowerCase() == "refund cash"
                          ) {
                            return (pre || 0) - curr?.subtotal;
                          } else if (
                            curr?.exchangeDate &&
                            Array?.isArray(curr?.paymentMethod) &&
                            curr?.paymentMethod?.some(
                              (e, i) => e?.toLowerCase() == "refund cash"
                            )
                          ) {
                            return (pre || 0) + curr?.subtotal;
                          } else {
                            return (pre || 0) + (curr?.cash || 0);
                          }
                        }, 0)
                    ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            if (
                              curr?.saleReturnDate &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "refund card"
                            ) {
                              return (pre || 0) - curr?.subtotal;
                            } else if (
                              curr?.exchangeDate &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (e, i) => e?.toLowerCase() == "refund card"
                              )
                            ) {
                              return (pre || 0) + curr?.subtotal;
                            } else {
                              return (pre || 0) + (curr?.card || 0);
                            }
                          }, 0)
                      ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            return (pre || 0) + (curr?.online || 0);
                          }, 0)
                      ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            if (
                              curr?.saleReturnDate &&
                              curr?.paymentMethod?.toLowerCase() ==
                                "credit note"
                            ) {
                              return (pre || 0) - curr?.subtotal;
                            } else if (
                              curr?.exchangeDate &&
                              Array?.isArray(curr?.paymentMethod) &&
                              curr?.paymentMethod?.some(
                                (e, i) => e?.toLowerCase() == "credit note"
                              )
                            ) {
                              return (pre || 0) + curr?.subtotal;
                            } else {
                              return (pre || 0) + (curr?.credit || 0);
                            }
                          }, 0)
                      ) +
                      Number(
                        shiftInvoices &&
                          shiftInvoices?.length > 0 &&
                          shiftInvoices?.reduce((pre, curr) => {
                            return (pre || 0) + (curr?.cheque || 0);
                          }, 0)
                      ) -
                      Number(
                        shiftInvoices &&
                          shiftInvoices.length > 0 &&
                          shiftInvoices.reduce((pre, curr) => {
                            if (curr?.saleReturnDate) {
                              return (pre || 0) - Number(curr?.subtotal);
                            } else {
                              return (pre || 0) + Number(curr?.subtotal);
                            }
                          }, 0)
                      )
                  ).toFixed(2)}
                </Text>
              </Text>
              {(userData?.role === "admin" ||
                userData?.role_access?.some(
                  (e, i) => e.name.toLowerCase() == "showprofit" && e?.selected
                )) && (
                <Text style={{ fontSize: 12 }}>
                  PF:
                  {Number(
                    shiftInvoices && shiftInvoices?.length > 0
                      ? shiftInvoices?.reduce((pre, curr) => {
                          //console.log(curr);
                          //console.log(curr?.discount);
                          //console.log(curr?.total);
                          //console.log(curr?.SDAmount);
                          // console.log(
                          //   Number(
                          //     curr?.total -
                          //       (curr?.discount || 0) -
                          //       curr?.costPrice -
                          //       curr?.SDAmount || 0
                          //   )
                          // );

                          return (
                            pre +
                            Number(
                              (curr?.total -
                                (curr?.discount || 0) -
                                curr?.costPrice || 0) - curr?.SDAmount || 0
                            )
                          );
                        }, 0)
                      : 0
                  ).toFixed(2)}
                </Text>
              )}
            </View>
          </View>
        </View>
         <Text
        style={{ position: "absolute",
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 10,
    color: "black",}}
        render={({ pageNumber, totalPages }) =>
          `Page ${pageNumber} of ${totalPages}`
        }
        fixed
      />
      </Page>
    </Document>
  );
  const handleClosePdf = () => {
    setPdfDownloadView({
      ...pdfDownloadView,
      stockReport: false,
      saleReport: false,
      minimumStockLevel: false,
      userSaleReport: false,
      saleReportBetweenDates: false,
      customerSpecificProductSaleReport: false,
      productSaleReportForSelectedCustomer: false,
      ProductSaleReportForSelectedCustomerWithProfit: false,
      productSaleReportForSelectedDates: false,
      bestSellerTop100: false,
      dayReport: false,
      saleReportByDepartment: false,
      saleReportBetweenDatesAfterExpenses: false,
      CustomerDueReport: false,
    });
  };
  const getDocumentComponent = () => {
    if (pdfDownloadView?.dayReport) return <DayReportDocument />;
    if (pdfDownloadView?.stockReport) return <StockReportDocument />;
    if (pdfDownloadView?.minimumStockLevel)
      return <MinimumStockReportDocument />;
    if (pdfDownloadView?.userSaleReport) return <UserSaleReportDocument />;
    if (pdfDownloadView?.saleReportBetweenDates)
      return <SaleReportBetweenDatesDocument />;
    if (pdfDownloadView?.saleReportBetweenDatesAfterExpenses)
      return <SaleReportBetweenDatesAfterExpensesDocument />;
    if (pdfDownloadView?.productSaleReportForSelectedCustomer)
      return <ProductSaleReportSelectedCustomerDocument />;
    if (pdfDownloadView?.ProductSaleReportForSelectedCustomerWithProfit)
      return <ProductSaleReportSelectedCustomerWithProfitDocument />;
    if (pdfDownloadView?.customerSpecificProductSaleReport)
      return <CustomerSpecificProductSaleReportDocument />;
    if (pdfDownloadView?.productSaleReportForSelectedDates)
      return <ProductSaleReportForSelectedDatesDocument />;
    if (pdfDownloadView?.bestSellerTop100) return <BestSellerProductDocument />;
    if (pdfDownloadView?.saleReportByDepartment)
      return <DepartmentSaleReportDocument />;
    if (pdfDownloadView?.CustomerDueReport)
      return <ProductCustomerDueReportDocument />;
    if (pdfDownloadView?.CustomerReportwithDeparmentand)
      return <CustomerReportWithProfitAndDepartment />;
    return null;
  };
  const [pdfOpenViewState, setPdfOpenViewState] = useState({
    stockReport: false,
    dayReport: false,
    saleReport: false,
    minimumStockLevel: false,
    userSaleReport: false,
    saleReportBetweenDates: false,
    saleReportBetweenDatesAfterExpenses: false,
    productSaleReportForSelectedCustomer: false,
    ProductSaleReportForSelectedCustomerWithProfit: false,
    customerSpecificProductSaleReport: false,
    productSaleReportForSelectedDates: false,
    bestSellerTop100: false,
    saleReportByDepartment: false,
    ByDepartmentReport: false,
    CustomerDueReport: false,
  });
  const openPDFInNewTab = async () => {
    const documentComponent = getDocumentComponent();
    if (!documentComponent) return;
    const blob = await pdf(documentComponent).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url);
    setPdfDownloadView({
      stockReport: false,
      dayReport: false,
      saleReport: false,
      minimumStockLevel: false,
      userSaleReport: false,
      saleReportBetweenDates: false,
      saleReportBetweenDatesAfterExpenses: false,
      productSaleReportForSelectedCustomer: false,
      ProductSaleReportForSelectedCustomerWithProfit: false,
      customerSpecificProductSaleReport: false,
      productSaleReportForSelectedDates: false,
      bestSellerTop100: false,
      saleReportByDepartment: false,
      ByDepartmentReport: false,
      CustomerDueReport: false,
    });
  };
  const fetchPaginatedData = async (url, payload, token) => {
    let allData = [];
    let page = 0;
    const limit = 50;
    let hasMore = true;

    while (hasMore) {
      const paginatedPayload = { ...payload, page, limit, pag: "1" };
      const response = await axios.post(url, paginatedPayload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.status && Array.isArray(response.data.data)) {
        const dataBatch = response.data.data;
        //console.log(allData, "allData");
        let alld = allData.length != 0 ? [...allData.data] : [...allData];
        allData = {
          data: [...alld, ...dataBatch],
          status: response?.data?.status,
        };

        if (dataBatch.length < limit) {
          hasMore = false;
        } else {
          page++;
        }
      } else {
        hasMore = false;
      }
    }

    return allData;
  };

  const fetchPaginatedDataWithQuery = async (
    url,
    token,
    queryParams = {},
    limit = 50
  ) => {
    let page = 1;
    let allData = [];
    let hasMore = true;

    while (hasMore) {
      const query = new URLSearchParams({
        ...queryParams,
        pag: 1,
        page,
        limit,
      });

      try {
        const res = await axios.get(`${url}?${query.toString()}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        // if (currentData.length < limit) {
        //   hasMore = false;
        // } else {
        //   //console.log(allData,"/allData")
        //      let alld = allData.length!=0?[...allData.data]:[...allData]
        //   allData ={data:  [...alld, ...currentData],status:res?.data?.success}

        //   page++;
        // }
        if ((res?.data?.success||res?.data?.status) && (Array.isArray(res.data.data)||Array.isArray(res.data))) {
          const currentData = (res.data.data||res.data);
          //console.log(allData, "allData");
          let alld = allData.length != 0 ? [...allData.data] : [...allData];
          allData = {
            data: [...alld, ...currentData],
            status: res?.data?.success||res?.data?.status,
          };
          //console.log(currentData, "currentData");
          //console.log(res.data, "currentData/");
          if (currentData.length < limit) {
            hasMore = false;
          } else {
            page++;
          }
        } else {
          hasMore = false;
        }
      } catch (error) {
        console.error("Pagination error:", error);
        throw error;
      }
    }
    //console.log(allData, "allData");
    return allData;
  };

  useEffect(() => {
    //console.log(pdfOpenViewState);
    openPDFInNewTab();
  }, [pdfOpenViewState]);
    const [open, setOpen] = useState(false);
    const [sortDataProducts,setSortDataProducts] = useState([])

  const handleGenerateForPurchasedOrder = async()=>{
    setLoading(true);

      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
      //console.log(new Date(startDate), "d");
     

      axios
        .get(
          `${Base_Uri}get-all-type-invoice?startDate=${startDate||""}&endDate=${endDate||""}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // Include other headers as needed
            },
          }
        )
        .then(async (res) => {
          if (!res?.status) {
            setLoading(false);
            message.info(res.message);
            return;
          }

          let { data } = res.data;

          let productWiseData = [];

          data &&
            data?.length > 0 &&
            data?.forEach((e, i) => {
              e?.productDetails &&
                e?.productDetails?.length > 0 &&
                e?.productDetails?.map((product, i) => {
                  if (e?.saleReturnDate) {
                    if (
                      productWiseData &&
                      productWiseData?.length > 0 &&
                      productWiseData?.some(
                        (j) => j.barcode == product?.barcode
                      )
                    ) {
                      productWiseData?.map((change) => {
                        if (change.barcode == product?.barcode) {
                          return {
                            ...change,
                            qty: (change.qty -= product?.DamageQty
                              ? product?.DamageQty
                              : product?.saleQty),
                            totalAmount: (change.totalAmount -=
                              (product?.DamageQty
                                ? product?.DamageQty
                                : product?.saleQty) *
                              (product?.discountPrice
                                ? product?.discountPrice
                                : e?.customerDetails?.[0]?.priceLevel?.[0]
                                    ?.id == 1
                                ? product?.trade_price
                                : e?.customerDetails?.[0]?.priceLevel?.[0]
                                    ?.id == 2
                                ? product?.warehouse_price
                                : product?.retail_price)),
                          };
                        } else {
                          return change;
                        }
                      });
                    } else {
                      if (e?.saleReturnDate) {
                        product.qty = -(product.DamageQty
                          ? product.DamageQty
                          : product.saleQty);
                        product.totalAmount = -(
                          (product?.DamageQty
                            ? product?.DamageQty
                            : product?.saleQty) *
                          (product?.discountPrice
                            ? product?.discountPrice
                            : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                            ? product?.trade_price
                            : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                            ? product?.warehouse_price
                            : product?.retail_price)
                        );

                        productWiseData?.push(product);
                        return;
                      }
                      product.qty = product.DamageQty
                        ? product.DamageQty
                        : product.saleQty;
                      product.totalAmount =
                        (product?.DamageQty
                          ? product?.DamageQty
                          : product?.saleQty) *
                        (product?.discountPrice
                          ? product?.discountPrice
                          : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                          ? product?.trade_price
                          : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                          ? product?.warehouse_price
                          : product?.retail_price);

                      productWiseData?.push(product);
                    }
                  } else {
                    if (
                      productWiseData &&
                      productWiseData?.length > 0 &&
                      productWiseData?.some(
                        (j) => j.barcode == product?.barcode
                      )
                    ) {
                      productWiseData?.map((change) => {
                        if (change.barcode == product?.barcode) {
                          return {
                            ...change,
                            qty: (change.qty += product?.DamageQty
                              ? product?.DamageQty
                              : product?.saleQty),
                            totalAmount: (change.totalAmount +=
                              (product?.DamageQty
                                ? product?.DamageQty
                                : product?.saleQty) *
                              (product?.discountPrice
                                ? product?.discountPrice
                                : e?.customerDetails?.[0]?.priceLevel?.[0]
                                    ?.id == 1
                                ? product?.trade_price
                                : e?.customerDetails?.[0]?.priceLevel?.[0]
                                    ?.id == 2
                                ? product?.warehouse_price
                                : product?.retail_price)),
                          };
                        } else {
                          return change;
                        }
                      });
                    } else {
                      if (e?.saleReturnDate) {
                        product.qty = -(product?.DamageQty
                          ? product?.DamageQty
                          : product?.saleQty);
                        product.totalAmount = -(
                          (product?.DamageQty
                            ? product?.DamageQty
                            : product?.saleQty) *
                          (product?.discountPrice
                            ? product?.discountPrice
                            : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                            ? product?.trade_price
                            : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                            ? product?.warehouse_price
                            : product?.retail_price)
                        );

                        productWiseData?.push(product);
                        return;
                      }
                      product.qty = product?.DamageQty
                        ? product?.DamageQty
                        : product?.saleQty;
                      product.totalAmount =
                        (product?.DamageQty
                          ? product?.DamageQty
                          : product?.saleQty) *
                        (product?.discountPrice
                          ? product?.discountPrice
                          : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                          ? product?.trade_price
                          : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                          ? product?.warehouse_price
                          : product?.retail_price);

                      productWiseData?.push(product);
                    }
                  }
                });

              e?.returnProductDetails &&
                e?.returnProductDetails?.length > 0 &&
                e?.returnProductDetails?.map((product, i) => {
                  if (
                    productWiseData &&
                    productWiseData?.length > 0 &&
                    productWiseData?.some((j) => j.barcode == product?.barcode)
                  ) {
                    productWiseData?.map((change) => {
                      if (change.barcode == product?.barcode) {
                        return {
                          ...change,
                          qty: (change.qty -= product?.DamageQty
                            ? product?.DamageQty
                            : product?.saleQty),
                          totalAmount: (change.totalAmount +=
                            (product?.DamageQty
                              ? product?.DamageQty
                              : product?.saleQty) *
                            (product?.discountPrice
                              ? product?.discountPrice
                              : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
                                1
                              ? product?.trade_price
                              : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
                                2
                              ? product?.warehouse_price
                              : product?.retail_price)),
                        };
                      } else {
                        return change;
                      }
                    });
                  } else {
                    product.qty = -(product?.DamageQty
                      ? product?.DamageQty
                      : product?.saleQty);
                    product.totalAmount = -(
                      (product?.DamageQty
                        ? product?.DamageQty
                        : product?.saleQty) *
                      (product?.discountPrice
                        ? product?.discountPrice
                        : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                        ? product?.trade_price
                        : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                        ? product?.warehouse_price
                        : product?.retail_price)
                    );
                    productWiseData?.push(product);
                    return;
                  }
                });
            });

          productWiseData =
            productWiseData &&
            productWiseData?.length > 0 &&
            productWiseData?.filter((e) => {
              return Number(e?.qty) > 0;
            });

          let sortData =
            productWiseData &&
            productWiseData?.length > 0 &&
            productWiseData?.sort((a, b) => {
              return b.qty - a?.qty;
            });

          sortData.length = 1000;
          //console.log(sortData,"lop")
          setLoading(false)
          setSortDataProducts(sortData)
          setOpen(true)
        })
  }
  const handleGenerateReports = async () => {
    if (!selectedReportType || selectedReportType == "select") {
      message.info("Kindly Select Report Type");
      return;
    }

    if (selectedReportType?.toLowerCase() == "daily sales report") {
      if (!startDate) {
        message.info("Start Date is missing");
        return;
      }

      if (!endDate) {
        message.info("End Date is missing");
        return;
      }

      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      setLoading(true);

      try {
        // Parse selectedDate and dateFrom
        let selectedDateParts = endDate?.split("/");
        let dateFromParts = startDate?.split("/");

        // Create Date objects from the parsed components
        let selectedDateTime = new Date(
          parseInt(selectedDateParts[2]), // Year
          parseInt(selectedDateParts[1]), // Month (zero-based)
          parseInt(selectedDateParts[0]), // Day
          23, // Hours
          59, // Minutes
          59 // Seconds
        );

        let dateFromTime = new Date(
          parseInt(dateFromParts[2]), // Year
          parseInt(dateFromParts[1]), // Month (zero-based)
          parseInt(dateFromParts[0]), // Day
          0, // Hours
          0, // Minutes
          0 // Seconds
        );

        let dataSend = {
          startDate: dateFromTime,
          endDate: selectedDateTime,
        };
        let invoicesData = await fetchPaginatedData(
          `${Base_Uri}getDateWiseAllInvoices`,
          dataSend,
          token
        );

        let returnInvoicesData = await fetchPaginatedData(
          `${Base_Uri}getDateWiseAllReturnInvoices`,
          dataSend,
          token
        );

        let exchangeInvoicesData = await fetchPaginatedData(
          `${Base_Uri}getDateWiseAllExchangeInvoices`,
          dataSend,
          token
        );
        // let invoicesData = await axios.post(
        //   `${Base_Uri}getDateWiseAllInvoices`,
        //   dataSend,
        //   {
        //     headers: {
        //       "Content-Type": "application/json",
        //       Authorization: `Bearer ${token}`,
        //     },
        //   }
        // );

        // let returnInvoicesData = await axios.post(
        //   `${Base_Uri}getDateWiseAllReturnInvoices`,
        //   dataSend,
        //   {
        //     headers: {
        //       "Content-Type": "application/json",
        //       Authorization: `Bearer ${token}`,
        //     },
        //   }
        // );

        // let exchangeInvoicesData = await axios.post(
        //   `${Base_Uri}getDateWiseAllExchangeInvoices`,
        //   dataSend,
        //   {
        //     headers: {
        //       "Content-Type": "application/json",
        //       Authorization: `Bearer ${token}`,
        //     },
        //   }
        // );
        invoicesData = invoicesData;
        returnInvoicesData = returnInvoicesData;
        exchangeInvoicesData = exchangeInvoicesData;

        let invoices;
        let returnInvoices;
        let exchangeInvoices;

        if (invoicesData?.status) {
          invoices = invoicesData?.data;
        }

        if (returnInvoicesData?.status) {
          returnInvoices = returnInvoicesData?.data;
        }

        if (exchangeInvoicesData?.status) {
          exchangeInvoices = exchangeInvoicesData?.data;
        }

        invoices = invoices && invoices?.length > 0 ? invoices : [];
        returnInvoices =
          returnInvoices && returnInvoices?.length > 0 ? returnInvoices : [];
        exchangeInvoices =
          exchangeInvoices && exchangeInvoices?.length > 0
            ? exchangeInvoices
            : [];

        let allInvoices = [...invoices, ...returnInvoices, ...exchangeInvoices];

        const groupedData = {};
        allInvoices &&
          allInvoices?.length > 0 &&
          allInvoices.forEach((invoice) => {
            const { businessName } = invoice?.customerDetails[0];

            if (!groupedData[businessName]) {
              groupedData[businessName] = [];
            }
            groupedData[businessName].push(invoice);
          });

        setShiftInvoices(allInvoices);
        setEmployeeInvoices(groupedData);

        let dataToSend = {
          startDate: dateFromTime,
          endDate: selectedDateTime,
        };

        let expenseResponse = await fetchPaginatedData(
          `${Base_Uri}getDateWiseExpense`,
          dataToSend,
          token
        );

        // await axios.post(
        //   `${Base_Uri}getDateWiseExpense`,
        //   dataToSend,
        //   {
        //     headers: {
        //       "Content-Type": "application/json",
        //       Authorization: `Bearer ${token}`,
        //     },
        //   }
        // );

        let expenseData = expenseResponse;
        //console.log(expenseData);
        if (expenseData?.status) {
          let allExpenses = expenseData?.data;
          dispatch(updateDayExpenses(allExpenses));
        } else {
          message.info(expenseData?.message);
          setLoading(false);
          return;
        }

        let refundResponse = await fetchPaginatedData(
          `${Base_Uri}getDateWiseRefund`,
          dataToSend,
          token
        );

        // await axios.post(
        //   `${Base_Uri}getDateWiseRefund`,
        //   dataToSend,
        //   {
        //     headers: {
        //       "Content-Type": "application/json",
        //       Authorization: `Bearer ${token}`,
        //     },
        //   }
        // );

        let refundData = refundResponse;

        if (refundData?.status) {
          let dayRefunds = refundData?.data;

          dispatch(updateDayRefund(dayRefunds));

          const groupedData = {};

          dayRefunds &&
            dayRefunds?.length > 0 &&
            dayRefunds.forEach((invoice) => {
              const business_name = invoice?.customerData?.business_name;

              if (!groupedData[business_name]) {
                groupedData[business_name] = [];
              }
              groupedData[business_name].push(invoice);
            });

          setRefundInvoices(groupedData);
        } else {
          message.info(refundData?.message);
          setLoading(false);
          return;
        }

        let creditResponse = await fetchPaginatedData(
          `${Base_Uri}getDateWiseCredit`,
          dataToSend,
          token
        );

        // await axios.post(
        //   `${Base_Uri}getDateWiseCredit`,
        //   dataToSend,
        //   {
        //     headers: {
        //       "Content-Type": "application/json",
        //       Authorization: `Bearer ${token}`,
        //     },
        //   }
        // );

        let creditData = creditResponse;

        if (creditData?.status) {
          let creditPayments = creditData?.data;

          dispatch(updateDayCreditPayment(creditPayments));

          const groupedData = {};

          creditPayments &&
            creditPayments?.length > 0 &&
            creditPayments.forEach((invoice) => {
              const business_name = invoice?.customerData?.business_name;

              if (!groupedData[business_name]) {
                groupedData[business_name] = [];
              }
              groupedData[business_name].push(invoice);
            });

          setCreditPayment(groupedData);

          setPdfDownloadView({
            ...pdfDownloadView,
            dayReport: true,
          });
          setPdfOpenViewState({
            ...pdfOpenViewState,
            dayReport: true,
          });

          setLoading(false);
        } else {
          message.info(creditData?.message);
          setLoading(false);
          return;
        }
      } catch (err) {
        //console.log(err, "errrrrr");
        setLoading(false);
        message.info("Internal Server Error");
      }
    }

    if (selectedReportType?.toLowerCase() === "inventory report") {
      setLoading(true);

      try {
        let data = sessionStorage.getItem("userData");
        let token = JSON.parse(data);

        if (!token) {
          console.error("No token found");
          setLoading(false);
          return;
        }

        let allProducts = [];
        let page = 1;
        const limit = 1000;
        let hasMore = true;

        while (hasMore) {
          const response = await axios.get(
            `${Base_Uri}getProducts?page=${page}&limit=${limit}&pag=1`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );

          const products = response?.data?.data;

          if (!products || products.length === 0) {
            hasMore = false;
          } else {
            allProducts = [...allProducts, ...products];
            page++;
          }
        }
        exportStockReportToExcel(allProducts);
        setAllProducts(allProducts);
        // setPdfDownloadView({
        //   ...pdfDownloadView,
        //   stockReport: true,
        // });
        // setPdfOpenViewState({
        //     ...pdfOpenViewState,
        //   stockReport: true,
        // });
      } catch (error) {
        console.error("Error fetching Inventory Report:", error);
      } finally {
        setLoading(false);
      }
    } else if (selectedReportType?.toLowerCase() == "low stock level report") {
      setLoading(true);

      try {
        let data = await sessionStorage.getItem("userData");
        data = JSON.parse(data);
        let token = data;

        let res = await fetchPaginatedDataWithQuery(
          `${Base_Uri}getMinimumStockProducts`,
          token
        );
        let myData = res;

        console.log(myData,"myData")

        if (myData?.status) {
          let { data } = myData;
          setMinimumStockProduct(data);
          setPdfDownloadView({
            ...pdfDownloadView,
            minimumStockLevel: true,
          });
          setPdfOpenViewState({
            ...pdfOpenViewState,
            minimumStockLevel: true,
          });
          setLoading(false);
        } else {
          //console.log("h")
          message.info(myData?.message);
        }
      } catch (error) {
        message.info(error?.message);
        //console.log(error, "error");
        setLoading(false);
      }

      // if (token) {
      //   axios
      //     .get(`${Base_Uri}getMinimumStockProducts`, {
      //       headers: {
      //         Authorization: `Bearer ${token}`,
      //         "Content-Type": "application/json", // Include other headers as needed
      //       },
      //     })
      //     .then((res) => {
      //       let myData = res.data;

      //       if (myData?.status) {
      //         let { data } = myData;
      //         setMinimumStockProduct(data);
      //         setPdfDownloadView({
      //           ...pdfDownloadView,
      //           minimumStockLevel: true,
      //         });
      //          setPdfOpenViewState({
      //       ...pdfOpenViewState,
      //           minimumStockLevel: true,
      //         });
      //         setLoading(false);
      //       } else {
      //         message.info(myData?.message);
      //       }
      //     })
      //     .catch((error) => {
      //       message.info(error?.message);
      //       console.log(error, "error");
      //       setLoading(false);
      //     });
      // }
    } else if (selectedReportType?.toLowerCase() == "sales report by user") {
      if (!selectedEmployee || selectedEmployee == "select") {
        message.info("Employee is missing");
        return;
      }

       if (!startDate) {
        message.info("Start Date is missing");
        return;
      }

      if (!endDate) {
        message.info("End Date is missing");
        return;
      }

      setLoading(true);

      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
      if (token) {
        try {
          let employee = employees.find((e) => e.full_name == selectedEmployee);
          let qu = {};
          if (searchDate?.selected && startDate && endDate) {
            qu.startDate = startDate;
            qu.endDate = endDate;
          }
          let allEmploInvoices = await fetchPaginatedDataWithQuery(
            `${Base_Uri}getAllTypesInvoices`,
            token,
            {
              employeeIdd: employee?._id,
              ...qu,
            }
          );

          //console.log(allEmploInvoices, "allEmploInvoices");

          let myData = allEmploInvoices;

          if (myData?.status) {
            let { data } = myData;

            //     if (searchDate?.selected) {
            //       let filteredData =
            //         data &&
            //         data?.length > 0 &&
            //         data?.filter((e, i) => {
            //           let date = e?.saleDate
            //             ? e?.saleDate
            //             : e?.saleReturnDate
            //             ? e?.saleReturnDate
            //             : e?.exchangeDate;

            //           let addDate = new Date(date);

            //           // Parse selectedDate and dateFrom
            //           let selectedDateParts = endDate?.split("/");
            //           let dateFromParts = startDate?.split("/");

            //           // Create Date objects from the parsed components
            //           let selectedDateTime = new Date(
            //             parseInt(selectedDateParts[2]), // Year
            //             parseInt(selectedDateParts[1]), // Month (zero-based)
            //             parseInt(selectedDateParts[0]), // Day
            //             23, // Hours
            //             59, // Minutes
            //             59 // Seconds
            //           );

            //           let dateFromTime = new Date(
            //             parseInt(dateFromParts[2]), // Year
            //             parseInt(dateFromParts[1]), // Month (zero-based)
            //             parseInt(dateFromParts[0]), // Day
            //             0, // Hours
            //             0, // Minutes
            //             0 // Seconds
            //           );

            //           // Check if addDate is between dateFrom and selectedDate
            //           return (
            //             addDate >= dateFromTime && addDate <= selectedDateTime
            //           );
            //         });

            //       setShiftInvoices(
            //         filteredData && filteredData?.length > 0 ? filteredData : []
            //       );

            //       const groupedData = {};
            //       filteredData &&
            //         filteredData?.length > 0 &&
            //         filteredData.forEach((invoice) => {
            //           const { businessName } = invoice?.customerDetails[0];

            //           if (!groupedData[businessName]) {
            //             groupedData[businessName] = [];
            //           }
            //           groupedData[businessName].push(invoice);
            //         });

            //       setEmployeeInvoices(groupedData);

            //       let selectedDateParts = endDate?.split("/");
            //       let dateFromParts = startDate?.split("/");

            //       // Create Date objects from the parsed components
            //       let selectedDateTime = new Date(
            //         parseInt(selectedDateParts[2]), // Year
            //         parseInt(selectedDateParts[1]), // Month (zero-based)
            //         parseInt(selectedDateParts[0]), // Day
            //         23, // Hours
            //         59, // Minutes
            //         59 // Seconds
            //       );

            //       let dateFromTime = new Date(
            //         parseInt(dateFromParts[2]), // Year
            //         parseInt(dateFromParts[1]), // Month (zero-based)
            //         parseInt(dateFromParts[0]), // Day
            //         0, // Hours
            //         0, // Minutes
            //         0 // Seconds
            //       );

            //       let dataToSend = {
            //         startDate: dateFromTime,
            //         endDate: selectedDateTime,
            //         id: employee?._id,
            //       };

            //       let expenseResponse = await fetchPaginatedData( `${Base_Uri}getDateWiseExpense`,dataToSend,token)

            //       // await axios.post(
            //       //   `${Base_Uri}getDateWiseExpense`,
            //       //   dataToSend,
            //       //   {
            //       //     headers: {
            //       //       "Content-Type": "application/json",
            //       //       Authorization: `Bearer ${token}`,
            //       //     },
            //       //   }
            //       // );

            //       let expenseData = expenseResponse;

            //       if (expenseData.status) {
            //         let allExpenses = expenseData.data;

            //         setUserExpenses(allExpenses);
            //       } else {
            //         message.info(expenseData.message);
            //         setLoading(false);
            //         return;
            //       }

            //       let CreditResponse = await fetchPaginatedData(`${Base_Uri}getDateWiseCredit`,dataToSend,token)

            //       // await axios.post(
            //       //   `${Base_Uri}getDateWiseCredit`,
            //       //   dataToSend,
            //       //   {
            //       //     headers: {
            //       //       "Content-Type": "application/json",
            //       //       Authorization: `Bearer ${token}`,
            //       //     },
            //       //   }
            //       // );

            //       let creditData = CreditResponse;

            //       if (creditData.status) {
            //         let allCredit = creditData.data;
            //         console.log(allCredit, "allCreidt");
            //         dispatch(updateShiftCreditPayment(allCredit));

            //         const mygroupedData = {};
            //         allCredit &&
            //           allCredit?.length > 0 &&
            //           allCredit.forEach((invoice) => {
            //             const { business_name } = invoice?.customerData;

            //             if (!mygroupedData[business_name]) {
            //               mygroupedData[business_name] = [];
            //             }
            //             mygroupedData[business_name].push(invoice);
            //           });

            //         setCreditPayment(mygroupedData);
            //       } else {
            //         message.info(creditData.message);
            //         setLoading(false);
            //         return;
            //       }

            //       let refundResponse =await fetchPaginatedData(`${Base_Uri}getDateWiseRefund`,dataToSend,token)

            //       // await axios.post(
            //       //   `${Base_Uri}getDateWiseRefund`,
            //       //   dataToSend,
            //       //   {
            //       //     headers: {
            //       //       "Content-Type": "application/json",
            //       //       Authorization: `Bearer ${token}`,
            //       //     },
            //       //   }
            //       // );

            //       let refundData = refundResponse.data;

            //       if (refundData.status) {
            //         let dayRefunds = refundData.data;

            //         setUserRefunds(dayRefunds);

            //         const groupedData = {};

            //         dayRefunds &&
            //           dayRefunds?.length > 0 &&
            //           dayRefunds.forEach((invoice) => {
            //             const { business_name } = invoice?.customerData;

            //             if (!groupedData[business_name]) {
            //               groupedData[business_name] = [];
            //             }
            //             groupedData[business_name].push(invoice);
            //           });

            //         setRefundInvoices(groupedData);

            //         setPdfDownloadView({
            //           ...pdfDownloadView,
            //           userSaleReport: true,
            //         });
            //          setPdfOpenViewState({
            // ...pdfOpenViewState,
            //           userSaleReport: true,
            //         });
            //         setLoading(false);
            //       } else {
            //         message.info(refundData.message);
            //         setLoading(false);
            //         return;
            //       }

            //       setLoading(false);

            //       return;
            //     }

            setShiftInvoices(data && data?.length > 0 ? data : []);

            const groupedData = {};
            data &&
              data?.length > 0 &&
              data.forEach((invoice) => {
                const { businessName } = invoice?.customerDetails[0];

                if (!groupedData[businessName]) {
                  groupedData[businessName] = [];
                }
                groupedData[businessName].push(invoice);
              });

            setEmployeeInvoices(groupedData);

            let createDate = new Date(employee.created_at);
             let selectedDateParts = endDate?.split("/");
        let dateFromParts = startDate?.split("/");

        // Create Date objects from the parsed components
        let selectedDateTime =endDate&& new Date(
          parseInt(selectedDateParts[2]), // Year
          parseInt(selectedDateParts[1]), // Month (zero-based)
          parseInt(selectedDateParts[0]), // Day
          23, // Hours
          59, // Minutes
          59 // Seconds
        );

        let dateFromTime =startDate&& new Date(
          parseInt(dateFromParts[2]), // Year
          parseInt(dateFromParts[1]), // Month (zero-based)
          parseInt(dateFromParts[0]), // Day
          0, // Hours
          0, // Minutes
          0 // Seconds
        );

            let dataToSend = {
              startDate: dateFromTime,
          endDate: selectedDateTime,
              id: employee?._id,
            };

            let expenseResponse = await fetchPaginatedData(
              `${Base_Uri}getDateWiseExpense`,
              dataToSend,
              token
            );

            //console.log(expenseResponse,"expenseResponse")

            let expenseData = expenseResponse;

            if (expenseData.status) {
              let allExpenses = expenseData.data;
              setUserExpenses(allExpenses);
            } else {
              message.info(expenseData.message);
              setLoading(false);
              return;
            }

            let CreditResponse = await fetchPaginatedData(
              `${Base_Uri}getDateWiseCredit`,
              dataToSend,
              token
            );
          

            let creditData = CreditResponse;

            if (creditData.status) {
              let allCredit = creditData.data;
              dispatch(updateShiftCreditPayment(allCredit));

              const mygroupedData = {};
              allCredit &&
                allCredit?.length > 0 &&
                allCredit.forEach((invoice) => {
                  const business_name = invoice?.customerData?.business_name;

                  if (!mygroupedData[business_name]) {
                    mygroupedData[business_name] = [];
                  }
                  mygroupedData[business_name].push(invoice);
                });

              setCreditPayment(mygroupedData);
            } else {
              message.info(creditData.message);
              setLoading(false);
              return;
            }

            let refundResponse = await fetchPaginatedData(
              `${Base_Uri}getDateWiseRefund`,
              dataToSend,
              token
            );

            let refundData = refundResponse;

            if (refundData.status) {
              let dayRefunds = refundData.data;

              setUserRefunds(dayRefunds);

              const groupedData = {};

              dayRefunds &&
                dayRefunds?.length > 0 &&
                dayRefunds.forEach((invoice) => {
                  const business_name = invoice?.customerData?.business_name;

                  if (!groupedData[business_name]) {
                    groupedData[business_name] = [];
                  }
                  groupedData[business_name].push(invoice);
                });

              setRefundInvoices(groupedData);

              setPdfDownloadView({
                ...pdfDownloadView,
                userSaleReport: true,
              });
              setPdfOpenViewState({
                ...pdfOpenViewState,
                userSaleReport: true,
              });
              setLoading(false);
            } else {
              message.info(refundData.message);
              setLoading(false);
              return;
            }

            setLoading(false);
          } else {
            setLoading(false);
            message.info(myData?.message);
          }
        } catch (err) {
          //console.log(err, "error");
          message.info(err?.message);
          setLoading(false);
          return;
        }
      }
      // if (token) {
      //   try {
      //     let employee = employees.find((e) => e.full_name == selectedEmployee);
      //     let allEmploInvoices = await fetchPaginatedDataWithQuery(`${Base_Uri}getAllTypesInvoices`,token,{
      //       employeeIdd:employee?._id
      //     })

      //     //console.log(allEmploInvoices,"allEmploInvoices")

      //     axios
      //       .get(`${Base_Uri}getEmployeeInvoices/${employee?._id}`, {
      //         headers: {
      //           Authorization: `Bearer ${token}`,
      //           "Content-Type": "application/json", // Include other headers as needed
      //         },
      //       })
      //       .then(async (res) => {
      //         let myData = res.data;

      //         if (myData?.status) {
      //           let { data } = myData;

      //           if (searchDate?.selected) {
      //             let filteredData =
      //               data &&
      //               data?.length > 0 &&
      //               data?.filter((e, i) => {
      //                 let date = e?.saleDate
      //                   ? e?.saleDate
      //                   : e?.saleReturnDate
      //                   ? e?.saleReturnDate
      //                   : e?.exchangeDate;

      //                 let addDate = new Date(date);

      //                 // Parse selectedDate and dateFrom
      //                 let selectedDateParts = endDate?.split("/");
      //                 let dateFromParts = startDate?.split("/");

      //                 // Create Date objects from the parsed components
      //                 let selectedDateTime = new Date(
      //                   parseInt(selectedDateParts[2]), // Year
      //                   parseInt(selectedDateParts[1]), // Month (zero-based)
      //                   parseInt(selectedDateParts[0]), // Day
      //                   23, // Hours
      //                   59, // Minutes
      //                   59 // Seconds
      //                 );

      //                 let dateFromTime = new Date(
      //                   parseInt(dateFromParts[2]), // Year
      //                   parseInt(dateFromParts[1]), // Month (zero-based)
      //                   parseInt(dateFromParts[0]), // Day
      //                   0, // Hours
      //                   0, // Minutes
      //                   0 // Seconds
      //                 );

      //                 // Check if addDate is between dateFrom and selectedDate
      //                 return (
      //                   addDate >= dateFromTime && addDate <= selectedDateTime
      //                 );
      //               });

      //             setShiftInvoices(
      //               filteredData && filteredData?.length > 0 ? filteredData : []
      //             );

      //             const groupedData = {};
      //             filteredData &&
      //               filteredData?.length > 0 &&
      //               filteredData.forEach((invoice) => {
      //                 const { businessName } = invoice?.customerDetails[0];

      //                 if (!groupedData[businessName]) {
      //                   groupedData[businessName] = [];
      //                 }
      //                 groupedData[businessName].push(invoice);
      //               });

      //             setEmployeeInvoices(groupedData);

      //             let selectedDateParts = endDate?.split("/");
      //             let dateFromParts = startDate?.split("/");

      //             // Create Date objects from the parsed components
      //             let selectedDateTime = new Date(
      //               parseInt(selectedDateParts[2]), // Year
      //               parseInt(selectedDateParts[1]), // Month (zero-based)
      //               parseInt(selectedDateParts[0]), // Day
      //               23, // Hours
      //               59, // Minutes
      //               59 // Seconds
      //             );

      //             let dateFromTime = new Date(
      //               parseInt(dateFromParts[2]), // Year
      //               parseInt(dateFromParts[1]), // Month (zero-based)
      //               parseInt(dateFromParts[0]), // Day
      //               0, // Hours
      //               0, // Minutes
      //               0 // Seconds
      //             );

      //             let dataToSend = {
      //               startDate: dateFromTime,
      //               endDate: selectedDateTime,
      //               id: employee?._id,
      //             };

      //             let expenseResponse = await axios.post(
      //               `${Base_Uri}getDateWiseExpense`,
      //               dataToSend,
      //               {
      //                 headers: {
      //                   "Content-Type": "application/json",
      //                   Authorization: `Bearer ${token}`,
      //                 },
      //               }
      //             );

      //             let expenseData = expenseResponse.data;

      //             if (expenseData.status) {
      //               let allExpenses = expenseData.data;

      //               setUserExpenses(allExpenses);
      //             } else {
      //               message.info(expenseData.message);
      //               setLoading(false);
      //               return;
      //             }

      //             let CreditResponse = await axios.post(
      //               `${Base_Uri}getDateWiseCredit`,
      //               dataToSend,
      //               {
      //                 headers: {
      //                   "Content-Type": "application/json",
      //                   Authorization: `Bearer ${token}`,
      //                 },
      //               }
      //             );

      //             let creditData = CreditResponse.data;

      //             if (creditData.status) {
      //               let allCredit = creditData.data;
      //               //console.log(allCredit, "allCreidt");
      //               dispatch(updateShiftCreditPayment(allCredit));

      //               const mygroupedData = {};
      //               allCredit &&
      //                 allCredit?.length > 0 &&
      //                 allCredit.forEach((invoice) => {
      //                   const { business_name } = invoice?.customerData;

      //                   if (!mygroupedData[business_name]) {
      //                     mygroupedData[business_name] = [];
      //                   }
      //                   mygroupedData[business_name].push(invoice);
      //                 });

      //               setCreditPayment(mygroupedData);
      //             } else {
      //               message.info(creditData.message);
      //               setLoading(false);
      //               return;
      //             }

      //             let refundResponse = await axios.post(
      //               `${Base_Uri}getDateWiseRefund`,
      //               dataToSend,
      //               {
      //                 headers: {
      //                   "Content-Type": "application/json",
      //                   Authorization: `Bearer ${token}`,
      //                 },
      //               }
      //             );

      //             let refundData = refundResponse.data;

      //             if (refundData.status) {
      //               let dayRefunds = refundData.data;

      //               setUserRefunds(dayRefunds);

      //               const groupedData = {};

      //               dayRefunds &&
      //                 dayRefunds?.length > 0 &&
      //                 dayRefunds.forEach((invoice) => {
      //                   const { business_name } = invoice?.customerData;

      //                   if (!groupedData[business_name]) {
      //                     groupedData[business_name] = [];
      //                   }
      //                   groupedData[business_name].push(invoice);
      //                 });

      //               setRefundInvoices(groupedData);

      //               setPdfDownloadView({
      //                 ...pdfDownloadView,
      //                 userSaleReport: true,
      //               });
      //                setPdfOpenViewState({
      //       ...pdfOpenViewState,
      //                 userSaleReport: true,
      //               });
      //               setLoading(false);
      //             } else {
      //               message.info(refundData.message);
      //               setLoading(false);
      //               return;
      //             }

      //             setLoading(false);

      //             return;
      //           }

      //           setShiftInvoices(data && data?.length > 0 ? data : []);

      //           const groupedData = {};
      //           data &&
      //             data?.length > 0 &&
      //             data.forEach((invoice) => {
      //               const { businessName } = invoice?.customerDetails[0];

      //               if (!groupedData[businessName]) {
      //                 groupedData[businessName] = [];
      //               }
      //               groupedData[businessName].push(invoice);
      //             });

      //           setEmployeeInvoices(groupedData);

      //           let createDate = new Date(employee.created_at);

      //           let dataToSend = {
      //             startDate: createDate,
      //             endDate: new Date(),
      //             id: employee?._id,
      //           };

      //           let expenseResponse = await axios.post(
      //             `${Base_Uri}getDateWiseExpense`,
      //             dataToSend,
      //             {
      //               headers: {
      //                 "Content-Type": "application/json",
      //                 Authorization: `Bearer ${token}`,
      //               },
      //             }
      //           );

      //           let expenseData = expenseResponse.data;

      //           if (expenseData.status) {
      //             let allExpenses = expenseData.data;
      //             setUserExpenses(allExpenses);
      //           } else {
      //             message.info(expenseData.message);
      //             setLoading(false);
      //             return;
      //           }

      //           let CreditResponse = await axios.post(
      //             `${Base_Uri}getDateWiseCredit`,
      //             dataToSend,
      //             {
      //               headers: {
      //                 "Content-Type": "application/json",
      //                 Authorization: `Bearer ${token}`,
      //               },
      //             }
      //           );

      //           let creditData = CreditResponse.data;

      //           if (creditData.status) {
      //             let allCredit = creditData.data;
      //             dispatch(updateShiftCreditPayment(allCredit));

      //             const mygroupedData = {};
      //             allCredit &&
      //               allCredit?.length > 0 &&
      //               allCredit.forEach((invoice) => {
      //                 const { business_name } = invoice?.customerData;

      //                 if (!mygroupedData[business_name]) {
      //                   mygroupedData[business_name] = [];
      //                 }
      //                 mygroupedData[business_name].push(invoice);
      //               });

      //             setCreditPayment(mygroupedData);
      //           } else {
      //             message.info(creditData.message);
      //             setLoading(false);
      //             return;
      //           }

      //           let refundResponse = await axios.post(
      //             `${Base_Uri}getDateWiseRefund`,
      //             dataToSend,
      //             {
      //               headers: {
      //                 "Content-Type": "application/json",
      //                 Authorization: `Bearer ${token}`,
      //               },
      //             }
      //           );

      //           let refundData = refundResponse.data;

      //           if (refundData.status) {
      //             let dayRefunds = refundData.data;

      //             setUserRefunds(dayRefunds);

      //             const groupedData = {};

      //             dayRefunds &&
      //               dayRefunds?.length > 0 &&
      //               dayRefunds.forEach((invoice) => {
      //                 const { business_name } = invoice?.customerData;

      //                 if (!groupedData[business_name]) {
      //                   groupedData[business_name] = [];
      //                 }
      //                 groupedData[business_name].push(invoice);
      //               });

      //             setRefundInvoices(groupedData);

      //             setPdfDownloadView({
      //               ...pdfDownloadView,
      //               userSaleReport: true,
      //             });
      //              setPdfOpenViewState({
      //       ...pdfOpenViewState,
      //               userSaleReport: true,
      //             });
      //             setLoading(false);
      //           } else {
      //             message.info(refundData.message);
      //             setLoading(false);
      //             return;
      //           }

      //           setLoading(false);
      //         } else {
      //           setLoading(false);
      //           message.info(myData?.message);
      //         }
      //       })
      //       .catch((error) => {
      //         message.info(error?.message);
      //         //console.log(error, "error");
      //         setLoading(false);
      //       });
      //   } catch (err) {
      //     message.info("Internal Server Error");
      //     return;
      //   }
      // }
    } else if (
      selectedReportType?.toLowerCase() === "sales report (date range)"
    ) {
      if (!startDate) {
        message.info("Start Date is missing");
        return;
      }

      if (!endDate) {
        message.info("End Date is missing");
        return;
      }

      setLoading(true);

      try {
        let data = await sessionStorage.getItem("userData");
        data = JSON.parse(data);
        let token = data;

        const res = await fetchPaginatedDataWithQuery(
          `${Base_Uri}getAllTypesInvoices`,
          token,
          {
            startDate: startDate,
            endDate: endDate,
            invoiceType: "sales",
          }
        );
        //console.log(res, "res");

        if (!res?.status) {
          setLoading(false);
          message.info(res.message);
          return;
        }

        let { data: invoiceData } = res;
        //console.log(invoiceData, "invoice||Data");
        let filteredData =
          invoiceData &&
          invoiceData.length > 0 &&
          invoiceData.filter((e) => {
            let date = e?.saleDate || e?.saleReturnDate || e?.exchangeDate;
            let addDate = new Date(date);

            let selectedDateParts = endDate.split("/");
            let dateFromParts = startDate.split("/");

            let selectedDateTime = new Date(
              parseInt(selectedDateParts[2]),
              parseInt(selectedDateParts[1]),
              parseInt(selectedDateParts[0]),
              23,
              59,
              59
            );

            let dateFromTime = new Date(
              parseInt(dateFromParts[2]),
              parseInt(dateFromParts[1]),
              parseInt(dateFromParts[0]),
              0,
              0,
              0
            );

            return addDate >= dateFromTime && addDate <= selectedDateTime;
          });
        filteredData = filteredData.reverse();
        //console.log(filteredData, "filteredData");
        setAllUngroupedInvoice(
          filteredData && filteredData.length > 0 ? filteredData : []
        );

        const groupedData = {};

        if (filteredData && filteredData.length > 0) {
          await Promise.all(
            filteredData.map(async (invoice) => {
              let dateKey;
              if (invoice?.saleDate) {
                const date = new Date(invoice.saleDate);
                date.setHours(0, 0, 0, 0);
                dateKey = date.toISOString();
              } else if (invoice?.saleReturnDate) {
                const date = new Date(invoice.saleReturnDate);
                date.setHours(0, 0, 0, 0);
                dateKey = date.toISOString();
              } else if (invoice?.exchangeDate) {
                const date = new Date(invoice.exchangeDate);
                date.setHours(0, 0, 0, 0);
                dateKey = date.toISOString();
              }

              if (!groupedData[dateKey]) {
                groupedData[dateKey] = [];
              }
              groupedData[dateKey].push(invoice);
            })
          );
        }
        //console.log(groupedData, "groupedData");
        setAllInvoices(groupedData);
        // [].reverse

        setPdfDownloadView({
          ...pdfDownloadView,
          saleReportBetweenDates: true,
        });
        setPdfOpenViewState({
          ...pdfOpenViewState,
          saleReportBetweenDates: true,
        });
      } catch (error) {
        //console.log(error, "error");
        message.info(error?.message);
      } finally {
        setLoading(false);
      }
    } else if (
      selectedReportType?.toLowerCase() ==
      "net sales report (after expenses)"
    ) {
      if (!startDate) {
        message.info("Start Date is missing");
        return;
      }

      if (!endDate) {
        message.info("End Date is missing");
        return;
      }

      setLoading(true);

      try {
        let data = await sessionStorage.getItem("userData");
        data = JSON.parse(data);
        let token = data;

        const res = await fetchPaginatedDataWithQuery(
          `${Base_Uri}getAllTypesInvoices`,
          token,
          {
            startDate: startDate,
            endDate: endDate,
            invoiceType: "sales",
          }
        );
        //console.log(res, "res");

        if (!res?.status) {
          setLoading(false);
          message.info(res.message);
          return;
        }

        let { data: invoiceData } = res;
        //console.log(invoiceData, "invoice||Data");
        let filteredData =
          invoiceData &&
          invoiceData.length > 0 &&
          invoiceData.filter((e) => {
            let date = e?.saleDate || e?.saleReturnDate || e?.exchangeDate;
            let addDate = new Date(date);

            let selectedDateParts = endDate.split("/");
            let dateFromParts = startDate.split("/");

            let selectedDateTime = new Date(
              parseInt(selectedDateParts[2]),
              parseInt(selectedDateParts[1]),
              parseInt(selectedDateParts[0]),
              23,
              59,
              59
            );

            let dateFromTime = new Date(
              parseInt(dateFromParts[2]),
              parseInt(dateFromParts[1]),
              parseInt(dateFromParts[0]),
              0,
              0,
              0
            );

            return addDate >= dateFromTime && addDate <= selectedDateTime;
          });
        filteredData = filteredData.reverse();
        //console.log(filteredData, "filteredData");
        setAllUngroupedInvoice(
          filteredData && filteredData.length > 0 ? filteredData : []
        );

        const groupedData = {};

        if (filteredData && filteredData.length > 0) {
          await Promise.all(
            filteredData.map(async (invoice) => {
              let dateKey;
              if (invoice?.saleDate) {
                const date = new Date(invoice.saleDate);
                date.setHours(0, 0, 0, 0);
                dateKey = date.toISOString();
              } else if (invoice?.saleReturnDate) {
                const date = new Date(invoice.saleReturnDate);
                date.setHours(0, 0, 0, 0);
                dateKey = date.toISOString();
              } else if (invoice?.exchangeDate) {
                const date = new Date(invoice.exchangeDate);
                date.setHours(0, 0, 0, 0);
                dateKey = date.toISOString();
              }

              if (!groupedData[dateKey]) {
                groupedData[dateKey] = [];
              }
              groupedData[dateKey].push(invoice);
            })
          );
        }
        //console.log(groupedData, "groupedData");
        setAllInvoices(groupedData);
        // [].reverse

        setPdfDownloadView({
          ...pdfDownloadView,
          saleReportBetweenDatesAfterExpenses: true,
        });
        setPdfOpenViewState({
          ...pdfOpenViewState,
          saleReportBetweenDatesAfterExpenses: true,
        });
      } catch (error) {
        //console.log(error, "error");
        message.info(error?.message);
      } finally {
        setLoading(false);
      }
    } else if (
      selectedReportType?.toLowerCase() ==
      "product sales report for selected customer"
    ) {
      if (!selectedCustomer) {
        message.info("Kindly Select Customer");
        return;
      }

      if (searchDate?.selected && !startDate) {
        message.info("Start Date is missing");
        return;
      }

      if (searchDate?.selected && !endDate) {
        message.info("End Date is missing");
        return;
      }

      setLoading(true);

      try {
        let datas = await sessionStorage.getItem("userData");
        datas = JSON.parse(datas);
        let token = datas;
        let qu = {};
        if (searchDate?.selected && startDate && endDate) {
          qu.startDate = startDate;
          qu.endDate = endDate;
        }
        let res = await fetchPaginatedDataWithQuery(
          `${Base_Uri}getAllTypesInvoices`,
          token,
          {
            CustomerId: selectedCustomer?.id,
            ...qu,
          }
        );
        if (!res?.status) {
          setLoading(false);
          message.info(res.message);
          return;
        }

        let { data } = res;

        let sortData =
          data &&
          data?.length > 0 &&
          data?.sort((a, b) => {
            return (
              new Date(
                a?.saleDate
                  ? a?.saleDate
                  : a?.saleReturnDate
                  ? a?.saleReturnDate
                  : a?.exchangeDate
              ).getTime() -
              new Date(
                b?.saleDate
                  ? b?.saleDate
                  : b?.saleReturnDate
                  ? b?.saleReturnDate
                  : b?.exchangeDate
              ).getTime()
            );
          });

        setCustomerInvoices(sortData && sortData?.length > 0 ? sortData : []);

        setPdfDownloadView({
          ...pdfDownloadView,
          productSaleReportForSelectedCustomer: true,
        });
        setPdfOpenViewState({
          ...pdfOpenViewState,
          productSaleReportForSelectedCustomer: true,
        });
        setLoading(false);
      } catch (error) {
        message.info(error?.message);
      }

      // let data = await sessionStorage.getItem("userData");
      // data = JSON.parse(data);
      // let token = data;

      // axios
      //   .get(`${Base_Uri}getCustomerInvoices/${selectedCustomer?.id}`, {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //       "Content-Type": "application/json", // Include other headers as needed
      //     },
      //   })
      // .then(async (res) => {
      //   if (!res?.status) {
      //     setLoading(false);
      //     message.info(res.message);
      //     return;
      //   }

      //   let { data } = res.data;

      //   if (searchDate?.selected) {
      //     let filteredData =
      //       data &&
      //       data?.length > 0 &&
      //       data?.filter((e, i) => {
      //         let addDate = new Date(
      //           e?.saleDate
      //             ? e?.saleDate
      //             : e?.saleReturnDate
      //             ? e?.saleReturnDate
      //             : e?.exchangeDate
      //         );

      //         let selectedDateParts = endDate?.split("/");
      //         let dateFromParts = startDate?.split("/");

      //         let selectedDateTime = new Date(
      //           parseInt(selectedDateParts[2]), // Year
      //           parseInt(selectedDateParts[1]), // Month (zero-based)
      //           parseInt(selectedDateParts[0]), // Day
      //           23, // Hours
      //           59, // Minutes
      //           59 // Seconds
      //         );

      //         let dateFromTime = new Date(
      //           parseInt(dateFromParts[2]), // Year
      //           parseInt(dateFromParts[1]), // Month (zero-based)
      //           parseInt(dateFromParts[0]), // Day
      //           0, // Hours
      //           0, // Minutes
      //           0 // Seconds
      //         );

      //         return addDate >= dateFromTime && addDate <= selectedDateTime;
      //       });

      //     let sortData =
      //       filteredData &&
      //       filteredData?.length > 0 &&
      //       filteredData?.sort((a, b) => {
      //         return (
      //           new Date(
      //             a?.saleDate
      //               ? a?.saleDate
      //               : a?.saleReturnDate
      //               ? a?.saleReturnDate
      //               : a?.exchangeDate
      //           ).getTime() -
      //           new Date(
      //             b?.saleDate
      //               ? b?.saleDate
      //               : b?.saleReturnDate
      //               ? b?.saleReturnDate
      //               : b?.exchangeDate
      //           ).getTime()
      //         );
      //       });

      //     setCustomerInvoices(sortData);

      //     setPdfDownloadView({
      //       ...pdfDownloadView,
      //       productSaleReportForSelectedCustomer: true,
      //     });
      //      setPdfOpenViewState({
      //     ...pdfOpenViewState,
      //       productSaleReportForSelectedCustomer: true,
      //     });
      //     setLoading(false);

      //     return;
      //   }

      //   let sortData =
      //     data &&
      //     data?.length > 0 &&
      //     data?.sort((a, b) => {
      //       return (
      //         new Date(
      //           a?.saleDate
      //             ? a?.saleDate
      //             : a?.saleReturnDate
      //             ? a?.saleReturnDate
      //             : a?.exchangeDate
      //         ).getTime() -
      //         new Date(
      //           b?.saleDate
      //             ? b?.saleDate
      //             : b?.saleReturnDate
      //             ? b?.saleReturnDate
      //             : b?.exchangeDate
      //         ).getTime()
      //       );
      //     });

      //   setCustomerInvoices(sortData && sortData?.length > 0 ? sortData : []);

      //   setPdfDownloadView({
      //     ...pdfDownloadView,
      //     productSaleReportForSelectedCustomer: true,
      //   });
      //    setPdfOpenViewState({
      //     ...pdfOpenViewState,
      //     productSaleReportForSelectedCustomer: true,
      //   });
      //   setLoading(false);
      // })
      // .catch((error) => {
      //   message.info(error?.message);
      // });
    } else if (
      selectedReportType?.toLowerCase() ==
      "product sales & profit report for selected customer"
    ) {
      if (!selectedCustomer) {
        message.info("Kindly Select Customer");
        return;
      }

      if (searchDate?.selected && !startDate) {
        message.info("Start Date is missing");
        return;
      }

      if (searchDate?.selected && !endDate) {
        message.info("End Date is missing");
        return;
      }

      setLoading(true);

      try {
        let datas = await sessionStorage.getItem("userData");
        datas = JSON.parse(datas);
        let token = datas;
        let qu = {};
        if (searchDate?.selected && startDate && endDate) {
          qu.startDate = startDate;
          qu.endDate = endDate;
        }
        let res = await fetchPaginatedDataWithQuery(
          `${Base_Uri}getAllTypesInvoices`,
          token,
          {
            CustomerId: selectedCustomer?.id,
            ...qu,
          }
        );
        if (!res?.status) {
          setLoading(false);
          message.info(res.message);
          return;
        }

        let { data } = res;

        let sortData =
          data &&
          data?.length > 0 &&
          data?.sort((a, b) => {
            return (
              new Date(
                a?.saleDate
                  ? a?.saleDate
                  : a?.saleReturnDate
                  ? a?.saleReturnDate
                  : a?.exchangeDate
              ).getTime() -
              new Date(
                b?.saleDate
                  ? b?.saleDate
                  : b?.saleReturnDate
                  ? b?.saleReturnDate
                  : b?.exchangeDate
              ).getTime()
            );
          });

        setCustomerInvoices(sortData && sortData?.length > 0 ? sortData : []);

        setPdfDownloadView({
          ...pdfDownloadView,
          ProductSaleReportForSelectedCustomerWithProfit: true,
        });
        setPdfOpenViewState({
          ...pdfOpenViewState,
          ProductSaleReportForSelectedCustomerWithProfit: true,
        });
        setLoading(false);
      } catch (error) {
        message.info(error?.message);
      }

      // let data = await sessionStorage.getItem("userData");
      // data = JSON.parse(data);
      // let token = data;

      // axios
      //   .get(`${Base_Uri}getCustomerInvoices/${selectedCustomer?.id}`, {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //       "Content-Type": "application/json", // Include other headers as needed
      //     },
      //   })
      //   .then(async (res) => {
      //     if (!res?.status) {
      //       setLoading(false);
      //       message.info(res.message);
      //       return;
      //     }

      //     let { data } = res.data;

      //     if (searchDate?.selected) {
      //       let filteredData =
      //         data &&
      //         data?.length > 0 &&
      //         data?.filter((e, i) => {
      //           let addDate = new Date(
      //             e?.saleDate
      //               ? e?.saleDate
      //               : e?.saleReturnDate
      //               ? e?.saleReturnDate
      //               : e?.exchangeDate
      //           );

      //           let selectedDateParts = endDate?.split("/");
      //           let dateFromParts = startDate?.split("/");

      //           let selectedDateTime = new Date(
      //             parseInt(selectedDateParts[2]), // Year
      //             parseInt(selectedDateParts[1]), // Month (zero-based)
      //             parseInt(selectedDateParts[0]), // Day
      //             23, // Hours
      //             59, // Minutes
      //             59 // Seconds
      //           );

      //           let dateFromTime = new Date(
      //             parseInt(dateFromParts[2]), // Year
      //             parseInt(dateFromParts[1]), // Month (zero-based)
      //             parseInt(dateFromParts[0]), // Day
      //             0, // Hours
      //             0, // Minutes
      //             0 // Seconds
      //           );

      //           return addDate >= dateFromTime && addDate <= selectedDateTime;
      //         });

      //       let sortData =
      //         filteredData &&
      //         filteredData?.length > 0 &&
      //         filteredData?.sort((a, b) => {
      //           return (
      //             new Date(
      //               a?.saleDate
      //                 ? a?.saleDate
      //                 : a?.saleReturnDate
      //                 ? a?.saleReturnDate
      //                 : a?.exchangeDate
      //             ).getTime() -
      //             new Date(
      //               b?.saleDate
      //                 ? b?.saleDate
      //                 : b?.saleReturnDate
      //                 ? b?.saleReturnDate
      //                 : b?.exchangeDate
      //             ).getTime()
      //           );
      //         });

      //       setCustomerInvoices(sortData);

      //       setPdfDownloadView({
      //         ...pdfDownloadView,
      //         ProductSaleReportForSelectedCustomerWithProfit: true,
      //       });
      //        setPdfOpenViewState({
      //       ...pdfOpenViewState,
      //         ProductSaleReportForSelectedCustomerWithProfit: true,
      //       });
      //       setLoading(false);

      //       return;
      //     }

      //     let sortData =
      //       data &&
      //       data?.length > 0 &&
      //       data?.sort((a, b) => {
      //         return (
      //           new Date(
      //             a?.saleDate
      //               ? a?.saleDate
      //               : a?.saleReturnDate
      //               ? a?.saleReturnDate
      //               : a?.exchangeDate
      //           ).getTime() -
      //           new Date(
      //             b?.saleDate
      //               ? b?.saleDate
      //               : b?.saleReturnDate
      //               ? b?.saleReturnDate
      //               : b?.exchangeDate
      //           ).getTime()
      //         );
      //       });

      //     setCustomerInvoices(sortData && sortData?.length > 0 ? sortData : []);

      //     setPdfDownloadView({
      //       ...pdfDownloadView,
      //       ProductSaleReportForSelectedCustomerWithProfit: true,
      //     });
      //      setPdfOpenViewState({
      //       ...pdfOpenViewState,
      //       ProductSaleReportForSelectedCustomerWithProfit: true,
      //     });
      //     setLoading(false);
      //   })
      //   .catch((error) => {
      //     message.info(error?.message);
      //   });
    } else if (
      selectedReportType?.toLowerCase() ==
      "customer-specific product sales report"
    ) {
      if (!selectedCustomer) {
        message.info("Kindly Select Customer");
        return;
      }

      if (!selectedProduct) {
        message.info("Kindly Select Product");
        return;
      }

      if (searchDate?.selected && !startDate) {
        message.info("Start Date is missing");
        return;
      }

      if (searchDate?.selected && !endDate) {
        message.info("End Date is missing");
        return;
      }

      setLoading(true);

      try {
        let datas = await sessionStorage.getItem("userData");
        datas = JSON.parse(datas);
        let token = datas;

        let qu = {};
        if (searchDate?.selected && startDate && endDate) {
          qu.startDate = startDate;
          qu.endDate = endDate;
        }
        let res = await fetchPaginatedDataWithQuery(
          `${Base_Uri}getAllTypesInvoices`,
          token,
          {
            CustomerId: selectedCustomer?.id,
            ...qu,
            byBarcode: selectedProduct?.barcode,
          }
        );
        if (!res?.status) {
          setLoading(false);
          message.info(res.message);
          return;
        }

        let { data } = res;

        //  data = data.map((e)=>{

        //     //  let { productDetails } = e;

        //     //   let { returnProductDetails } = e;

        //       let selectedProductData =
        //         e?.productDetails &&
        //         e?.productDetails?.length > 0 &&
        //         e?.productDetails?.filter((j) => {
        //           if (j?.barcode == selectedProduct?.barcode) {
        //             return j;
        //           }
        //         });

        //       let selectedReturnProductData =
        //         e?.returnProductDetails &&
        //         e?.returnProductDetails?.length > 0 &&
        //         e?.returnProductDetails?.filter((j) => {
        //           if (j?.barcode == selectedProduct?.barcode) {
        //             return j;
        //           }
        //         });

        //       if (selectedProductData?.length > 0) {
        //         e.productDetails = selectedProductData;
        //       }
        //      if (selectedReturnProductData?.length > 0) {
        //        e.returnProductDetails = selectedReturnProductData;
        //      }

        //  })

        // if (searchDate?.selected) {
        //   let selectedProducts =
        //     data &&
        //     data?.length > 0 &&
        //     data?.filter((e, i) => {
        //       let { productDetails } = e;

        //       let { returnProductDetails } = e;

        //       let selectedProductData =
        //         productDetails &&
        //         productDetails?.length > 0 &&
        //         productDetails?.filter((j) => {
        //           if (j?.barcode == selectedProduct?.barcode) {
        //             return j;
        //           }
        //         });

        //       let selectedReturnProductData =
        //         returnProductDetails &&
        //         returnProductDetails?.length > 0 &&
        //         returnProductDetails?.filter((j) => {
        //           if (j?.barcode == selectedProduct?.barcode) {
        //             return j;
        //           }
        //         });

        //       e.productDetails = selectedProductData;
        //       e.returnProductDetails = selectedReturnProductData;

        //       if (
        //         (e?.productDetails && e?.productDetails?.length > 0) ||
        //         (e?.returnProductDetails &&
        //           e?.returnProductDetails?.length > 0)
        //       ) {
        //         return e;
        //       }
        //     });

        //   let filteredData =
        //     selectedProducts &&
        //     selectedProducts?.length > 0 &&
        //     selectedProducts?.filter((e, i) => {
        //       let addDate = new Date(
        //         e?.saleDate
        //           ? e?.saleDate
        //           : e?.saleReturnDate
        //           ? e?.saleReturnDate
        //           : e?.exchangeDate
        //       );

        //       let selectedDateParts = endDate?.split("/");
        //       let dateFromParts = startDate?.split("/");

        //       let selectedDateTime = new Date(
        //         parseInt(selectedDateParts[2]), // Year
        //         parseInt(selectedDateParts[1]), // Month (zero-based)
        //         parseInt(selectedDateParts[0]), // Day
        //         23, // Hours
        //         59, // Minutes
        //         59 // Seconds
        //       );

        //       let dateFromTime = new Date(
        //         parseInt(dateFromParts[2]), // Year
        //         parseInt(dateFromParts[1]), // Month (zero-based)
        //         parseInt(dateFromParts[0]), // Day
        //         0, // Hours
        //         0, // Minutes
        //         0 // Seconds
        //       );

        //       return addDate >= dateFromTime && addDate <= selectedDateTime;
        //     });

        //   let sortData =
        //     filteredData &&
        //     filteredData?.length > 0 &&
        //     filteredData?.sort((a, b) => {
        //       return (
        //         new Date(
        //           a?.saleDate
        //             ? a?.saleDate
        //             : a?.saleReturnDate
        //             ? a?.saleReturnDate
        //             : a?.exchangeDate
        //         ).getTime() -
        //         new Date(
        //           b?.saleDate
        //             ? b?.saleDate
        //             : b?.saleReturnDate
        //             ? b?.saleReturnDate
        //             : b?.exchangeDate
        //         ).getTime()
        //       );
        //     });

        //   setCustomerProductsSale(sortData);

        //   setPdfDownloadView({
        //     ...pdfDownloadView,
        //     customerSpecificProductSaleReport: true,
        //   });
        //   setPdfOpenViewState({
        //   ...pdfOpenViewState,
        //     customerSpecificProductSaleReport: true,
        //   });
        //   setLoading(false);

        //   return;
        // }

        data =
          data &&
          data?.length > 0 &&
          data?.filter((e, i) => {
            let { productDetails } = e;

            let { returnProductDetails } = e;

            let selectedProductData =
              productDetails &&
              productDetails?.length > 0 &&
              productDetails?.filter((j) => {
                if (j?.barcode == selectedProduct?.barcode) {
                  return j;
                }
              });

            let selectedReturnProductData =
              returnProductDetails &&
              returnProductDetails?.length > 0 &&
              returnProductDetails?.filter((j) => {
                if (j?.barcode == selectedProduct?.barcode) {
                  return j;
                }
              });

            e.productDetails = selectedProductData;
            e.returnProductDetails = selectedReturnProductData;

            if (
              (e?.productDetails && e?.productDetails?.length > 0) ||
              (e?.returnProductDetails && e?.returnProductDetails?.length > 0)
            ) {
              return e;
            }
          });

        // let sortData =
        //   selectedProducts &&
        //   selectedProducts?.length > 0 &&
        //   selectedProducts?.sort((a, b) => {
        //     return (
        //       new Date(
        //         a?.saleDate
        //           ? a?.saleDate
        //           : a?.saleReturnDate
        //           ? a?.saleReturnDate
        //           : a?.exchangeDate
        //       ).getTime() -
        //       new Date(
        //         b?.saleDate
        //           ? b?.saleDate
        //           : b?.saleReturnDate
        //           ? b?.saleReturnDate
        //           : b?.exchangeDate
        //       ).getTime()
        //     );
        //   });

        setCustomerProductsSale(data && data?.length > 0 ? data : []);

        setPdfDownloadView({
          ...pdfDownloadView,
          customerSpecificProductSaleReport: true,
        });
        setPdfOpenViewState({
          ...pdfOpenViewState,
          customerSpecificProductSaleReport: true,
        });
        setLoading(false);
      } catch (error) {
        message.info(error?.message);
      }

      // axios
      //   .get(`${Base_Uri}getCustomerInvoices/${selectedCustomer?.id}`, {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //       "Content-Type": "application/json", // Include other headers as needed
      //     },
      //   })
      //   .then(async (res) => {
      //     if (!res?.status) {
      //       setLoading(false);
      //       message.info(res.message);
      //       return;
      //     }

      //     let { data } = res.data;

      //     if (searchDate?.selected) {
      //       let selectedProducts =
      //         data &&
      //         data?.length > 0 &&
      //         data?.filter((e, i) => {
      //           let { productDetails } = e;

      //           let { returnProductDetails } = e;

      //           let selectedProductData =
      //             productDetails &&
      //             productDetails?.length > 0 &&
      //             productDetails?.filter((j) => {
      //               if (j?.barcode == selectedProduct?.barcode) {
      //                 return j;
      //               }
      //             });

      //           let selectedReturnProductData =
      //             returnProductDetails &&
      //             returnProductDetails?.length > 0 &&
      //             returnProductDetails?.filter((j) => {
      //               if (j?.barcode == selectedProduct?.barcode) {
      //                 return j;
      //               }
      //             });

      //           e.productDetails = selectedProductData;
      //           e.returnProductDetails = selectedReturnProductData;

      //           if (
      //             (e?.productDetails && e?.productDetails?.length > 0) ||
      //             (e?.returnProductDetails &&
      //               e?.returnProductDetails?.length > 0)
      //           ) {
      //             return e;
      //           }
      //         });

      //       let filteredData =
      //         selectedProducts &&
      //         selectedProducts?.length > 0 &&
      //         selectedProducts?.filter((e, i) => {
      //           let addDate = new Date(
      //             e?.saleDate
      //               ? e?.saleDate
      //               : e?.saleReturnDate
      //               ? e?.saleReturnDate
      //               : e?.exchangeDate
      //           );

      //           let selectedDateParts = endDate?.split("/");
      //           let dateFromParts = startDate?.split("/");

      //           let selectedDateTime = new Date(
      //             parseInt(selectedDateParts[2]), // Year
      //             parseInt(selectedDateParts[1]), // Month (zero-based)
      //             parseInt(selectedDateParts[0]), // Day
      //             23, // Hours
      //             59, // Minutes
      //             59 // Seconds
      //           );

      //           let dateFromTime = new Date(
      //             parseInt(dateFromParts[2]), // Year
      //             parseInt(dateFromParts[1]), // Month (zero-based)
      //             parseInt(dateFromParts[0]), // Day
      //             0, // Hours
      //             0, // Minutes
      //             0 // Seconds
      //           );

      //           return addDate >= dateFromTime && addDate <= selectedDateTime;
      //         });

      //       let sortData =
      //         filteredData &&
      //         filteredData?.length > 0 &&
      //         filteredData?.sort((a, b) => {
      //           return (
      //             new Date(
      //               a?.saleDate
      //                 ? a?.saleDate
      //                 : a?.saleReturnDate
      //                 ? a?.saleReturnDate
      //                 : a?.exchangeDate
      //             ).getTime() -
      //             new Date(
      //               b?.saleDate
      //                 ? b?.saleDate
      //                 : b?.saleReturnDate
      //                 ? b?.saleReturnDate
      //                 : b?.exchangeDate
      //             ).getTime()
      //           );
      //         });

      //       setCustomerProductsSale(sortData);

      //       setPdfDownloadView({
      //         ...pdfDownloadView,
      //         customerSpecificProductSaleReport: true,
      //       });
      //       setPdfOpenViewState({
      //       ...pdfOpenViewState,
      //         customerSpecificProductSaleReport: true,
      //       });
      //       setLoading(false);

      //       return;
      //     }

      //     let selectedProducts =
      //       data &&
      //       data?.length > 0 &&
      //       data?.filter((e, i) => {
      //         let { productDetails } = e;

      //         let { returnProductDetails } = e;

      //         let selectedProductData =
      //           productDetails &&
      //           productDetails?.length > 0 &&
      //           productDetails?.filter((j) => {
      //             if (j?.barcode == selectedProduct?.barcode) {
      //               return j;
      //             }
      //           });

      //         let selectedReturnProductData =
      //           returnProductDetails &&
      //           returnProductDetails?.length > 0 &&
      //           returnProductDetails?.filter((j) => {
      //             if (j?.barcode == selectedProduct?.barcode) {
      //               return j;
      //             }
      //           });

      //         e.productDetails = selectedProductData;
      //         e.returnProductDetails = selectedReturnProductData;

      //         if (
      //           (e?.productDetails && e?.productDetails?.length > 0) ||
      //           (e?.returnProductDetails && e?.returnProductDetails?.length > 0)
      //         ) {
      //           return e;
      //         }
      //       });

      //     let sortData =
      //       selectedProducts &&
      //       selectedProducts?.length > 0 &&
      //       selectedProducts?.sort((a, b) => {
      //         return (
      //           new Date(
      //             a?.saleDate
      //               ? a?.saleDate
      //               : a?.saleReturnDate
      //               ? a?.saleReturnDate
      //               : a?.exchangeDate
      //           ).getTime() -
      //           new Date(
      //             b?.saleDate
      //               ? b?.saleDate
      //               : b?.saleReturnDate
      //               ? b?.saleReturnDate
      //               : b?.exchangeDate
      //           ).getTime()
      //         );
      //       });

      //     setCustomerProductsSale(
      //       sortData && sortData?.length > 0 ? sortData : []
      //     );

      //     setPdfDownloadView({
      //       ...pdfDownloadView,
      //       customerSpecificProductSaleReport: true,
      //     });
      //      setPdfOpenViewState({
      //       ...pdfOpenViewState,
      //       customerSpecificProductSaleReport: true,
      //     });
      //     setLoading(false);
      //   })
      //   .catch((error) => {
      //     message.info(error?.message);
      //   });
    } else if (
      selectedReportType?.toLowerCase() ==
      "product sales report (selected dates)"
    ) {
      if (!selectedProduct) {
        message.info("Kindly Select Product");
        return;
      }

      if (!startDate) {
        message.info("Start Date is missing");
        return;
      }

      if (!endDate) {
        message.info("End Date is missing");
        return;
      }

      setLoading(true);

      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      try {
        let datas = await sessionStorage.getItem("userData");
        datas = JSON.parse(datas);
        let token = datas;

        let qu = {};
        if (startDate && endDate) {
          qu.startDate = startDate;
          qu.endDate = endDate;
        }
        let res = await fetchPaginatedDataWithQuery(
          `${Base_Uri}getAllTypesInvoices`,
          token,
          {
            // CustomerId:selectedCustomer?.id,
            ...qu,
            byBarcode: selectedProduct?.barcode,
          }
        );
        if (!res?.status) {
          setLoading(false);
          message.info(res.message);
          return;
        }

        let { data } = res;

        setProductSaleData(data && data?.length > 0 ? data : []);

        setPdfDownloadView({
          ...pdfDownloadView,
          productSaleReportForSelectedDates: true,
        });
        setPdfOpenViewState({
          ...pdfOpenViewState,
          productSaleReportForSelectedDates: true,
        });
        setLoading(false);
      } catch (error) {
        message.info(error?.message);
      }

      axios
        .get(`${Base_Uri}get-all-type-invoice`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then(async (res) => {
          if (!res?.status) {
            setLoading(false);
            message.info(res.message);
            return;
          }

          let { data } = res.data;

          let selectedProducts =
            data &&
            data?.length > 0 &&
            data?.filter((e, i) => {
              let { productDetails } = e;

              let { returnProductDetails } = e;

              let selectedProductData =
                productDetails &&
                productDetails?.length > 0 &&
                productDetails?.filter((j) => {
                  if (j?.barcode == selectedProduct?.barcode) {
                    return j;
                  }
                });

              let selectedReturnProductData =
                returnProductDetails &&
                returnProductDetails?.length > 0 &&
                returnProductDetails?.filter((j) => {
                  if (j?.barcode == selectedProduct?.barcode) {
                    return j;
                  }
                });

              e.productDetails = selectedProductData;
              e.returnProductDetails = selectedReturnProductData;

              if (
                (e?.productDetails && e?.productDetails?.length > 0) ||
                (e?.returnProductDetails && e?.returnProductDetails?.length > 0)
              ) {
                return e;
              }
            });

          let filteredData =
            selectedProducts &&
            selectedProducts?.length > 0 &&
            selectedProducts?.filter((e, i) => {
              let date = e?.saleDate
                ? e?.saleDate
                : e?.saleReturnDate
                ? e?.saleReturnDate
                : e?.exchangeDate;

              let addDate = new Date(date);

              // Parse selectedDate and dateFrom
              let selectedDateParts = endDate?.split("/");
              let dateFromParts = startDate?.split("/");

              // Create Date objects from the parsed components
              let selectedDateTime = new Date(
                parseInt(selectedDateParts[2]), // Year
                parseInt(selectedDateParts[1]), // Month (zero-based)
                parseInt(selectedDateParts[0]), // Day
                23, // Hours
                59, // Minutes
                59 // Seconds
              );

              let dateFromTime = new Date(
                parseInt(dateFromParts[2]), // Year
                parseInt(dateFromParts[1]), // Month (zero-based)
                parseInt(dateFromParts[0]), // Day
                0, // Hours
                0, // Minutes
                0 // Seconds
              );

              // Check if addDate is between dateFrom and selectedDate
              return addDate >= dateFromTime && addDate <= selectedDateTime;
            });

          let sortData =
            filteredData &&
            filteredData?.length > 0 &&
            filteredData?.sort((a, b) => {
              return (
                new Date(
                  a?.saleDate
                    ? a?.saleDate
                    : a?.saleReturnDate
                    ? a?.saleReturnDate
                    : a?.exchangeDate
                ).getTime() -
                new Date(
                  b?.saleDate
                    ? b?.saleDate
                    : b?.saleReturnDate
                    ? b?.saleReturnDate
                    : b?.exchangeDate
                ).getTime()
              );
            });

          setProductSaleData(sortData && sortData?.length > 0 ? sortData : []);

          setPdfDownloadView({
            ...pdfDownloadView,
            productSaleReportForSelectedDates: true,
          });
          setPdfOpenViewState({
            ...pdfOpenViewState,
            productSaleReportForSelectedDates: true,
          });

          setLoading(false);
        })
        .catch((error) => {
          message.info(error?.message);
          console.log(error, "error");
        });
    } else if (selectedReportType?.toLowerCase() == "top 1000 best-selling products") {
      setLoading(true);

      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
      //console.log(new Date(startDate), "d");
     

      axios
        .get(
          `${Base_Uri}get-all-type-invoice?startDate=${startDate||""}&endDate=${endDate||""}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // Include other headers as needed
            },
          }
        )
        .then(async (res) => {
          if (!res?.status) {
            setLoading(false);
            message.info(res.message);
            return;
          }

          let { data } = res.data;

          let productWiseData = [];

          data &&
            data?.length > 0 &&
            data?.forEach((e, i) => {
              e?.productDetails &&
                e?.productDetails?.length > 0 &&
                e?.productDetails?.map((product, i) => {
                  if (e?.saleReturnDate) {
                    if (
                      productWiseData &&
                      productWiseData?.length > 0 &&
                      productWiseData?.some(
                        (j) => j.barcode == product?.barcode
                      )
                    ) {
                      productWiseData?.map((change) => {
                        if (change.barcode == product?.barcode) {
                          return {
                            ...change,
                            qty: (change.qty -= product?.DamageQty
                              ? product?.DamageQty
                              : product?.saleQty),
                            totalAmount: (change.totalAmount -=
                              (product?.DamageQty
                                ? product?.DamageQty
                                : product?.saleQty) *
                              (product?.discountPrice
                                ? product?.discountPrice
                                : e?.customerDetails?.[0]?.priceLevel?.[0]
                                    ?.id == 1
                                ? product?.trade_price
                                : e?.customerDetails?.[0]?.priceLevel?.[0]
                                    ?.id == 2
                                ? product?.warehouse_price
                                : product?.retail_price)),
                          };
                        } else {
                          return change;
                        }
                      });
                    } else {
                      if (e?.saleReturnDate) {
                        product.qty = -(product.DamageQty
                          ? product.DamageQty
                          : product.saleQty);
                        product.totalAmount = -(
                          (product?.DamageQty
                            ? product?.DamageQty
                            : product?.saleQty) *
                          (product?.discountPrice
                            ? product?.discountPrice
                            : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                            ? product?.trade_price
                            : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                            ? product?.warehouse_price
                            : product?.retail_price)
                        );

                        productWiseData?.push(product);
                        return;
                      }
                      product.qty = product.DamageQty
                        ? product.DamageQty
                        : product.saleQty;
                      product.totalAmount =
                        (product?.DamageQty
                          ? product?.DamageQty
                          : product?.saleQty) *
                        (product?.discountPrice
                          ? product?.discountPrice
                          : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                          ? product?.trade_price
                          : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                          ? product?.warehouse_price
                          : product?.retail_price);

                      productWiseData?.push(product);
                    }
                  } else {
                    if (
                      productWiseData &&
                      productWiseData?.length > 0 &&
                      productWiseData?.some(
                        (j) => j.barcode == product?.barcode
                      )
                    ) {
                      productWiseData?.map((change) => {
                        if (change.barcode == product?.barcode) {
                          return {
                            ...change,
                            qty: (change.qty += product?.DamageQty
                              ? product?.DamageQty
                              : product?.saleQty),
                            totalAmount: (change.totalAmount +=
                              (product?.DamageQty
                                ? product?.DamageQty
                                : product?.saleQty) *
                              (product?.discountPrice
                                ? product?.discountPrice
                                : e?.customerDetails?.[0]?.priceLevel?.[0]
                                    ?.id == 1
                                ? product?.trade_price
                                : e?.customerDetails?.[0]?.priceLevel?.[0]
                                    ?.id == 2
                                ? product?.warehouse_price
                                : product?.retail_price)),
                          };
                        } else {
                          return change;
                        }
                      });
                    } else {
                      if (e?.saleReturnDate) {
                        product.qty = -(product?.DamageQty
                          ? product?.DamageQty
                          : product?.saleQty);
                        product.totalAmount = -(
                          (product?.DamageQty
                            ? product?.DamageQty
                            : product?.saleQty) *
                          (product?.discountPrice
                            ? product?.discountPrice
                            : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                            ? product?.trade_price
                            : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                            ? product?.warehouse_price
                            : product?.retail_price)
                        );

                        productWiseData?.push(product);
                        return;
                      }
                      product.qty = product?.DamageQty
                        ? product?.DamageQty
                        : product?.saleQty;
                      product.totalAmount =
                        (product?.DamageQty
                          ? product?.DamageQty
                          : product?.saleQty) *
                        (product?.discountPrice
                          ? product?.discountPrice
                          : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                          ? product?.trade_price
                          : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                          ? product?.warehouse_price
                          : product?.retail_price);

                      productWiseData?.push(product);
                    }
                  }
                });

              e?.returnProductDetails &&
                e?.returnProductDetails?.length > 0 &&
                e?.returnProductDetails?.map((product, i) => {
                  if (
                    productWiseData &&
                    productWiseData?.length > 0 &&
                    productWiseData?.some((j) => j.barcode == product?.barcode)
                  ) {
                    productWiseData?.map((change) => {
                      if (change.barcode == product?.barcode) {
                        return {
                          ...change,
                          qty: (change.qty -= product?.DamageQty
                            ? product?.DamageQty
                            : product?.saleQty),
                          totalAmount: (change.totalAmount +=
                            (product?.DamageQty
                              ? product?.DamageQty
                              : product?.saleQty) *
                            (product?.discountPrice
                              ? product?.discountPrice
                              : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
                                1
                              ? product?.trade_price
                              : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
                                2
                              ? product?.warehouse_price
                              : product?.retail_price)),
                        };
                      } else {
                        return change;
                      }
                    });
                  } else {
                    product.qty = -(product?.DamageQty
                      ? product?.DamageQty
                      : product?.saleQty);
                    product.totalAmount = -(
                      (product?.DamageQty
                        ? product?.DamageQty
                        : product?.saleQty) *
                      (product?.discountPrice
                        ? product?.discountPrice
                        : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                        ? product?.trade_price
                        : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                        ? product?.warehouse_price
                        : product?.retail_price)
                    );
                    productWiseData?.push(product);
                    return;
                  }
                });
            });

          productWiseData =
            productWiseData &&
            productWiseData?.length > 0 &&
            productWiseData?.filter((e) => {
              return Number(e?.qty) > 0;
            });

          let sortData =
            productWiseData &&
            productWiseData?.length > 0 &&
            productWiseData?.sort((a, b) => {
              return b.qty - a?.qty;
            });

          sortData.length = 1000;

          setProductSaleData(sortData && sortData?.length > 0 ? sortData : []);

          setPdfDownloadView({
            ...pdfDownloadView,
            bestSellerTop100: true,
          });
          setPdfOpenViewState({
            ...pdfOpenViewState,
            bestSellerTop100: true,
          });

          setLoading(false);
        })
        .catch((error) => {
          message.info(error?.message);
          //console.log(error, "error");
        });
    } else if (
      selectedReportType?.toLowerCase() == "sales report by department"
    ) {
      if (searchDate?.selected && !startDate) {
        message.info("Start Date is missing");
        return;
      }

      if (searchDate?.selected && !endDate) {
        message.info("End Date is missing");
        return;
      }

      setLoading(true);
      try {
        let datas = await sessionStorage.getItem("userData");
        datas = JSON.parse(datas);
        let token = datas;
        let qu = {};
        if (searchDate?.selected && startDate && endDate) {
          qu.startDate = startDate;
          qu.endDate = endDate;
        }
        let res = await fetchPaginatedDataWithQuery(
          `${Base_Uri}getAllTypesInvoices`,
          token,
          qu
        );
        if (!res?.status) {
          setLoading(false);
          message.info(res.message);
          return;
        }

        let { data } = res;

        let allInvoices = [...data];
        let productWiseData = [];

        allInvoices &&
          allInvoices?.length > 0 &&
          allInvoices?.forEach((e, i) => {
            e?.productDetails &&
              e?.productDetails?.length > 0 &&
              e?.productDetails?.map((product, i) => {
                if (e?.saleReturnDate) {
                  if (
                    productWiseData &&
                    productWiseData?.length > 0 &&
                    productWiseData?.some(
                      (j) => j.department == product?.department
                    )
                  ) {
                    productWiseData?.map((change) => {
                      if (change.department == product?.department) {
                        return {
                          ...change,
                          qty: (change.qty -= product?.DamageQty
                            ? product?.DamageQty
                            : product?.saleQty),
                          totalAmount: (change.totalAmount -=
                            (product?.DamageQty
                              ? product?.DamageQty
                              : product?.saleQty) *
                            (product?.discountPrice
                              ? product?.discountPrice
                              : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
                                1
                              ? product?.trade_price
                              : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
                                2
                              ? product?.warehouse_price
                              : product?.retail_price)),
                        };
                      } else {
                        return change;
                      }
                    });
                  } else {
                    if (e?.saleReturnDate) {
                      product.qty = -(product.DamageQty
                        ? product.DamageQty
                        : product.saleQty);
                      product.totalAmount = -(
                        (product?.DamageQty
                          ? product?.DamageQty
                          : product?.saleQty) *
                        (product?.discountPrice
                          ? product?.discountPrice
                          : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                          ? product?.trade_price
                          : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                          ? product?.warehouse_price
                          : product?.retail_price)
                      );

                      productWiseData?.push(product);
                      return;
                    }
                    product.qty = product.DamageQty
                      ? product.DamageQty
                      : product.saleQty;
                    product.totalAmount =
                      (product?.DamageQty
                        ? product?.DamageQty
                        : product?.saleQty) *
                      (product?.discountPrice
                        ? product?.discountPrice
                        : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                        ? product?.trade_price
                        : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                        ? product?.warehouse_price
                        : product?.retail_price);

                    productWiseData?.push(product);
                  }
                } else {
                  if (
                    productWiseData &&
                    productWiseData?.length > 0 &&
                    productWiseData?.some(
                      (j) => j.department == product?.department
                    )
                  ) {
                    productWiseData?.map((change) => {
                      if (change.department == product?.department) {
                        return {
                          ...change,
                          qty: (change.qty += product?.DamageQty
                            ? product?.DamageQty
                            : product?.saleQty),
                          totalAmount: (change.totalAmount +=
                            (product?.DamageQty
                              ? product?.DamageQty
                              : product?.saleQty) *
                            (product?.discountPrice
                              ? product?.discountPrice
                              : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
                                1
                              ? product?.trade_price
                              : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
                                2
                              ? product?.warehouse_price
                              : product?.retail_price)),
                        };
                      } else {
                        return change;
                      }
                    });
                  } else {
                    if (e?.saleReturnDate) {
                      product.qty = -(product?.DamageQty
                        ? product?.DamageQty
                        : product?.saleQty);
                      product.totalAmount = -(
                        (product?.DamageQty
                          ? product?.DamageQty
                          : product?.saleQty) *
                        (product?.discountPrice
                          ? product?.discountPrice
                          : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                          ? product?.trade_price
                          : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                          ? product?.warehouse_price
                          : product?.retail_price)
                      );

                      productWiseData?.push(product);
                      return;
                    }
                    product.qty = product?.DamageQty
                      ? product?.DamageQty
                      : product?.saleQty;
                    product.totalAmount =
                      (product?.DamageQty
                        ? product?.DamageQty
                        : product?.saleQty) *
                      (product?.discountPrice
                        ? product?.discountPrice
                        : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                        ? product?.trade_price
                        : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                        ? product?.warehouse_price
                        : product?.retail_price);

                    productWiseData?.push(product);
                  }
                }
              });

            e?.returnProductDetails &&
              e?.returnProductDetails?.length > 0 &&
              e?.returnProductDetails?.map((product, i) => {
                if (
                  productWiseData &&
                  productWiseData?.length > 0 &&
                  productWiseData?.some(
                    (j) => j.department == product?.department
                  )
                ) {
                  productWiseData?.map((change) => {
                    if (change.department == product?.department) {
                      return {
                        ...change,
                        qty: (change.qty -= product?.DamageQty
                          ? product?.DamageQty
                          : product?.saleQty),
                        totalAmount: (change.totalAmount +=
                          (product?.DamageQty
                            ? product?.DamageQty
                            : product?.saleQty) *
                          (product?.discountPrice
                            ? product?.discountPrice
                            : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                            ? product?.trade_price
                            : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                            ? product?.warehouse_price
                            : product?.retail_price)),
                      };
                    } else {
                      return change;
                    }
                  });
                } else {
                  product.qty = -(product?.DamageQty
                    ? product?.DamageQty
                    : product?.saleQty);
                  product.totalAmount = -(
                    (product?.DamageQty
                      ? product?.DamageQty
                      : product?.saleQty) *
                    (product?.discountPrice
                      ? product?.discountPrice
                      : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
                      ? product?.trade_price
                      : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
                      ? product?.warehouse_price
                      : product?.retail_price)
                  );
                  productWiseData?.push(product);
                  return;
                }
              });
          });

        productWiseData =
          productWiseData &&
          productWiseData?.length > 0 &&
          productWiseData?.filter((e) => {
            return Number(e?.qty) > 0;
          });

        let sortData =
          productWiseData &&
          productWiseData?.length > 0 &&
          productWiseData?.sort((a, b) => {
            return b.qty - a?.qty;
          });

        setProductSaleData(sortData && sortData?.length > 0 ? sortData : []);

        setPdfDownloadView({
          ...pdfDownloadView,
          saleReportByDepartment: true,
        });
        setPdfOpenViewState({
          ...pdfOpenViewState,
          saleReportByDepartment: true,
        });

        setLoading(false);
      } catch (error) {
        message.info(error?.message);
        //console.log(error, "error");
      }
      //       let data = await sessionStorage.getItem("userData");
      //       data = JSON.parse(data);
      //       let token = data;

      //       axios
      //         .get(`${Base_Uri}get-all-type-invoice`, {
      //           headers: {
      //             Authorization: `Bearer ${token}`,
      //             "Content-Type": "application/json", // Include other headers as needed
      //           },
      //         })
      //         .then(async (res) => {
      //           if (!res?.status) {
      //             setLoading(false);
      //             message.info(res.message);
      //             return;
      //           }

      //           let { data } = res.data;

      //           let allInvoices = [...data];

      //           if (searchDate?.selected && startDate && endDate) {
      //             let filteredData =
      //               data &&
      //               data?.length > 0 &&
      //               data?.filter((e, i) => {
      //                 let date = e?.saleDate
      //                   ? e?.saleDate
      //                   : e?.saleReturnDate
      //                   ? e?.saleReturnDate
      //                   : e?.exchangeDate;

      //                 let addDate = new Date(date);

      //                 // Parse selectedDate and dateFrom
      //                 let selectedDateParts = endDate?.split("/");
      //                 let dateFromParts = startDate?.split("/");

      //                 // Create Date objects from the parsed components
      //                 let selectedDateTime = new Date(
      //                   parseInt(selectedDateParts[2]), // Year
      //                   parseInt(selectedDateParts[1]), // Month (zero-based)
      //                   parseInt(selectedDateParts[0]), // Day
      //                   23, // Hours
      //                   59, // Minutes
      //                   59 // Seconds
      //                 );

      //                 let dateFromTime = new Date(
      //                   parseInt(dateFromParts[2]), // Year
      //                   parseInt(dateFromParts[1]), // Month (zero-based)
      //                   parseInt(dateFromParts[0]), // Day
      //                   0, // Hours
      //                   0, // Minutes
      //                   0 // Seconds
      //                 );

      //                 // Check if addDate is between dateFrom and selectedDate
      //                 return addDate >= dateFromTime && addDate <= selectedDateTime;
      //               });

      //             allInvoices = filteredData;
      //           }

      //           let productWiseData = [];

      //           allInvoices &&
      //             allInvoices?.length > 0 &&
      //             allInvoices?.forEach((e, i) => {
      //               e?.productDetails &&
      //                 e?.productDetails?.length > 0 &&
      //                 e?.productDetails?.map((product, i) => {
      //                   if (e?.saleReturnDate) {
      //                     if (
      //                       productWiseData &&
      //                       productWiseData?.length > 0 &&
      //                       productWiseData?.some(
      //                         (j) => j.department == product?.department
      //                       )
      //                     ) {
      //                       productWiseData?.map((change) => {
      //                         if (change.department == product?.department) {
      //                           return {
      //                             ...change,
      //                             qty: (change.qty -= product?.DamageQty
      //                               ? product?.DamageQty
      //                               : product?.saleQty),
      //                             totalAmount: (change.totalAmount -=
      //                               (product?.DamageQty
      //                                 ? product?.DamageQty
      //                                 : product?.saleQty) *
      //                               (product?.discountPrice
      //                                 ? product?.discountPrice
      //                                 : e?.customerDetails?.[0]?.priceLevel?.[0]
      //                                     ?.id == 1
      //                                 ? product?.trade_price
      //                                 : e?.customerDetails?.[0]?.priceLevel?.[0]
      //                                     ?.id == 2
      //                                 ? product?.warehouse_price
      //                                 : product?.retail_price)),
      //                           };
      //                         } else {
      //                           return change;
      //                         }
      //                       });
      //                     } else {
      //                       if (e?.saleReturnDate) {
      //                         product.qty = -(product.DamageQty
      //                           ? product.DamageQty
      //                           : product.saleQty);
      //                         product.totalAmount = -(
      //                           (product?.DamageQty
      //                             ? product?.DamageQty
      //                             : product?.saleQty) *
      //                           (product?.discountPrice
      //                             ? product?.discountPrice
      //                             : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
      //                             ? product?.trade_price
      //                             : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
      //                             ? product?.warehouse_price
      //                             : product?.retail_price)
      //                         );

      //                         productWiseData?.push(product);
      //                         return;
      //                       }
      //                       product.qty = product.DamageQty
      //                         ? product.DamageQty
      //                         : product.saleQty;
      //                       product.totalAmount =
      //                         (product?.DamageQty
      //                           ? product?.DamageQty
      //                           : product?.saleQty) *
      //                         (product?.discountPrice
      //                           ? product?.discountPrice
      //                           : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
      //                           ? product?.trade_price
      //                           : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
      //                           ? product?.warehouse_price
      //                           : product?.retail_price);

      //                       productWiseData?.push(product);
      //                     }
      //                   } else {
      //                     if (
      //                       productWiseData &&
      //                       productWiseData?.length > 0 &&
      //                       productWiseData?.some(
      //                         (j) => j.department == product?.department
      //                       )
      //                     ) {
      //                       productWiseData?.map((change) => {
      //                         if (change.department == product?.department) {
      //                           return {
      //                             ...change,
      //                             qty: (change.qty += product?.DamageQty
      //                               ? product?.DamageQty
      //                               : product?.saleQty),
      //                             totalAmount: (change.totalAmount +=
      //                               (product?.DamageQty
      //                                 ? product?.DamageQty
      //                                 : product?.saleQty) *
      //                               (product?.discountPrice
      //                                 ? product?.discountPrice
      //                                 : e?.customerDetails?.[0]?.priceLevel?.[0]
      //                                     ?.id == 1
      //                                 ? product?.trade_price
      //                                 : e?.customerDetails?.[0]?.priceLevel?.[0]
      //                                     ?.id == 2
      //                                 ? product?.warehouse_price
      //                                 : product?.retail_price)),
      //                           };
      //                         } else {
      //                           return change;
      //                         }
      //                       });
      //                     } else {
      //                       if (e?.saleReturnDate) {
      //                         product.qty = -(product?.DamageQty
      //                           ? product?.DamageQty
      //                           : product?.saleQty);
      //                         product.totalAmount = -(
      //                           (product?.DamageQty
      //                             ? product?.DamageQty
      //                             : product?.saleQty) *
      //                           (product?.discountPrice
      //                             ? product?.discountPrice
      //                             : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
      //                             ? product?.trade_price
      //                             : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
      //                             ? product?.warehouse_price
      //                             : product?.retail_price)
      //                         );

      //                         productWiseData?.push(product);
      //                         return;
      //                       }
      //                       product.qty = product?.DamageQty
      //                         ? product?.DamageQty
      //                         : product?.saleQty;
      //                       product.totalAmount =
      //                         (product?.DamageQty
      //                           ? product?.DamageQty
      //                           : product?.saleQty) *
      //                         (product?.discountPrice
      //                           ? product?.discountPrice
      //                           : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
      //                           ? product?.trade_price
      //                           : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
      //                           ? product?.warehouse_price
      //                           : product?.retail_price);

      //                       productWiseData?.push(product);
      //                     }
      //                   }
      //                 });

      //               e?.returnProductDetails &&
      //                 e?.returnProductDetails?.length > 0 &&
      //                 e?.returnProductDetails?.map((product, i) => {
      //                   if (
      //                     productWiseData &&
      //                     productWiseData?.length > 0 &&
      //                     productWiseData?.some(
      //                       (j) => j.department == product?.department
      //                     )
      //                   ) {
      //                     productWiseData?.map((change) => {
      //                       if (change.department == product?.department) {
      //                         return {
      //                           ...change,
      //                           qty: (change.qty -= product?.DamageQty
      //                             ? product?.DamageQty
      //                             : product?.saleQty),
      //                           totalAmount: (change.totalAmount +=
      //                             (product?.DamageQty
      //                               ? product?.DamageQty
      //                               : product?.saleQty) *
      //                             (product?.discountPrice
      //                               ? product?.discountPrice
      //                               : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
      //                                 1
      //                               ? product?.trade_price
      //                               : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
      //                                 2
      //                               ? product?.warehouse_price
      //                               : product?.retail_price)),
      //                         };
      //                       } else {
      //                         return change;
      //                       }
      //                     });
      //                   } else {
      //                     product.qty = -(product?.DamageQty
      //                       ? product?.DamageQty
      //                       : product?.saleQty);
      //                     product.totalAmount = -(
      //                       (product?.DamageQty
      //                         ? product?.DamageQty
      //                         : product?.saleQty) *
      //                       (product?.discountPrice
      //                         ? product?.discountPrice
      //                         : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
      //                         ? product?.trade_price
      //                         : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
      //                         ? product?.warehouse_price
      //                         : product?.retail_price)
      //                     );
      //                     productWiseData?.push(product);
      //                     return;
      //                   }
      //                 });
      //             });

      //           productWiseData =
      //             productWiseData &&
      //             productWiseData?.length > 0 &&
      //             productWiseData?.filter((e) => {
      //               return Number(e?.qty) > 0;
      //             });

      //           let sortData =
      //             productWiseData &&
      //             productWiseData?.length > 0 &&
      //             productWiseData?.sort((a, b) => {
      //               return b.qty - a?.qty;
      //             });

      //           setProductSaleData(sortData && sortData?.length > 0 ? sortData : []);

      //           setPdfDownloadView({
      //             ...pdfDownloadView,
      //             saleReportByDepartment: true,
      //           });
      //            setPdfOpenViewState({
      //             ...pdfOpenViewState,
      //             saleReportByDepartment: true,
      //           });

      //           setLoading(false);
      //         })
      //         .catch((error) => {
      //           message.info(error?.message);
      //           //console.log(error, "error");
      //         });
    } else if (selectedReportType?.toLowerCase() == "department summary report") {
      if (!startDate) {
        message.info("Start Date is missing");
        return;
      }

      if (!endDate) {
        message.info("End Date is missing");
        return;
      }
      if (!selectDeparment) {
        message.info("Deparment name is missing");
        return;
      }

      setLoading(true);

      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
      let selectedDateParts = endDate?.split("/");
      let dateFromParts = startDate?.split("/");
      let selectedDateTime = new Date(
        parseInt(selectedDateParts[2]), // Year
        parseInt(selectedDateParts[1]), // Month (zero-based)
        parseInt(selectedDateParts[0]), // Day
        23, // Hours
        59, // Minutes
        59 // Seconds
      );

      let dateFromTime = new Date(
        parseInt(dateFromParts[2]), // Year
        parseInt(dateFromParts[1]), // Month (zero-based)
        parseInt(dateFromParts[0]), // Day
        0, // Hours
        0, // Minutes
        0 // Seconds
      );

      axios(
        `${Base_Uri}findProductsByDepartment?departmentName=${selectDeparment
          .split(" ")
          .join("_")}&fromDate=${JSON.stringify(
          dateFromTime
        )}&toDate=${JSON.stringify(selectedDateTime)}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
        .then((data) => {
          let ctc = []; //{qty,total_sell_price,profit}
          console.log(data.data.data);
          setAllDeparmentReportsData(
            data.data.data.map((e) => ({
              sku: e?.productDetails?.sku,
              buying_date: moment(e?.productDetails?.created_at).format(
                "DD MMMM YYYY"
              ),
              supplier_details: e?.productDetails.supplier_name,
              model: e?.productDetails?.model,
              IMEI: e?.productDetails?.IMEI,
              qty: e?.productDetails?.saleQty,
              total_cost_price: (
                e?.productDetails?.saleQty * e?.productDetails?.cost_price
              ).toFixed(2),
              buyer_details: e?.customerDetails?.customerName,
              sell_date: moment(e.saleDate).format("DD MMMM YYYY"),
              total_sell_price: (e.productDetails?.discountPrice
                ? e?.productDetails?.saleQty *
                  Number(e.productDetails.discountPrice)
                : e?.customerDetails?.priceLevel[0].id == 3
                ? e?.productDetails?.saleQty * e?.productDetails?.retail_price
                : e?.customerDetails?.priceLevel[0].id == 1
                ? e?.productDetails?.saleQty * e?.productDetails?.trade_price
                : e?.customerDetails?.priceLevel[0].id == 2
                ? e?.productDetails?.saleQty *
                  e?.productDetails?.warehouse_price
                : e?.customerDetails?.priceLevel[0].id == 4
                ? e?.productDetails?.saleQty * e?.productDetails?.diamond
                : e?.productDetails?.saleQty * e.productDetails.cost_price
              ).toFixed(2),
              profit: JSON.stringify(
                (
                  (e.productDetails?.discountPrice
                    ? e?.productDetails?.saleQty *
                      Number(e.productDetails.discountPrice)
                    : e?.customerDetails?.priceLevel[0].id == 3
                    ? e?.productDetails?.saleQty *
                      e?.productDetails?.retail_price
                    : e?.customerDetails?.priceLevel[0].id == 1
                    ? e?.productDetails?.saleQty *
                      e?.productDetails?.trade_price
                    : e?.customerDetails?.priceLevel[0].id == 2
                    ? e?.productDetails?.saleQty *
                      e?.productDetails?.warehouse_price
                    : e?.customerDetails?.priceLevel[0].id == 4
                    ? e?.productDetails?.saleQty * e?.productDetails?.diamond
                    : e?.productDetails?.saleQty *
                      e.productDetails.cost_price) -
                  e?.productDetails?.saleQty * e?.productDetails?.cost_price
                ).toFixed(2)
              ),
            }))
          );
          generateExcel(
            data.data.data.map((e) => ({
              sku: e?.productDetails?.sku,
              buying_date: moment(e?.productDetails?.created_at).format(
                "DD MMMM YYYY"
              ),
              supplier_details: e?.productDetails.supplier_name,
              model: e?.productDetails?.model,
              IMEI:
                typeof e?.productDetails?.IMEI == "string"
                  ? e?.productDetails?.IMEI
                  : e?.productDetails?.IMEI?.map((e) => e)?.join(", "),
              qty: e?.productDetails?.saleQty,
              total_cost_price: (
                e?.productDetails?.saleQty * e?.productDetails?.cost_price
              ).toFixed(2),
              buyer_details: e?.customerDetails?.customerName,
              sell_date: moment(e.saleDate).format("DD MMMM YYYY"),
              total_sell_price: (e.productDetails?.discountPrice
                ? e?.productDetails?.saleQty *
                  Number(e.productDetails.discountPrice)
                : e?.customerDetails?.priceLevel[0].id == 3
                ? e?.productDetails?.saleQty * e?.productDetails?.retail_price
                : e?.customerDetails?.priceLevel[0].id == 1
                ? e?.productDetails?.saleQty * e?.productDetails?.trade_price
                : e?.customerDetails?.priceLevel[0].id == 2
                ? e?.productDetails?.saleQty *
                  e?.productDetails?.warehouse_price
                : e?.customerDetails?.priceLevel[0].id == 4
                ? e?.productDetails?.saleQty * e?.productDetails?.diamond
                : e?.productDetails?.saleQty * e.productDetails.cost_price
              ).toFixed(2),
              profit: (
                (e.productDetails?.discountPrice
                  ? e?.productDetails?.saleQty *
                    Number(e.productDetails.discountPrice)
                  : e?.customerDetails?.priceLevel[0].id == 3
                  ? e?.productDetails?.saleQty * e?.productDetails?.retail_price
                  : e?.customerDetails?.priceLevel[0].id == 1
                  ? e?.productDetails?.saleQty * e?.productDetails?.trade_price
                  : e?.customerDetails?.priceLevel[0].id == 2
                  ? e?.productDetails?.saleQty *
                    e?.productDetails?.warehouse_price
                  : e?.customerDetails?.priceLevel[0].id == 4
                  ? e?.productDetails?.saleQty * e?.productDetails?.diamond
                  : e?.productDetails?.saleQty * e.productDetails.cost_price) -
                e?.productDetails?.saleQty * e?.productDetails?.cost_price
              ).toFixed(2),
            }))
          );
          setLoading(false);
        })
        .catch((err) => {
          //console.log(err);
          setLoading(false);
        });
    } else if (selectedReportType?.toLowerCase() === "customer balance statement") {
      setLoading(true);
      try {
        let data = JSON.parse(await sessionStorage.getItem("userData"));
        let token = data;

        const res = await axios.get(`${Base_Uri}findcustomerdue`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const balancePromises = customers.map(async (e) => {
          const runB = await checkCustomerBalances(e);
          return { ...e, totalToPay: runB };
        });

        const pk = await Promise.all(balancePromises);

        setCustomerDueData(pk);
        setPdfDownloadView((prev) => ({
          ...prev,
          CustomerDueReport: true,
        }));
        setPdfOpenViewState((prev) => ({
          ...prev,
          CustomerDueReport: true,
        }));
      } catch (error) {
        message.info(error?.message);
      } finally {
        setLoading(false);
      }
    }
    else if (
      selectedReportType?.toLowerCase() ==
      "customer report by department / category / subcategory"
    ) {
      //console.log(isCategoryExist,isSubCategoryExist)
      if (!selectedCustomer) {
        message.info("Kindly Select Customer");
        return;
      }

      if (searchDate?.selected && !startDate) {
        message.info("Start Date is missing");
        return;
      }

      if (searchDate?.selected && !endDate) {
        message.info("End Date is missing");
        return;
      }

      setLoading(true);

      try {
        let datas = await sessionStorage.getItem("userData");
        datas = JSON.parse(datas);
        let token = datas;
        let qu = {};
        if (searchDate?.selected && startDate && endDate) {
          qu.startDate = startDate;
          qu.endDate = endDate;
        }
        let deparmentData = await axios.get(`${Base_Uri}getProductDepartment`,{headers:{Authorization:`Bearer ${token}`}})
        let res = await fetchPaginatedDataWithQuery(
          `${Base_Uri}getAllTypesInvoices`,
          token,
          {
            CustomerId: selectedCustomer?.id,
            ...qu,
          }
        );
        if (!res?.status) {
          setLoading(false);
          message.info(res.message);
          return;
        }

        let { data } = res;

        let allInvoices = [...data];
        let productWiseData = [];
const getQty = (product) =>
  product?.DamageQty ? product?.DamageQty : product?.saleQty;

const getPrice = (product, invoice) =>
  product?.discountPrice ??
  (invoice?.customerDetails?.[0]?.priceLevel?.[0]?.id === 1
    ? product?.trade_price
    : invoice?.customerDetails?.[0]?.priceLevel?.[0]?.id === 2
    ? product?.warehouse_price
    : invoice?.customerDetails?.[0]?.priceLevel?.[0]?.id === 4
    ? product?.diamond
    : product?.retail_price);
let result = [];

allInvoices?.forEach((invoice) => {
  const isReturn = !!invoice?.saleReturnDate;

  const handleProduct = (product, isNegative = false) => {
    const qty = getQty(product) * (isNegative ? -1 : 1);
    const amount = qty * getPrice(product, invoice);

    // ===== Department =====
    let dept = result.find((d) => d.department === product.department);

    if (!dept) {
      dept = {
        department: product.department,
        qty: 0,
        totalAmount: 0,
        categories: []
      };
      result.push(dept);
    }

    dept.qty += qty;
    dept.totalAmount += amount;

    // ===== Category (optional) =====
    if (!product?.category) return;

    let cat = dept.categories.find(
      (c) => c.category === product.category
    );

    if (!cat) {
      cat = {
        category: product.category,
        qty: 0,
        totalAmount: 0,
        subcategory: []
      };
      dept.categories.push(cat);
    }

    cat.qty += qty;
    cat.totalAmount += amount;

    // ===== Sub Category (optional) =====
    if (!product?.subcategory) return;

    let sub = cat.subcategory.find(
      (s) => s.subcategory === product.subcategory
    );

    if (!sub) {
      sub = {
        subcategory: product.subcategory,
        qty: 0,
        totalAmount: 0
      };
      cat.subcategory.push(sub);
    }

    sub.qty += qty;
    sub.totalAmount += amount;
  };

  // ===== Sales =====
  invoice?.productDetails?.forEach((product) => {
    handleProduct(product, isReturn);
  });

  // ===== Returns =====
  invoice?.returnProductDetails?.forEach((product) => {
    handleProduct(product, true);
  });
});
        // allInvoices &&
        //   allInvoices?.length > 0 &&
        //   allInvoices?.forEach((e, i) => {
        //     e?.productDetails &&
        //       e?.productDetails?.length > 0 &&
        //       e?.productDetails?.map((product, i) => {
        //         if (e?.saleReturnDate) {
        //           if (
        //             productWiseData &&
        //             productWiseData?.length > 0 &&
        //             productWiseData?.some(
        //               (j) => j.department == product?.department
        //             )
        //           ) {
        //             productWiseData?.map((change) => {
        //               if (change.department == product?.department) {
        //                 return {
        //                   ...change,
        //                   qty: (change.qty -= product?.DamageQty
        //                     ? product?.DamageQty
        //                     : product?.saleQty),
        //                   totalAmount: (change.totalAmount -=
        //                     (product?.DamageQty
        //                       ? product?.DamageQty
        //                       : product?.saleQty) *
        //                     (product?.discountPrice
        //                       ? product?.discountPrice
        //                       : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
        //                         1
        //                       ? product?.trade_price
        //                       : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
        //                         2
        //                       ? product?.warehouse_price
        //                       : product?.retail_price)),
        //                 };
        //               } else {
        //                 return change;
        //               }
        //             });
        //           } else {
        //             if (e?.saleReturnDate) {
        //               product.qty = -(product.DamageQty
        //                 ? product.DamageQty
        //                 : product.saleQty);
        //               product.totalAmount = -(
        //                 (product?.DamageQty
        //                   ? product?.DamageQty
        //                   : product?.saleQty) *
        //                 (product?.discountPrice
        //                   ? product?.discountPrice
        //                   : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
        //                   ? product?.trade_price
        //                   : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
        //                   ? product?.warehouse_price
        //                   : product?.retail_price)
        //               );

        //               productWiseData?.push(product);
        //               return;
        //             }
        //             product.qty = product.DamageQty
        //               ? product.DamageQty
        //               : product.saleQty;
        //             product.totalAmount =
        //               (product?.DamageQty
        //                 ? product?.DamageQty
        //                 : product?.saleQty) *
        //               (product?.discountPrice
        //                 ? product?.discountPrice
        //                 : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
        //                 ? product?.trade_price
        //                 : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
        //                 ? product?.warehouse_price
        //                 : product?.retail_price);

        //             productWiseData?.push(product);
        //           }
        //         } else {
        //           if (
        //             productWiseData &&
        //             productWiseData?.length > 0 &&
        //             productWiseData?.some(
        //               (j) => j.department == product?.department
        //             )
        //           ) {
        //             productWiseData?.map((change) => {
        //               if (change.department == product?.department) {
        //                 return {
        //                   ...change,
        //                   qty: (change.qty += product?.DamageQty
        //                     ? product?.DamageQty
        //                     : product?.saleQty),
        //                   totalAmount: (change.totalAmount +=
        //                     (product?.DamageQty
        //                       ? product?.DamageQty
        //                       : product?.saleQty) *
        //                     (product?.discountPrice
        //                       ? product?.discountPrice
        //                       : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
        //                         1
        //                       ? product?.trade_price
        //                       : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
        //                         2
        //                       ? product?.warehouse_price
        //                       : e?.customerDetails?.[0]?.priceLevel?.[0]?.id ==
        //                         4
        //                       ? product?.diamond
        //                       : product?.retail_price)),
        //                 };
        //               } else {
        //                 return change;
        //               }
        //             });
        //           } else {
        //             if (e?.saleReturnDate) {
        //               product.qty = -(product?.DamageQty
        //                 ? product?.DamageQty
        //                 : product?.saleQty);
        //               product.totalAmount = -(
        //                 (product?.DamageQty
        //                   ? product?.DamageQty
        //                   : product?.saleQty) *
        //                 (product?.discountPrice
        //                   ? product?.discountPrice
        //                   : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
        //                   ? product?.trade_price
        //                   : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
        //                   ? product?.warehouse_price
        //                   : product?.retail_price)
        //               );

        //               productWiseData?.push(product);
        //               return;
        //             }
        //             product.qty = product?.DamageQty
        //               ? product?.DamageQty
        //               : product?.saleQty;
        //             product.totalAmount =
        //               (product?.DamageQty
        //                 ? product?.DamageQty
        //                 : product?.saleQty) *
        //               (product?.discountPrice
        //                 ? product?.discountPrice
        //                 : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
        //                 ? product?.trade_price
        //                 : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
        //                 ? product?.warehouse_price
        //                 : product?.retail_price);

        //             productWiseData?.push(product);
        //           }
        //         }
        //       });

        //     e?.returnProductDetails &&
        //       e?.returnProductDetails?.length > 0 &&
        //       e?.returnProductDetails?.map((product, i) => {
        //         if (
        //           productWiseData &&
        //           productWiseData?.length > 0 &&
        //           productWiseData?.some(
        //             (j) => j.department == product?.department
        //           )
        //         ) {
        //           productWiseData?.map((change) => {
        //             if (change.department == product?.department) {
        //               return {
        //                 ...change,
        //                 qty: (change.qty -= product?.DamageQty
        //                   ? product?.DamageQty
        //                   : product?.saleQty),
        //                 totalAmount: (change.totalAmount +=
        //                   (product?.DamageQty
        //                     ? product?.DamageQty
        //                     : product?.saleQty) *
        //                   (product?.discountPrice
        //                     ? product?.discountPrice
        //                     : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
        //                     ? product?.trade_price
        //                     : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
        //                     ? product?.warehouse_price
        //                     : product?.retail_price)),
        //               };
        //             } else {
        //               return change;
        //             }
        //           });
        //         } else {
        //           product.qty = -(product?.DamageQty
        //             ? product?.DamageQty
        //             : product?.saleQty);
        //           product.totalAmount = -(
        //             (product?.DamageQty
        //               ? product?.DamageQty
        //               : product?.saleQty) *
        //             (product?.discountPrice
        //               ? product?.discountPrice
        //               : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 1
        //               ? product?.trade_price
        //               : e?.customerDetails?.[0]?.priceLevel?.[0]?.id == 2
        //               ? product?.warehouse_price
        //               : product?.retail_price)
        //           );
        //           productWiseData?.push(product);
        //           return;
        //         }
        //       });
        //   });

        productWiseData =
          result &&
          result?.length > 0 &&
          result?.filter((e) => {
            return Number(e?.qty) > 0;
          });

        let sortData =
          result &&
          result?.length > 0 &&
          result?.sort((a, b) => {
            return b.qty - a?.qty;
          });

          //console.log(sortData,"sortData")

        setProductSaleData(sortData && sortData?.length > 0 ? sortData : []);
        setAllDempartment(deparmentData.data.data)
        setPdfDownloadView({
          ...pdfDownloadView,
          CustomerReportwithDeparmentand: true,
        });
        setPdfOpenViewState({
          ...pdfOpenViewState,
          CustomerReportwithDeparmentand: true,
        });
        setLoading(false);
      } catch (error) {
        message.info(error?.message);
      }

    }
  };
  return (
    <Box sx={{ backgroundColor: Colors.white, minHeight: "100vh" }}>
      <Navbar currentPage={"Reports"} />

      <Box style={{ width: "100%", padding: "10px 20px" }}>
        <Box sx={{ marginTop: "20px", width: "100%" }}>
          <Box sx={{ display: "flex", marginTop: 1 }}>
            <Typography
              sx={{
                fontSize: "14px",
                fontFamily: "Poppins",
                mr: 1,
                color: Colors.text,
              }}
            >
              Search By Date
            </Typography>
            <Checkbox
              data={searchDate}
              onClick={() =>
                setSearchDate((prevState) => ({
                  ...prevState,
                  selected: !prevState.selected,
                }))
              }
            />
          </Box>

          <Grid
            container
            xs={12}
            sm={12}
            md={12}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Grid
              item
              xs={12}
              sm={5}
              md={3.5}
              lg={3.4}
              xl={2.9}
              style={{ marginRight: "5px" }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Poppins",
                  mr: 1,
                  color: Colors.text,
                }}
              >
                From
              </Typography>
              <DatePickers
              
                style={{
                  borderRadius: 10,
                  marginTop: { xs: "5px", sm: "0px" },
                }}
                disableFuture={ !( (userData?.role_access?.length > 0 &&
          userData.role_access?.some((role) =>
            role?.subcategory?.some(
              (sub) => sub.name === "Calendar" && sub.selected
            )
          )) || userData?.role === "admin")}
                disablePast={ !( (userData?.role_access?.length > 0 &&
          userData.role_access?.some((role) =>
            role?.subcategory?.some(
              (sub) => sub.name === "Calendar" && sub.selected
            )
          )) || userData?.role === "admin")}
                values={startDate}
                onChange={(e) => setStartDate(e)}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={5}
              md={3.5}
              lg={3.4}
              xl={2.9}
              style={{ marginRight: "5px" }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Poppins",
                  mr: 1,
                  color: Colors.text,
                }}
              >
                To
              </Typography>
              <DatePickers
                style={{
                  borderRadius: 10,
                  marginTop: { xs: "5px", sm: "0px" },
                }}
                 disableFuture={ !( (userData?.role_access?.length > 0 &&
          userData.role_access?.some((role) =>
            role?.subcategory?.some(
              (sub) => sub.name === "Calendar" && sub.selected
            )
          )) || userData?.role === "admin")}
                disablePast={ !( (userData?.role_access?.length > 0 &&
          userData.role_access?.some((role) =>
            role?.subcategory?.some(
              (sub) => sub.name === "Calendar" && sub.selected
            )
          )) || userData?.role === "admin")}
                values={endDate}
                onChange={(e) => setEndDate(e)}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={4.8}
              lg={5}
              xl={6}
              style={{
                marginRight: "5px",
                marginTop: { xs: "5px", sm: "0px" },
              }}
            >
              <BasicSelect
                value={selectedReportType}
                status="Select Report Type"
                id={reportType}
                innerStyle={{
                  fontSize: "14px",
                  border: `0px solid ${Colors.border}`,
                  borderRadius: "5px",
                  fontWeight: "bold",
                  width: "100%",
                  padding: "5px",
                  color: Colors.button,
                }}
                style={{
                  border: `0px solid ${Colors.buttonLight}`,
                  width: "100%",
                  padding: "5px",
                }}
                onChange={(e) => setSelectedReportType(e)}
              />
            </Grid>
          </Grid>
        </Box>

        {selectedReportType?.toLowerCase() == "sales report by user" && (
          <BasicSelect
            value={selectedEmployee}
            status="Select User"
            id={employees.map((e, i) => e?.full_name)}
            innerStyle={{
              fontSize: "14px",
              border: `0px solid ${Colors.border}`,
              borderRadius: "5px",
              fontWeight: "bold",
              width: "100%",
              padding: "5px",
              color: Colors.button,
            }}
            style={{
              border: `0px solid ${Colors.buttonLight}`,
              width: "100%",
              padding: "5px",
              mt: 2,
            }}
            onChange={(e) => setSelectedEmployee(e)}
          />
        )}
        {selectedReportType?.toLowerCase() == "department summary report" && (
          <BasicSelect
            value={selectDeparment}
            status="Select Deparment"
            id={deparments.map((e, i) => e?.departmentName)}
            innerStyle={{
              fontSize: "14px",
              border: `0px solid ${Colors.border}`,
              borderRadius: "5px",
              fontWeight: "bold",
              width: "100%",
              padding: "5px",
              color: Colors.button,
            }}
            style={{
              border: `0px solid ${Colors.buttonLight}`,
              width: "100%",
              padding: "5px",
              mt: 2,
            }}
            onChange={(e) => setSelectDeparment(e)}
          />
        )}
        <Box
          sx={{
            width: "100%",
            marginTop: { xs: "10px", sm: "10px", md: "10px" },
            border: `1px solid ${Colors.button}`,
            borderRadius: "5px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "5px 10px 5px 10px",
            margin: 0,
          }}
        >
          <TextField
            variant="standard" // <== changed this
            margin="normal"
            required
            value={text}
            fullWidth
            inputRef={customerInputRef}
            onChange={(e) => handleSearch(e.target.value)}
            InputProps={{
              disableUnderline: true,
              fontSize: "12px",
            }}
            placeholder={
              selectedSearch == "products"
                ? "Search Products by Name & Bar Code"
                : "Search Customer"
            }
            sx={{
              width: "90%",
              fontSize: "12px",
              padding: 0,
              fontFamily: "Poppins",
              fontWeight: "bold",
              margin: 0,
            }}
          />

          <img
            src={require("../../Images/search.png")}
            style={{ height: "20px" }}
          />
        </Box>

        <Box>
          {searchCustomers && searchCustomers.length > 0
            ? searchCustomers.map((e, i) => {
                return (
                  <Button
                    onClick={() => handleSelectCustomer(e)}
                    sx={{
                      width: "100%",
                      mt: 1,
                      backgroundColor: Colors.white,
                      p: "0px 10px",
                      fontFamily: "Poppins",
                      fontWeight: "bold",
                      borderRadius: 1,
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "flex-start",
                      border: `1px solid ${Colors.border}`,
                    }}
                  >
                    <p style={{ fontFamily: "Poppins", textAlign: "left" }}>
                      {e.businessName}
                    </p>
                  </Button>
                );
              })
            : searchProducts &&
              searchProducts.length > 0 &&
              searchProducts.map((e, i) => {
                return (
                  <Box
                    sx={{
                      width: "100%",
                      mt: 1,
                      backgroundColor: Colors.white,
                      p: "0px 10px",
                      fontFamily: "Poppins",
                      fontWeight: "bold",
                      borderRadius: 1,
                      textAlign: "left",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      border: `1px solid ${Colors.border}`,
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "Poppins",
                        textAlign: "left",
                        marginBottom: 0,
                        color: Colors.button,
                      }}
                    >
                      {e.product_name}
                    </p>

                    <CustomButton
                      text={"Select"}
                      onClick={() => handleSelectProduct(e)}
                      style={{
                        fontFamily: "Poppins",
                        textAlign: "left",
                        marginBottom: "10px",
                        fontSize: 14,
                        // color: "black",
                        borderRadius: 2,
                        width: 250,
                        // border: "none",
                        // justifyContent: "flex-start",
                        // padding: 0,
                        marginTop: "10px",
                        // backgroundColor: "transparent",
                      }}
                    />
                  </Box>
                );
              })}
        </Box>
<ProductTableModal
        visible={open}
        onClose={() => setOpen(false)}
        products={sortDataProducts}
      />
        <Box sx={{ display: "flex", flexDirection: "row", mt: 1 }}>
          <CustomButton
            text="Customers"
            onClick={() => setSelectedSearch("customers")}
            style={{
              width: "120px",
              borderRadius: "5px",

              backgroundColor:
                selectedSearch == "customers" ? Colors.button : Colors.white,
              color:
                selectedSearch == "customers" ? Colors.white : Colors.button,
            }}
          />

          <CustomButton
            text="Products"
            onClick={() => setSelectedSearch("products")}
            style={{
              width: "120px",
              ml: 1,
              borderRadius: "5px",
              backgroundColor:
                selectedSearch == "products" ? Colors.button : Colors.white,
              color:
                selectedSearch == "products" ? Colors.white : Colors.button,
            }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
          {selectedCustomer && (
            <Typography
              sx={{
                fontSize: "18px",
                fontFamily: "Poppins",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              Customer : {selectedCustomer?.businessName}
            </Typography>
          )}
          {selectedProduct && (
            <Typography
              sx={{
                fontSize: "18px",
                fontFamily: "Poppins",
                textAlign: "left",
                fontWeight: "600",
              }}
            >
              Product Name : {selectedProduct?.productName}
            </Typography>
          )}
        </Box>

        {(selectedReportType?.toLowerCase() ==
      "customer report by department / category / subcategory")&&<Box sx={{ mt: 2,display:"flex",gap:10 }}>
        <CustomCheckBox defaultChecked={true} onChange={(e)=>{
          setIsCategoryExist(e.target.checked)

        }} value={isCategoryExist}>Category</CustomCheckBox>
        <CustomCheckBox defaultChecked={true} onChange={(e)=>{
          setIsSubCategoryExist(e.target.checked)
        }} value={isSubCategoryExist}>Sub Category</CustomCheckBox>
        </Box>}

        <Box sx={{ width: "100%", display: "flex", mt: 2 }}>
          <CustomButton
            onClick={() => handleGenerateReports()}
            text={
              loading ? (
                <RingLoader loading={loading} color={"black"} size={30} />
              ) : (
                "Generate Report"
              )
            }
            style={{ width: "200px" }}
          />
          {selectedReportType?.toLowerCase() == "top 1000 best-selling products"&&<CustomButton
            onClick={() => handleGenerateForPurchasedOrder()}
            text={
              loading ? (
                <RingLoader loading={loading} color={"black"} size={30} />
              ) : (
                "Generate For Purchased Order"
              )
            }
            style={{ width: "300px",marginLeft:2 }}
          />}
        </Box>
      </Box>
    </Box>
  );
}

export default Reports;
